 /*
  * kony-sdk-plain-js Version 8.4.2
  */
        
/**
 * Kony namespace
 * @namespace kony
 */
if (typeof(kony) === "undefined") {
    kony = {};
}

/**
 * Constructor for creating the kony client instance.
 * @class
 * @classdesc kony Class
 * @memberof kony
 */
kony.sdk = function() {
    var currentObj = this;
    this.mainRef = {};
    var clientParams = {};
    this.tokens = {};
    this.currentClaimToken = null;
    this.globalRequestParams = {
        "headers":{},
        "queryparams":{},
        "bodyparams":{}
    };
    var userId = "";
    var integrityCustomSecurityKey = null;
    this.reportingheaders_allowed = false;

    if(kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE && typeof(kony.setUserID) === 'function') {
        var userIDflagGet = kony.ds.read("userIDFromLicenseFlag");
        if(kony.sdk.isNullOrUndefined(userIDflagGet)) {
            var userIDflagSet = [];
            userIDflagSet.push("false");
            kony.ds.save(userIDflagSet, "userIDFromLicenseFlag");
        }
    }

    if (kony.internal && kony.internal.sdk && kony.internal.sdk.Services) {
        this.internalSdkObject = new kony.internal.sdk.Services();
    }

    this.getUserId = function() {
        return userId;
    };
    this.setCurrentUserId = function(newUserID) {
        userId = newUserID;
    };
    this.getSessionId = function() {
        if(!konyRef.sessionId) {
            var sessionId = kony.ds.read(kony.sdk.constants.KONYUUID);
            if(sessionId) {
                konyRef.sessionId = sessionId[0];
            } else {
                kony.sdk.logsdk.error("Session id is not available");
                konyRef.sessionId = "";
            }
        }
        return konyRef.sessionId;
    };
    this.setSessionId = function(newSessionId) {
        konyRef.sessionId = newSessionId;
    };
    this.setClientParams = function(clientParamsMap) {
        clientParams = clientParamsMap;
    };

    this.getClientParams = function() {
        return clientParams;
    };

    this.globalRequestParamType = {
        headers:"headers",
        queryParams:"queryparams",
        bodyParams:"bodyparams"
    };

    this.getGlobalRequestParams = function(paramType){
        kony.sdk.logsdk.trace("Entering getGlobalRequestParams");
        if(kony.sdk.isNullOrUndefined(paramType)) {
            return currentObj.globalRequestParams;
        }else if(paramType === currentObj.globalRequestParamType.headers){
            return currentObj.globalRequestParams.headers;
        }else if(paramType === currentObj.globalRequestParamType.queryParams){
            return currentObj.globalRequestParams.queryparams;
        }else if(paramType === currentObj.globalRequestParamType.bodyParams) {
            return currentObj.globalRequestParams.bodyparams;
        }
    };

    this.setGlobalRequestParam = function(paramName, paramValue, paramType){
        kony.sdk.logsdk.trace("Entering setGlobalRequestParam");
        if(typeof(paramName) === 'string' && typeof(paramValue) === 'string' && typeof(paramType) === 'string'){
            if(paramType === currentObj.globalRequestParamType.headers){
                currentObj.globalRequestParams.headers[paramName] = paramValue;
            }else if(paramType === currentObj.globalRequestParamType.queryParams){
                currentObj.globalRequestParams.queryparams[paramName] = paramValue;
            }else if(paramType === currentObj.globalRequestParamType.bodyParams){
                currentObj.globalRequestParams.bodyparams[paramName] = paramValue;
            }
        }
    };

    this.removeGlobalRequestParam = function(paramName, paramType){
        kony.sdk.logsdk.trace("Entering removeGlobalRequestParam");
        if(typeof(paramName) === 'string' && typeof(paramType) === 'string'){
            if(paramType.toLowerCase() === currentObj.globalRequestParamType.headers && !kony.sdk.isNullOrUndefined(currentObj.globalRequestParams.headers[paramName])){
                delete currentObj.globalRequestParams.headers[paramName];
            }else if(paramType.toLowerCase() === currentObj.globalRequestParamType.queryParams && !kony.sdk.isNullOrUndefined(currentObj.globalRequestParams.queryparams[paramName])){
                delete currentObj.globalRequestParams.queryparams[paramName];
            }else if(paramType.toLowerCase() === currentObj.globalRequestParamType.bodyParams && !kony.sdk.isNullOrUndefined(currentObj.globalRequestParams.bodyparams[paramName])){
                delete currentObj.globalRequestParams.bodyparams[paramName];
            }
        }
    };

    this.resetGlobalRequestParams = function(){
        kony.sdk.logsdk.trace("Entering resetGlobalRequestParams");
        currentObj.globalRequestParams = {
            "headers":{},
            "queryparams":{},
            "bodyparams":{}
        };
    };

    this.appendGlobalHeaders = function(headers){
        kony.sdk.logsdk.trace("Entering appendGlobalHeaders");
        var globalHeaders = currentObj.getGlobalRequestParams(currentObj.globalRequestParamType.headers);
        if(!kony.sdk.isNullOrUndefined(globalHeaders)) {
            if (kony.sdk.isNullOrUndefined(headers)) {
                headers = {};
            }
            for (var obj in globalHeaders) {
                if (kony.sdk.isNullOrUndefined(headers[obj])) {
                    headers[obj] = globalHeaders[obj];
                }
            }
        }
    };

    this.appendGlobalBodyParams = function(params){
        kony.sdk.logsdk.trace("Entering appendGlobalBodyParams");
        var globalBodyParams = currentObj.getGlobalRequestParams(currentObj.globalRequestParamType.bodyParams);
        if(!kony.sdk.isNullOrUndefined(globalBodyParams)) {
            if (kony.sdk.isNullOrUndefined(params)) {
                params = {};
            }
            for (var obj in globalBodyParams) {
                if (kony.sdk.isNullOrUndefined(params[obj])) {
                    params[obj] = globalBodyParams[obj];
                }
            }
        }
    };

    this.appendGlobalQueryParams = function(url){
        kony.sdk.logsdk.trace("Entering appendGlobalQueryParams");
        var globalQueryParams = currentObj.getGlobalRequestParams(currentObj.globalRequestParamType.queryParams);
        if(!kony.sdk.isNullOrUndefined(globalQueryParams) && Object.keys(globalQueryParams).length !== 0){
            if(url.indexOf("?") < 0){
                url = url + "?" + kony.sdk.util.objectToQueryParams(globalQueryParams);
            }else{
                url = url + "&" + kony.sdk.util.objectToQueryParams(globalQueryParams);
            }
        }
        return url;
    };

    this.appendGlobalParams = function(url, headers, params){
        kony.sdk.logsdk.trace("Entering appendGlobalParams");
        currentObj.appendGlobalHeaders(headers);
        currentObj.appendGlobalBodyParams(params);
        return currentObj.appendGlobalQueryParams(url);
    };

    this.setAppSecurityKey = function (customSalt) {
        if (!kony.sdk.isNullOrUndefined(customSalt) && typeof customSalt === 'string') {
            integrityCustomSecurityKey = customSalt;
            return true;
        }
        else {
            var errorObj = {};
            errorObj[kony.sdk.constants.MF_ERROR_CODE] = kony.sdk.errorcodes.invalid_security_key;
            errorObj[kony.sdk.constants.MF_ERROR_MSG] = kony.sdk.errormessages.invalid_security_key;
            kony.sdk.logsdk.error(kony.sdk.errormessages.invalid_security_key);
            return errorObj;
        }
    };

    this.getAppSecurityKey = function () {
        return integrityCustomSecurityKey;
    };
};

kony.mbaas = kony.sdk;
kony.sdk.isDebugEnabled = true;
kony.sdk.isInitialized = false;
kony.sdk.currentInstance = null;
kony.sdk.isLicenseUrlAvailable = true;
kony.sdk.constants = kony.sdk.constants || {};
kony.sdk.version = "8.4.2";
kony.sdk.logsdk = new konySdkLogger();
kony.sdk.syncService = null;
kony.sdk.dataStore = kony.sdk.dataStore || new konyDataStore();
kony.sdk.skipAnonymousCall = false;

kony.sdk.getDefaultInstance = function() {
    return kony.sdk.currentInstance;
};

// This is to be deprecated with getDefaultInstance
kony.sdk.getCurrentInstance = function() {
    return kony.sdk.currentInstance;
};

// This is to be set by client to skip anonymous login calls.
kony.sdk.skipAnonymousLoginCall = function(state){
    // If enabled then client can only access public integration services.
    // If disabled then client can access protected integration services.
    // To access private client needs to get authenticated by an identity service.

    kony.sdk.skipAnonymousCall = state;
};

kony.sdk.claimsRefresh = function(callback, failureCallback) {
    kony.sdk.logsdk.trace("Entering kony.sdk.claimsRefresh");
    var konyRef = kony.sdk.getCurrentInstance();

    var networkProvider = new konyNetworkProvider();
    var loginWithAnonymousProvider = function(successCallback, failureCallback) {
        var identityObject = konyRef.getIdentityService("$anonymousProvider");
        identityObject.login(null,
            function(res) {
                successCallback();
            },
            function(res) {
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getAuthErrObj(res));
            });
    };

    if (konyRef.currentClaimToken === null) {
        kony.sdk.logsdk.warn("claims Token is Unavialable");
        if (konyRef.isAnonymousProvider) {
            loginWithAnonymousProvider(callback, failureCallback);
        } else {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getNullClaimsTokenErrObj());
        }
    } else if (konyRef.claimTokenExpiry && new Date().getTime() > konyRef.claimTokenExpiry) {
        if (konyRef.isAnonymousProvider) {
            loginWithAnonymousProvider(callback, failureCallback);
        } else {
            kony.sdk.fetchClaimsTokenFromServer(false, callback, failureCallback);
        }
    } else {
        callback();
    }
};

kony.sdk.claimsAndProviderTokenRefresh = function(callback, failureCallback) {

    kony.sdk.logsdk.trace("Entering kony.sdk.claimsAndProviderTokenRefresh");
    kony.sdk.fetchClaimsTokenFromServer(true, callback, failureCallback);
};

/**
 * Checks for the etag in the response data. Gets the service doc & caches it if etag is updated.
 * @param data{JSON} response data from claimsRefresh or login.
 * @param callback{function} callback to be invoked.
 */
function getLatestServiceDocIfAvailable(data, callback){
    //Disabling this for phonegap and plain-js as there is not concept of auto-init there
    if(kony.sdk.getSdkType() !== kony.sdk.constants.SDK_TYPE_IDE){
        kony.sdk.verifyAndCallClosure(callback);
        return;
    }
    var currentETag = kony.sdk.dataStore.getItem("etagID");
    var serverETag = data.service_doc_etag;

    if (!kony.sdk.isNullOrUndefined(serverETag) &&
        (kony.sdk.isNullOrUndefined(currentETag) || currentETag != serverETag)){
        kony.sdk.logsdk.info("Service doc update found.");
        var networkProvider = new konyNetworkProvider();
        var _serviceUrl = stripTrailingCharacter(konyRef.rec.url, "/") + "/appconfig";

        var headers = {};
        headers[kony.sdk.constants.APP_KEY_HEADER] = konyRef.mainRef.appKey;
        headers[kony.sdk.constants.APP_SECRET_HEADER] = konyRef.mainRef.appSecret;
        headers["X-HTTP-Method-Override"] = "GET";

        populateHeaderWithFabricAppVersion(headers);

        networkProvider.post(_serviceUrl, null, headers,
            function (successResponse) {
                kony.sdk.dataStore.setItem("etagID", serverETag);
                kony.sdk.logsdk.debug("Update done. Current version = "+currentETag+" Updated to "+serverETag);
                kony.sdk.dataStore.setItem(appConfig.appId + "_mobileFabricServiceDoc", JSON.stringify(successResponse));
                kony.sdk.verifyAndCallClosure(callback);
            },
            function (failureResponse) {
                kony.sdk.logsdk.error("Refresh of serviceDoc failed:" + JSON.stringify(failureResponse));
                kony.sdk.verifyAndCallClosure(callback);
            });
    } else {
        kony.sdk.verifyAndCallClosure(callback);
    }
}

kony.sdk.fetchClaimsTokenFromServer = function(isBackendTokenRefreshRequired, callback, failureCallback) {
    kony.sdk.logsdk.trace("Entering kony.sdk.fetchClaimsTokenFromServer");
    var konyRef = kony.sdk.getCurrentInstance();

    var networkProvider = new konyNetworkProvider();
    kony.sdk.logsdk.debug("claims token has expired. fetching new token and isBackendTokenRefreshRequired :" ,isBackendTokenRefreshRequired);
    var _serviceUrl = stripTrailingCharacter(konyRef.rec.url, "/");
    var _url = _serviceUrl + "/claims";
    if(isBackendTokenRefreshRequired){
        _url = _url + "?refresh=true";
    }
    kony.sdk.logsdk.debug("service url is " + _url);
    if (konyRef.currentRefreshToken === null) {
        kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getNullRefreshTokenErrObj());
    } else {
        var headers = {};
        headers[kony.sdk.constants.AUTHORIZATION_HEADER] = konyRef.currentRefreshToken;
        headers[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_FORM_URL_ENCODED;
        networkProvider.post(_url, {}, headers,
            function(tokens) {
                kony.sdk.logsdk.trace("refresh success..acquiring new tokens");
                var response = kony.sdk.processClaimsSuccessResponse(tokens,konyRef,false);

                function serviceDocCallback(){
                    kony.sdk.verifyAndCallClosure(callback, response);
                }

                getLatestServiceDocIfAvailable(tokens, serviceDocCallback);
            },
            function(data) {
                kony.sdk.logsdk.error("failed to acquire refresh token",data);
                kony.sdk.processClaimsErrorResponse(data,konyRef,true,failureCallback);
            });
    }
};

kony.sdk.processClaimsSuccessResponse=function(data,konyRef,isAsync,callBack){
    kony.sdk.logsdk.trace("Entering kony.sdk.processClaimsSuccessResponse");
    data = kony.sdk.formatSuccessResponse(data);
    konyRef.currentClaimToken = data.claims_token.value;
    konyRef.claimTokenExpiry = data.claims_token.exp;
    konyRef.currentRefreshToken = data.refresh_token;
    kony.logger.setClaimsToken();
    //if offline login enabled then updating the claimstoken in the store
    if(kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE &&  kony.sdk.getAType() === kony.sdk.constants.SDK_ATYPE_NATIVE && kony.sdk.getPlatformName() !== kony.sdk.constants.PLATFORM_WINDOWS){
        if(kony.sdk.offline.isOfflineEnabled && kony.sdk.offline.isOfflineEnabled == true) {
            kony.sdk.offline.updateAuthToken(data);
        }
        if(kony.sdk.offline.persistToken || kony.sdk.util.isPersistentLoginResponseEnabled()) {
            kony.sdk.offline.updatePersistedToken(data);
        }
    }
    if(!isAsync){
        return { "message" :"success"};
    }
    else if(callBack){
        callBack();
    }
};
kony.sdk.processClaimsErrorResponse=function(data,konyRef,isAsync,callBack){
    kony.sdk.logsdk.trace("Entering kony.sdk.processClaimsErrorResponse");
	/*reset the claims token*/
    konyRef.currentClaimToken = null;
    konyRef.claimTokenExpiry = null;
    konyRef.currentRefreshToken = null;
    //setting the anonymous provider as true to access the public protected urls without any issue
    konyRef.isAnonymousProvider = true;
    if(!isAsync){
        return kony.sdk.error.getAuthErrObj(data);
    }
    else if(callBack){
        kony.sdk.verifyAndCallClosure(callBack, kony.sdk.error.getAuthErrObj(data));
    }
};

/**
 * Init success callback method.
 * @callback initSuccessCallback
 * @param {json} mainRef - Application Configuration
 */

/**
 * Init failure callback method.
 * @callback initFailureCallback
 */

/**
 * Initialization method for the kony SDK.
 * This method will fetch the app configuration from the kony server and stores in memory.
 * This method has to be invoked before invoking any other SDK methods.
 * @param {string} appKey - Appkey of the kony application
 * @param {string} appSecret - App Secret of the kony application
 * @param {string} serviceUrl - URL of the kony Server
 * @param {initSuccessCallback} successCallback  - Callback method on success
 * @param {initFailureCallback} failureCallback - Callback method on failure
 */
kony.sdk.prototype.init = function(appKey, appSecret, serviceUrl, successCallback, failureCallback, initOptions) {

    // removing app metadata with key for the latest app metadata
    kony.sdk.logsdk.trace("Entering kony.sdk.prototype.init");
    kony.sdk.deleteMetadatafromDs();

    if (!(appKey && appSecret && serviceUrl)) {
        kony.sdk.logsdk.error("### init:: Invalid credentials passed");
        kony.sdk.verifyAndCallClosure(failureCallback, "Invalid initialization parameters passed. Please check appKey, appSecret and ServiceUrl parameters");
        return;
    }
    var networkProvider = new konyNetworkProvider();
    serviceUrl = serviceUrl.trim();
    this.mainRef.serviceUrl = serviceUrl;
    this.mainRef.appSecret = appSecret;
    
    konyRef = this;
    KNYMobileFabric = this;
    kony.sdk.currentInstance = konyRef;

    var options = {};
    options["ignoreintegrity"] = true;

    setIntegrityParams.call(konyRef);
    kony.sdk.logsdk.trace("### init:: calling GET on appConfig to retrieve servicedoc");

    var headers = {};

    headers[kony.sdk.constants.APP_KEY_HEADER] = appKey;
    headers[kony.sdk.constants.APP_SECRET_HEADER] = appSecret;
    headers["X-HTTP-Method-Override"] = "GET";

    //Resetting the value.
    kony.sdk.setFabricAppVersion(null);

    if (!kony.sdk.isNullOrUndefined(initOptions) && initOptions["MFAppVersion"]){
        kony.sdk.setFabricAppVersion(initOptions["MFAppVersion"]);
    }

    populateHeaderWithFabricAppVersion(headers);

    networkProvider.post(
        serviceUrl,
        null,
        headers,
        function(data) {
            data = kony.sdk.formatSuccessResponse(data);
            kony.sdk.logsdk.info("### init::_doInit fetched servicedoc successfuly");
            kony.sdk.logsdk.debug("### init:: retrieved data from service doc",data);
            konyRef.mainRef.config = data;
            konyRef.servicedoc = data;
            konyRef.mainRef.appId = data.appId;
            var processServiceDocResult = konyRef.initWithServiceDoc(appKey, appSecret, data);
            if (processServiceDocResult === true) {
                kony.sdk.logsdk.info("### init::_doInit processing service document successful");
                kony.sdk.logsdk.debug("### init::_doInit saving done. Calling success callback",data);
                kony.sdk.initiateSession(konyRef);
                if (typeof (KNYMetricsService) !== "undefined" && kony.sdk.currentInstance.getMetricsService) {
                    KNYMetricsService = kony.sdk.currentInstance.getMetricsService();
                    if (KNYMetricsService && typeof (appConfig) !== "undefined" &&
                        kony.sdk.util.isJsonObject(appConfig) && appConfig.hasOwnProperty("eventTypes") &&
                        kony.sdk.isArray(appConfig.eventTypes) && appConfig.eventTypes.length !== 0) {
                        KNYMetricsService.setEventTracking(appConfig.eventTypes);
                    }
                }
                if (kony.sdk.skipAnonymousCall){
                    kony.sdk.logsdk.info("### init::skipping anonymous login call");
                    // Enabling this flag to connect to any protected integration service.
                    konyRef.isAnonymousProvider = true ;
                    kony.sdk.verifyAndCallClosure(successCallback, konyRef.mainRef);
                }
                else{
                    var identityObject = kony.sdk.getCurrentInstance().getIdentityService("$anonymousProvider");
                    identityObject.login(null,
                        function(res) {
                            kony.sdk.verifyAndCallClosure(successCallback, konyRef.mainRef);
                        },
                        function(res) {
                            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getAuthErrObj(res));
                        });
                }
            } else {

                kony.sdk.logsdk.error("### init::_doInit processing servicedoc failed. Calling failure callback");
                kony.sdk.verifyAndCallClosure(failureCallback, JSON.stringify(processServiceDocResult));
            }
        },
        function(error) {
            kony.sdk.logsdk.error("### init::_doInit fetching service document from Server failed", error);
            kony.sdk.logsdk.info("### init::_doInit  calling failure callback");
            kony.sdk.isInitialized = false;
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getAuthErrObj(error));
        },null,options);
};

kony.sdk.prototype.initWithServiceDoc = function(appKey, appSecret, serviceDoc) {
    kony.sdk.logsdk.trace("Entering kony.sdk.prototype.initWithServiceDoc");
    konyRef = this;
    KNYMobileFabric = this;
    kony.sdk.currentInstance = this;

    var unprocessedServiceDoc = kony.sdk.cloneObject(serviceDoc);
    if(kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE){
        if (!kony.sdk.isNullOrUndefined(serviceDoc)) {
            if(serviceDoc.hasOwnProperty("integrity_check_required") && serviceDoc.integrity_check_required === true)
            {
                //MF server >=8.2
                konyRef.mainRef.integrityKey = true;
            }
            else {
                //MF server < 8.2 and integrity is disabled
                konyRef.mainRef.integrityKey = false;
            }
        }
    }else{
        //platform phonegap and plain-js doesn't support http integrity
        konyRef.mainRef.integrityKey = false;
    }
    if (serviceDoc instanceof kony.sdk.serviceDoc) {
        var servConfig = serviceDoc.toJSON();
        processServiceDocMap(servConfig);
    } else {
        return processServiceDocMap(serviceDoc);
    }

    function processServiceDocMap(servConfig) {
        for (var item in servConfig) {
            if (kony.sdk.isNullOrUndefined(servConfig[item]) || kony.sdk.isEmptyObject(servConfig[item])) {
                delete servConfig[item];
            }
        }

        kony.sdk.logsdk.debug("### init::_doInit::_processServiceDoc", servConfig);
        try {
            konyRef.mainRef.appKey = appKey;
            konyRef.mainRef.appSecret = appSecret;
            konyRef.mainRef.appId = servConfig.appId;
            konyRef.mainRef.config = serviceDoc;

            /* if (!servConfig.baseId) {
             throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, "invalid baseId " + servConfig.baseId);
             } */
            konyRef.mainRef.baseId = servConfig.baseId;

            /* if (!servConfig.name) {
             throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, "invalid name " + servConfig.name);
             } */
            konyRef.mainRef.name = servConfig.name;

            if (servConfig.login) {
                konyRef.login = servConfig.login;
            } else {
                konyRef.login = [];
            }

            var url = servConfig.selflink;
            if (url) {
                var lastPos = url.indexOf("/appconfig");
                if (lastPos != -1) {
                    url = url.slice(0, lastPos);
                } else {
                    throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, "invalid self link");
                }
                var anonymousLoginProvider = {};
                anonymousLoginProvider.type = "anonymous";
                anonymousLoginProvider.url = url;
                anonymousLoginProvider.prov = "$anonymousProvider";
                konyRef.login.push(anonymousLoginProvider);
            }

            if (typeof(servConfig.integsvc) !== 'undefined') {
                kony.sdk.logsdk.info("### init::_doInit::_processServiceDoc parsing Integration services");
                konyRef.integsvc = servConfig.integsvc;
                kony.sdk.logsdk.debug("### init::_doInit::konyRef integration Services", konyRef.integsvc);
            }
            if (typeof(servConfig.services_meta) === 'object') {
                kony.sdk.logsdk.info("### init::_doInit::_processServiceDoc parsing Object services");
                kony.sdk.util.populateIndividualServiceLists(servConfig, konyRef);
            }

            if (typeof(servConfig.messagingsvc) !== 'undefined') {
                kony.sdk.logsdk.info("### init::_doInit::_processServiceDoc parsing Messaging services");
                konyRef.messagingsvc = servConfig.messagingsvc;
            }
            if (typeof(servConfig.logicsvc) !== 'undefined') {
                kony.sdk.logsdk.info("### init::_doInit::_processServiceDoc parsing Logic services");
                konyRef.logicsvc = servConfig.logicsvc;
            }

            if (typeof(servConfig.sync) !== 'undefined') {
                konyRef.sync = servConfig.sync;
            }

            if (servConfig.identity_features && servConfig.identity_features.reporting_params_header_allowed) {
                kony.sdk.logsdk.info("### init::_doInit::_processServiceDoc parsing Identity features");
                konyRef.reportingheaders_allowed = servConfig.identity_features.reporting_params_header_allowed;
            }

            if (kony.sdk.isLicenseUrlAvailable) {
                if (servConfig.reportingsvc && servConfig.reportingsvc.custom && servConfig.reportingsvc.session) {
                    konyRef.customReportingURL = servConfig.reportingsvc.custom;
                    konyRef.sessionReportingURL = servConfig.reportingsvc.session;

                    if (konyRef.sessionReportingURL && kony.logger.isNativeLoggerAvailable()) {
                        var lastIndex = konyRef.sessionReportingURL.lastIndexOf("/");
                        if (lastIndex !== -1) {
                            var networkUrl = konyRef.sessionReportingURL.substring(0, lastIndex + 1) + kony.logger.networkPersistorUrlEndpoint;
                            var networkPersistor = kony.logger.createNetworkPersistor();
                            networkPersistor.URL = networkUrl;
                            kony.logger.setPersistorConfig(networkPersistor);
                        }
                    }

                } else {
                    throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, "invalid url for reporting service");
                }
            }

            if (konyRef.internalSdkObject) {
                konyRef.internalSdkObject.initWithServiceDoc(appKey, appSecret, servConfig);
                if (konyRef.internalSdkObject.setClientParams) {
                    if (appConfig) {
                        konyRef.internalSdkObject.setClientParams({"aid": appConfig.appId, "aname": appConfig.appName});
                    } else {
                        konyRef.internalSdkObject.setClientParams(konyRef.getClientParams());
                    }

                }
                kony.sdk.logsdk.info("### init::internal sdk object initialized");
            }
            kony.sdk.logsdk.info("### init::_doInit::_processServiceDoc parsing service document done");
            kony.sdk.isInitialized = true;
            if (kony.sdk.metric && kony.os.deviceInfo().name === kony.sdk.constants.PLATFORM_SPA) {
                kony.sdk.metric.flushEvents();
            }

            if (!kony.sdk.isNullOrUndefined(servConfig.reportingsvc)) {
                kony.sdk.saveMetadatainDs(appKey, appSecret, unprocessedServiceDoc);
                kony.sdk.setLicenseCall(appKey, appSecret, unprocessedServiceDoc);
            }

            if (kony.sdk.getPlatformName() === kony.sdk.constants.PLATFORM_ANDROID && (appConfig.isSSOEnabled === true || appConfig.isSSOEnabled === "true")) {
                kony.sdk.util.initializeSSO();
            }

            var sdkType = kony.sdk.getSdkType();
            var type = kony.sdk.getAType();
            var platformName = kony.sdk.getPlatformName();

            if (sdkType == kony.sdk.constants.SDK_TYPE_IDE && ((type === kony.sdk.constants.SDK_ATYPE_NATIVE) || (type === kony.sdk.constants.SDK_ATYPE_SPA))) {
                if ((!kony.sdk.isNullOrUndefined(konyRef.offlineObjectsvc)) && !(kony.sdk.isEmptyObject(konyRef.offlineObjectsvc))) {
                    konyRef.OfflineObjects = new kony.sdk.OfflineObjects(konyRef.offlineObjectsvc);
                }
            }

            if (kony.license) {
                if (kony.licensevar && kony.licensevar.changeHandlers && kony.licensevar.changeHandlers.length == 0 && kony.license.registerChangeListener) {
                    kony.license.registerChangeListener(konyRef.sessionChangeHandler);
                    konyRef.overrideUserIdFlag = true;
                }
            }
            if (konyRef.mainRef.integrityKey === true) {
                setIntegrityParams();
                try {
                    if(!(kony.sdk.getAType() === kony.sdk.constants.SDK_ATYPE_SPA || kony.sdk.getAType() === "watch")){
                        //invoke NFI only for android,ios and FFI for windows 
                        kony.sdk.httpIntegrity.setIntegrityCheck(konyRef.mainRef.integrityParams);
                    }

                } catch (e) {
                    kony.sdk.logsdk.warn("Invalid Integrity properties received");
                    throw new Exception(kony.sdk.errorConstants.INTEGRITY_FAILURE, "Invalid Integrity properties");
                }
            } else {
                resetIntegrityParams();
                if(!(kony.sdk.getAType() === kony.sdk.constants.SDK_ATYPE_SPA || kony.sdk.getAType() === "watch")){
                    //invoke NFI only for android,ios and FFI for windows 
                    kony.sdk.httpIntegrity.removeIntegrityCheck();
                }
            }
            return true;
         }
        catch (err) {
            kony.sdk.logsdk.error("### init::_doInit::_processServiceDoc failed with an exception: " , err);
            return ("processing the ServiceDoc failed with an exception: " + JSON.stringify(err));
        }

    }
};

kony.sdk.prototype.sessionChangeHandler = function(changes) {
    kony.sdk.logsdk.trace("Entering kony.sdk.prototype.sessionChangeHandler");
    var konyRef = kony.sdk.getCurrentInstance();
    konyRef.getMetricsService();
    var sessionId = null;
    var userId = null;
    if (changes["sessionId"] != undefined) {
        sessionId = changes["sessionId"];
        konyRef.setSessionId(sessionId);
        if(konyRef.internalSdkObject) {
            sessionId = sessionId + "," + kony.sdk.util.getSessionType();
        }
        if (konyRef.metricsServiceObject && konyRef.metricsServiceObject.setSessionId) {
            konyRef.metricsServiceObject.setSessionId(sessionId);
        }
    }
    if (changes["userId"] != undefined) {
        konyRef.overrideUserIdFlag = true;
        userId = changes["userId"];
        konyRef.setCurrentUserId(userId);
        if (konyRef.metricsServiceObject && konyRef.metricsServiceObject.setUserId) {
            konyRef.metricsServiceObject.setUserId(userId);
        }
    }
};

function setIntegrityParams(){
    var integrityParams = {
        "algo": kony.sdk.constants.HASHING_ALGORITHM,
        "headerName": kony.sdk.constants.INTEGRITY_HEADER,
        "validateResp": true
    };
    if (!kony.sdk.isNullOrUndefined(konyRef.getAppSecurityKey())) {
        integrityParams["salt"] = konyRef.getAppSecurityKey();
    }
    else {
        integrityParams["salt"] = konyRef.mainRef.appSecret;
    }
    konyRef.mainRef.integrityKey = true;
    konyRef.mainRef.integrityParams = integrityParams;
}

function resetIntegrityParams(){
    konyRef.mainRef.integrityKey = false;
    konyRef.mainRef.integrityParams = {};
}

/**
 * MFSDK
 * Created by KH1969 on 18-01-2018.
 * Copyright © 2018 Kony. All rights reserved.
 */

/**
 * Constructor for ClientCache service, uses lruCache.js internally to save key, value pairs.
 * This is a singleton class, object gets created for the first time of instantiation and the same object is
 * returned for next initializations.
 *
 * @param size {Number} Maximum size of the cache. It should be non zero positive number.
 * @return {kony.sdk.ClientCache}
 *
 */
kony.sdk.ClientCache = function(size){

    if (typeof kony.sdk.ClientCache.instance === 'object')
        return kony.sdk.ClientCache.instance;

    var lruCacheObj = null;

    if (size === undefined || size === null)
        lruCacheObj = new lruCache(kony.sdk.constants.DEFAULT_CACHE_SIZE);
    else if (typeof size != 'number' || size <= 0){
        kony.sdk.logsdk.warn("cache cannot be created of size <= 0");
        return null;
    }
    else
        lruCacheObj = new lruCache(size);

    /**
     * Gets the response cached for the key. Returns null if not found.
     * @param key {string}
     * @return {null|object}
     */
    this.get = function(key){
        return lruCacheObj.get(key);
    }

    /**
     * Gets the boolean assertion for key existence in the cache.
     * @param key {string}
     * @return {boolean}
     */
    this.has = function(key){
        return lruCacheObj.has(key);
    }

    /**
     * Adds the key, value pair to cache.
     * @param key {string}
     * @param value {string}
     * @param expiryTime {number} Expiry time in seconds.
     */
    this.add = function(key, value, expiryTime){
        lruCacheObj.add(key, value, expiryTime);
    }

    /**
     * Removes the key, value from cache.
     * @param key {string}
     */
    this.remove = function(key){
        lruCacheObj.remove(key);
    }

    kony.sdk.ClientCache.instance = this;
}

/**
 * MFSDK
 * Created by KH1969 on 18-01-2018.
 * Copyright © 2018 Kony. All rights reserved.
 */

/**
 * Constructor for standalone LRU page replacement implementation.
 * Implementation is done using a double linked list data structure and a hashmap.
 * Upon every insert & get the head gets updated to the newest element.
 * Cached nodes gets removed if size is more than the requested capacity.
 * Default cache size is 100.
 *
 * Should not be called by the developer.
 *
 *  Below is the list structure if elements are inserted in the order A, B, C & D

 *  Head = D, Tail = A
 *  D--(older)-->C--(older)-->B--(older)-->A--(older)-->NULL
 *  NULL<--(newer)--D<--(newer)--C<--(newer)--B<--(newer)--A
 *
 *  Now if B is accessed the list structure will be modified as,
 *  Head = B, Tail = A
 *
 *  B--(older)-->D--(older)-->C--(older)-->A--(older)-->NULL
 *  NULL<--(newer)--B<--(newer)--D<--(newer)--C<--(newer)--A
 */
lruCache = function(size){
    var LOG_PREFIX = "SDK_CACHE ";
    if (size === undefined || size === null)
        this.capacity = kony.sdk.constants.DEFAULT_CACHE_SIZE;
    else if (typeof size != 'number' || size <= 0){
        kony.sdk.logsdk.warn("cache cannot be created of size <= 0");
        return null;
    }
    else
        this.capacity = size;

    this.length = 0;
    this.map = {};
    // save the head and tail so we can update it easily
    this.head = null;
    this.tail = null;

    /**
     * Gets the current time in seconds.
     * @returns {number}
     */
    function getCurrentTimeInSeconds(){
        return Math.floor(new Date().getTime()/1000);
    }

    /**
     * Double linked list data structure.
     * @param key
     * @param value
     */
    function cacheNode(key,value, expiry){
        this.key = key;
        this.val = value;
        this.newer = null;// Next newer node
        this.older = null;// Previous older node
        this.expiryTime = 0;

        if (expiry !== undefined && typeof expiry === 'number' && expiry != 0){
            this.expiryTime = getCurrentTimeInSeconds() + expiry;
        }
    }

    /**
     * Shuffles the cache by last recently used.
     * @param key
     */
    function shuffleLRUCache(key){
        var node = this.map[key];

        if (this.head === node){
            // No need to shuffle the cache, as the head itself is the recently accessed node.
            return;
        }

        // Head will not have newer node.
        if(node.newer){
            node.newer.older= node.older;
        }else{
            this.head = node.older;
        }

        // Tail will not have older node.
        if(node.older){
            node.older.newer = node.newer;
        }else{
            this.tail = node.newer;
        }

        // Now node is detached. Place it at head.
        // Updates are done in this way
        // 1: node--(older)-->head
        // 2: null<--(newer)--node
        // 3: node<--(newer)--head
        // 4: node is assigned to head. So current head got updated to node.
        node.older = this.head;
        node.newer = null;
        if(this.head){
            this.head.newer = node;
        }
        this.head = node;
    }

    /**
     * Returns the current size of the cache.
     * @returns {number}
     */
    this.getSize = function (){
        return this.length;
    }

    /**
     * Adds the key value pair to the cache.
     * Key gets removed upon expiry, expiry time is calculated by currentTimeInSeconds + expiryTime.
     * If no expiryTime is specified then key will not expire.
     * @param key {String}
     * @param value {Object}
     * @param expiryTime {Number}
     */
    this.add = function(key, value, expiryTime){
        if (key === undefined || value === undefined || key === null || value === null)
            return;

        // update the value for existing entries
        if(this.has(key)){
            this.map[key].val = value;
            kony.sdk.logsdk.debug(LOG_PREFIX+"Key: "+key+" updated");
            shuffleLRUCache.call(this, key);
            return;
        }

        if(this.length >= this.capacity){
            // remove the least recently used item
            this.remove(this.tail.key)
        }

        var node = new cacheNode(key,value, expiryTime);
        // Additions are done in this way
        // 1: node--(older)-->head
        // 2: node<--(newer)--head
        // 3: node is assigned to head. So current head got updated to node.
        // 4: tail = node, if there is no tail node then current node is tail node. This happens only for the first add.

        node.older = this.head;
        // if have head, we need re-connect node with other nodes older than head
        if(this.head){
            this.head.newer = node;
        }
        this.head = node;
        // if no tail which means first insert, set the tail to node too
        if(!this.tail){
            this.tail = node;
        }
        this.map[key] = node;
        this.length ++;

        kony.sdk.logsdk.debug(LOG_PREFIX+"Key: "+key+" added");
    }

    /**
     * Gets the cached node by key. Returns null if key is not found.
     * The key is removed if it is expired, returns null here as well.
     * @param key {String}
     * @returns {Object}
     */
    this.get = function(key){
        if(this.has(key)){
            if (this.map[key].expiryTime != 0 && getCurrentTimeInSeconds() > this.map[key].expiryTime){
                this.remove(key);
                kony.sdk.logsdk.debug(LOG_PREFIX+"Key: "+key+" expired");
                return null;
            }
            shuffleLRUCache.call(this, key);
            return this.map[key].val;
        }else{
            return null;
        }
    }

    /**
     * Removes the key, value from the cache by key.
     * @param key {String} Key to delete from the cache
     */
    this.remove = function(key){
        if(this.has(key)){
            var node = this.map[key];

            // Head node will not have newer node.
            if(node.newer){
                node.newer.older= node.older;
            }else{
                this.head = node.older;
            }

            // Tail node will not have older node.
            if(node.older){
                node.older.newer = node.newer;
            }else{
                this.tail = node.newer;
            }

            delete this.map[key];
            node = null;
            this.length --;
        }
    }

    /**
     * Clears the cache.
     */
    this.clear = function(){
        this.map = {};
        this.length = 0;
    }

    /**
     * Check if key exists.
     * @param key {string} Key to be found in the cache
     * @returns {boolean}
     */
    this.has = function(key){
        return this.map.hasOwnProperty(key);
    }

    /**
     * Updates the cache size.
     * @param size {number}
     */
    this.setMaxCacheSize = function(size){
        //    Todo: If requested size < capacity remove the last (N - size) nodes from tail.
        kony.sdk.logsdk.debug(LOG_PREFIX+"updating cache size from "+this.capacity+" to "+size);
        this.capacity = size;
    }
}

/**
 * Method to create the configuration service instance
 * @returns {ConfigurationService} Configuration service instance
 */
kony.sdk.prototype.getConfigurationService = function() {
    kony.sdk.logsdk.trace("Entering kony.sdk.prototype.getConfigurationService")
    if (!kony.sdk.isInitialized) {
        throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, kony.sdk.constants.INIT_FAILURE_MESSAGE + " Configuration service.");
    }
    var configObj = new ConfigurationService(this);
    if(configObj){
        return configObj;
    }
    else {
        throw new Exception(kony.sdk.errorConstants.CONFIGURATION_FAILURE, "Error in creating configuration object");
    }
};

/**
 * Should not be called by the developer.
 * @class
 * @classdesc Configuration service instance for fetching client app properties.
 */
function ConfigurationService(konyRef){

    var istUrl = konyRef.mainRef.config.reportingsvc.session.split("/IST")[0];
    kony.sdk.logsdk.debug("IST url fetched from service doc is :"+istUrl);
    var configUrl = istUrl + kony.sdk.constants.GET_CLIENT_PROPERTY_URL;
    kony.sdk.logsdk.debug("Configuration url formed is :"+configUrl);
    var networkProvider = new konyNetworkProvider();

    /**
     * Configuration svc method to get all the client app properties which is configured in admin console.
     * @successCallback this is called on successfull retrieval of properties
     * @failureCallback this is called on failure in retrieving properties
     * @returns {json} key value pair of all client app properties
     */
    this.getAllClientAppProperties = function(successCallback,failureCallback){

        function fetchClientPropertiesHandler(){
            _getAllClientAppProperties(successCallback,failureCallback);
        }

        kony.sdk.claimsRefresh(fetchClientPropertiesHandler, failureCallback);
    };

    function _getAllClientAppProperties(successCallback,failureCallback){
        kony.sdk.logsdk.trace("Entering into _getAllClientAppProperties");
        var defaultHeaders = {};
        var token = konyRef.currentClaimToken;
        if(!token){
            token = kony.sdk.getCurrentInstance().currentClaimToken;
        }
        defaultHeaders[kony.sdk.constants.KONY_AUTHORIZATION_HEADER] = token;
        var options = {};
        options["disableIntegrity"] = true;
        networkProvider.get(configUrl,null,defaultHeaders,
            function(res) {
                kony.sdk.logsdk.trace("Entering Configuration service network success");
                kony.sdk.logsdk.debug("response from server for client properties is :"+JSON.stringify(res));
                var tempArray = ["httpresponse",kony.sdk.constants.MF_OPSTATUS];
                var tempJSON = {};
                for(var key in res){
                    if(tempArray.indexOf(key.toLowerCase())>-1){
                        continue;
                    }
                    tempJSON[key] = res[key];
                }
                kony.sdk.verifyAndCallClosure(successCallback, tempJSON);
            },
            function(xhr, status, err) {
                kony.sdk.logsdk.trace("Entering Configuration service network error");
                if (xhr && !(status && err)) {
                    err = xhr;
                }
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getObjectServiceErrObj(err));
            }, null, options);
    }
}
kony.sdk.constants =
    {
        /**Logger Constants**/
        LOGGER_NAME : "MFSDK",
        SYNC_LOGGER_NAME : "SYNCV1",
        APP_LOGGER_NAME : "KonyLogger",

        /**Network constants**/
        LAUNCHMODE_DEEPLINK : 3,
        DEEPLINK_VALID_PARAM : "code",
        HASHING_ALGORITHM : "SHA256",
        REMOVE_INTEGRITY_CHECK : "removeIntegrityCheck",
        SET_INTEGRITY_CHECK : "setIntegrityCheck",
        DEFAULT_CACHE_SIZE : 100,
        GET_CLIENT_PROPERTY_URL : "/metadata/configurations/client/properties",
        DEFAULT_CACHE_EXPIRY_TIME : 0, //Which means it doesn't expire in the application session.

        /**Service ID's for Identity Calls**/
        GET_BACKEND_TOKEN : "getBackendToken",
        GET_SECURITY_ATTRIBUTES : "getSecurityAttributes",
        GET_USER_ATTRIBUTES : "getUserAttributes",
        GET_USER_DATA : "getUserData",
        GET_PROFILE : "getProfile",

        /** Identity Options**/
        OAUTH_REDIRECT_SUCCESS_URL: "success_url",

        //OAuth for IE11 Workaround Constants, MFSDK-3657
        IE11_CROSS_DOMAIN_OAUTH_BASE_URL: "IE11CrossDomainOAuthBaseUrl",
        KNY_OAUTH_REDIRECT_HTML: "KNYOAuthRedirect.html",
        KNY_OAUTH_CALLBACK_HTML: "KNYOAuthCallback.html",
        KNY_OAUTH_REDIRECT_URL: "kny_oauth_redirect_url",

        /**HttpMethods and header constants**/
        HTTP_METHOD_GET : "GET",
        HTTP_METHOD_POST : "POST",
        HTTP_METHOD_DELETE : "DELETE",
        HTTP_CONTENT_HEADER : "Content-Type",
        HTTP_REQUEST_HEADER_ACCEPT : "Accept",

        /**Content Type Value Constants**/
        CONTENT_TYPE_FORM_URL_ENCODED   : "application/x-www-form-urlencoded",
        CONTENT_TYPE_JSON               : "application/json",
        //Added a new content-type based on the bug MFSDK-4096
        CONTENT_TYPE_JSON_CHARSET_UTF8  : "application/json;charset=utf-8",
        CONTENT_TYPE_OCTET_STREAM       : "application/octet-stream",
        CONTENT_TYPE_TEXT_HTML          : "text/html",
        CONTENT_TYPE_TEXT_PLAIN         : "text/plain",

        /**SDK Plugin Type**/
        SDK_TYPE_IDE : "js",
        SDK_TYPE_PHONEGAP : "phonegap",
        SDK_TYPE_PLAIN_JS : "plain-js",

        /**APP Session Type**/
        APP_SESSION_INTERACTIVE : "I",
        APP_SESSION_NON_INTERACTIVE : "NI",
        
        /**SDK Architecture Type**/
        SDK_ATYPE_NATIVE : "native",
        SDK_ATYPE_SPA :"spa",

        /**Device platform**/
        PLATFORM_WINDOWS :"windows",
        PLATFORM_ANDROID :"android",
        PLATFORM_IOS :"ios",

        //kony.os.device.info() for SPA returns thinclient
        PLATFORM_SPA : "thinclient", 
        
        /***Metrics Constants**/
        REPORTING_PARAMS : "konyreportingparams",
        KEY_DEVICE_ID : "deviceID",

        /**Headers**/
        APP_KEY_HEADER : "X-Kony-App-Key",
        APP_SECRET_HEADER : "X-Kony-App-Secret",
        KONY_AUTHORIZATION_HEADER : "X-Kony-Authorization",
        AUTHORIZATION_HEADER : "Authorization",
        REPORTING_HEADER : "X-Kony-ReportingParams",
        INTEGRITY_HEADER : "X-Kony-Integrity",
        DEVICEID_HEADER : "X-Kony-DeviceId",
        API_VERSION_HEADER : "X-Kony-API-Version",
        APP_VERSION_HEADER : "X-Kony-App-Version",
        SDK_TYPE_HEADER : "X-Kony-SDK-Type",
        SDK_VERSION_HEADER : "X-Kony-SDK-Version",
        PLATFORM_TYPE_HEADER : "X-Kony-Platform-Type",
        HTTP_OVERRIDE_HEADER : "X-HTTP-Method-Override",

        /**Mobilefabric constants**/
        HTTP_STATUS_CODE : "httpStatusCode",
        MF_OPSTATUS : "opstatus",
        MF_CODE : "mfcode",
        MF_ERROR_MSG : "errmsg",
        MF_ERROR_CODE : "errcode",
        MF_SERVICE : "service",

        /**Engagement service API constants**/
        SUBSCRIBE_AUDIENCE : "/subscribeaudience",
        BEACON_UPDATE : "/beaconupdate",
        RICH_PUSH_MESSAGE : "/messages/rich/",
        LAST_ACTIVE_DATE : "lastActiveDate",
        KSID : "ksid",
        AUTH_TOKEN: "authToken",
        DEVICE_AUTHTOKEN_HEADER: "X-Device-AuthToken",

        /**Parsed Template Constants**/
        PROCESSED_TEMPLATE: "processedTemplate",
        MISSING_VARIABLES: "missingVariables",

        /**Mandatory Binary Params**/
        FILE_PATH: "FilePath",
        RAW_BYTES: "rawBytes",
        FILE_OBJECT: "fileObject",
        FILE_NAME: "fileName",

        /**Miscellaneous**/
        SSO_TOKEN_KEY : "ssoTokenKey",
        KONYUUID : "konyUUID",
        BROWSER_WIDGET : "browserWidget",
        INIT_FAILURE_MESSAGE : "SDK is not initialized, call init before invoking any operation on",
        DISABLE_INTEGRITY : "disableIntegrity",
        PASSTHROUGH : "passthrough",
        BINARY_DATATYPE : "binary",

        /** License Constants **/
        LICENSE_SESSION_TIMEOUT_IN_MILLIS : 14400000,
        LICENSE_BG_TO_FG_SESSION_TIMEOUT_IN_MILLIS : 1800000
    };

if (typeof(kony.sdk) === "undefined") {
	kony.sdk = {};
}

if (typeof(kony.sdk.error) === "undefined") {
	kony.sdk.error = {};
}

kony.sdk.error.getAuthErrObj = function(errResponse) {
	kony.sdk.logsdk.trace("Entering into kony.sdk.error.getAuthErrObj");
	if (errResponse && errResponse.httpresponse) {
		delete errResponse.httpresponse;
	}
	if (errResponse && errResponse[kony.sdk.constants.MF_ERROR_MSG]) {
		errResponse["message"] = errResponse[kony.sdk.constants.MF_ERROR_MSG];
		delete errResponse.errmsg;
	}
	try {
		var mfcode = errResponse[kony.sdk.constants.MF_CODE];
		var message = errResponse["message"];
		var details = errResponse["details"];
		if (mfcode) {
			return kony.sdk.error.getMFcodeErrObj(mfcode, message, details, "");
		}
		return errResponse;
	} catch (err) {
		return errResponse;
	}
}

kony.sdk.error.getNullClaimsTokenErrObj = function() {
		kony.sdk.logsdk.trace("Entering into kony.sdk.error.getNullClaimsTokenErrObj");
	var errorObj = {};
	errorObj.opstatus = kony.sdk.errorcodes.cliams_token_null
	errorObj.message = kony.sdk.errormessages.cliams_token_null
	errorObj.details = {};
	errorObj.mfcode = "";
	return errorObj;
}

kony.sdk.error.getIdentitySessionInactiveErrObj = function() {
		kony.sdk.logsdk.trace("Entering into kony.sdk.error.getIdentitySessionInactiveErrObj");
	var errorObj = {};	errorObj.opstatus = kony.sdk.errorcodes.identity_session_inactive
	errorObj.message = kony.sdk.errormessages.identity_session_inactive
	errorObj.details = {};
	errorObj.mfcode = "";
	return errorObj;
}

kony.sdk.error.getNullRefreshTokenErrObj = function() {
		kony.sdk.logsdk.trace("Entering into kony.sdk.error.getNullRefreshTokenErrObj");
	var errorObj = {};
	errorObj.opstatus = kony.sdk.errorcodes.invalid_session_or_token_expiry
	errorObj.message = kony.sdk.errormessages.invalid_session_or_token_expiry
	errorObj.details = {};
	errorObj.mfcode = "";
	return errorObj;
}

kony.sdk.error.getIntegrationErrObj = function(errResponse) {
		kony.sdk.logsdk.trace("Entering into kony.sdk.error.getIntegrationErrObj");
	try {
		var mfcode = errResponse[kony.sdk.constants.MF_CODE];
		var message = errResponse[kony.sdk.constants.MF_ERROR_MSG];
		var details = errResponse["mferrmsg"];
		var service = errResponse[kony.sdk.constants.MF_SERVICE];
		if (!service) {
			service = "";
		}
		if (!details) {
			details = "";
		}
		var errorMessagePrefixForIntegration = "";
		if (service) {
			errorMessagePrefixForIntegration = "Integration Service Request Failed for " + service + ":";
		} else {
			errorMessagePrefixForIntegration = "Integration Service Request Failed:";
		}
		if (mfcode) {
			return kony.sdk.error.getMFcodeErrObj(mfcode, message, details, errorMessagePrefixForIntegration);
		}
		return errResponse;
	} catch (err) {
		return errResponse;
	}
}

kony.sdk.error.getLogicErrObj = function(errResponse) {
		kony.sdk.logsdk.trace("Entering into kony.sdk.error.getLogicErrObj");
	try {
		var mfcode = errResponse[kony.sdk.constants.MF_CODE];
		var message = errResponse[kony.sdk.constants.MF_ERROR_MSG];
		var details = errResponse["mferrmsg"];
		var service = errResponse[kony.sdk.constants.MF_SERVICE];
		if (!service) {
			service = "";
		}
		if (!details) {
			details = "";
		}
		
		var errorMessagePrefixForLogic = "";
		if (service) {
			errorMessagePrefixForLogic = "Logic Service Request Failed for " + service + ":";
		} else {
			errorMessagePrefixForLogic = "Logic Service Request Failed:";
		}
		if (mfcode) {
			return kony.sdk.error.getMFcodeErrObj(mfcode, message, details, errorMessagePrefixForLogic);
		}
		return errResponse;
	} catch (err) {
		return errResponse;
	}
}

kony.sdk.error.getMFcodeErrObj = function(mfcode, message, details, errMessagePrefix) {
		kony.sdk.logsdk.trace("Entering into kony.sdk.error.getMFcodeErrObj");
	var errorObj = {};
	errorObj.details = {};
	if (details) {
		errorObj.details = details;
	}
	errorObj.mfcode = mfcode;
	if (mfcode === "Auth-4") {
		if (!message) {
			message = kony.sdk.errormessages.invalid_user_credentials
		}
		errorObj.opstatus = kony.sdk.errorcodes.invalid_user_credentials
		errorObj.message = errMessagePrefix + message;

	} else if (mfcode === "Auth-9") {
		if (!message) {
			message = kony.sdk.errormessages.invalid_app_credentials
		}
		errorObj.opstatus = kony.sdk.errorcodes.invalid_app_credentials
		errorObj.message = errMessagePrefix + message;
	} else if (mfcode === "Auth-3") {
		if (!message) {
			message = kony.sdk.errormessages.invalid_user_app_credentials
		}
		errorObj.opstatus = kony.sdk.errorcodes.invalid_user_app_credentials
		errorObj.message = errMessagePrefix + message;
	} else if ((mfcode === "Auth-5") || (mfcode === "Auth-6") || (mfcode === "Gateway-31") || (mfcode === "Gateway-33") || (mfcode === "Gateway-35") || (mfcode === "Gateway-36") || (mfcode === "Auth-46") || (mfcode === "Auth-55")) {
		errorObj.opstatus = kony.sdk.errorcodes.invalid_session_or_token_expiry
		errorObj.message = errMessagePrefix + kony.sdk.errormessages.invalid_session_or_token_expiry
	} else if (mfcode === "Auth-7" || mfcode === "Auth-27") {
		if (!message) {
			message = errMessagePrefix + kony.sdk.errormessages.invalid_user_app_services
		}
		errorObj.opstatus = kony.sdk.errorcodes.invalid_user_app_services
		errorObj.message = message;
	} else {
		errorObj.opstatus = kony.sdk.errorcodes.default_code
		errorObj.message = errMessagePrefix + kony.sdk.errormessages.default_message
	}
	return errorObj;
}

function getAuthErrorMessage(mfcode) {
		kony.sdk.logsdk.trace("Entering into getAuthErrorMessage");
	if (mfcode === "Auth-4") {
		return kony.sdk.errormessages.invalid_user_credentials
	} else if (mfcode === "Auth-9") {
		return kony.sdk.errormessages.invalid_app_credentials
	} else if (mfcode === "Auth-3") {
		return kony.sdk.errormessages.invalid_user_app_credentials
	} else if ((mfcode === "Auth-5") || (mfcode === "Auth-6") || (mfcode === "Gateway-31") || (mfcode === "Gateway-33") || (mfcode === "Gateway-35") || (mfcode === "Gateway-36") || (mfcode === "Auth-46") || (mfcode === "Auth-55")) {
		return kony.sdk.errormessages.invalid_session_or_token_expiry
	} else if (mfcode === "Auth-7" || mfcode === "Auth-27") {
		return kony.sdk.errormessages.invalid_user_app_services
	} else {
		return mfcode + ":" + kony.sdk.errormessages.default_message
	}
}

kony.sdk.error.getObjectServiceErrObj = function(errResponse) {
		kony.sdk.logsdk.trace("Entering into kony.sdk.error.getObjectServiceErrObj");
	try {
		var mfcode = errResponse[kony.sdk.constants.MF_CODE];
		var message = errResponse[kony.sdk.constants.MF_ERROR_MSG];
		var details = errResponse["mferrmsg"];
		var service = errResponse[kony.sdk.constants.MF_SERVICE];
		if (!service) {
			service = "";
		}
		if (!details) {
			details = "";
		}
		var errorMessagePrefixForIntegration = "";
		if (service) {
			errorMessagePrefixForIntegration = "Object Service Request Failed for " + service + ":";
		} else {
			errorMessagePrefixForIntegration = "Object Service Request Failed:";
		}
		
		if (mfcode) {
			return kony.sdk.error.getMFcodeErrObj(mfcode, message, details, errorMessagePrefixForIntegration);
		}
		return errResponse;
	} catch (err) {
		return errResponse;
	}
}

kony.sdk.error.getClientErrObj = function(errCode,errMsg){
		kony.sdk.logsdk.trace("Entering into kony.sdk.error.getClientErrObj");
	var errObj = new Object();
	errObj.opstatus = kony.sdk.errorcodes.clientvalidation_error_opstatus;
	errObj.errmsg = errMsg;
	errObj.errcode = errCode;
	return errObj;
}

kony.sdk.error.getMessagingError = function(errMsg){
		kony.sdk.logsdk.trace("Entering into kony.sdk.error.getMessagingError");
    var errObj = new Object();
    errObj.opstatus = kony.sdk.errorcodes.messaging_service_fail;
    errObj.errmsg = kony.sdk.errormessages.messaging_service_fail + errMsg;
    errObj.errcode = kony.sdk.errorcodes.messaging_service_fail;
    return errObj;
}

kony.sdk.error.getConfigServiceErrObject = function(errResponse) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.error.getConfigServiceErrObject");
    try {
        var mfcode = errResponse[kony.sdk.constants.MF_CODE];
        var message = errResponse[kony.sdk.constants.MF_ERROR_MSG];
        var details = errResponse["mferrmsg"];
        var service = errResponse[kony.sdk.constants.MF_SERVICE];
        if (!service) {
            service = "";
        }
        if (!details) {
            details = "";
        }
        var errorMessagePrefixForIntegration = "";
        if (service) {
            errorMessagePrefixForIntegration = "Configuration Service Request Failed for " + service + ":";
        } else {
            errorMessagePrefixForIntegration = "Configuration Service Request Failed:";
        }

        if (mfcode) {
            return kony.sdk.error.getMFcodeErrObj(mfcode, message, details, errorMessagePrefixForIntegration);
        }
        return errResponse;
    } catch (err) {
        return errResponse;
    }
};

kony.sdk.error.getIntegrityErrorMessage = function (httpRequest,url) {
	kony.sdk.logsdk.trace("Entering into kony.sdk.error.getIntegrityErrorMessage");
    var errorMessage={};
    errorMessage.httpresponse = {};
    errorMessage[kony.sdk.constants.MF_OPSTATUS]=kony.sdk.errorcodes.integrity_check_failed;
    errorMessage[kony.sdk.constants.MF_ERROR_MSG]= kony.sdk.errormessages.integrity_check_failed;
    errorMessage[kony.sdk.constants.MF_ERROR_CODE]=kony.sdk.errorcodes.integrity_check_failed;
    errorMessage[kony.sdk.constants.HTTP_STATUS_CODE] = httpRequest.status.toString();
    errorMessage.httpresponse["response"]= httpRequest.response;
    errorMessage.httpresponse.headers = httpRequest.getAllResponseHeaders();
    errorMessage.httpresponse.url = url;
    errorMessage.httpresponse.responsecode = httpRequest.status.toString();
    return errorMessage;
};

kony.sdk.error.getOperationFailedErrorMessage = function(httpRequest,url){
    kony.sdk.logsdk.trace("Entering into kony.sdk.error.getOperationFailedErrorMessage");
    var errorMessage = {};
    errorMessage[kony.sdk.constants.MF_OPSTATUS]=httpRequest.response.opstatus;
    errorMessage[kony.sdk.constants.MF_ERROR_MSG]= kony.sdk.errormessages.server_operation_failed;
    errorMessage[kony.sdk.constants.MF_ERROR_CODE]=kony.sdk.errorcodes.server_operation_failed;
    errorMessage[kony.sdk.constants.HTTP_STATUS_CODE] = httpRequest.status.toString();
    var httpResponse = {};
    httpResponse.response = httpRequest.response;
    httpResponse.headers = httpRequest.getAllResponseHeaders();
    httpResponse.responsecode = httpRequest.status.toString();
    httpResponse.url = url;
    errorMessage.httpResponse = httpResponse;
	return errorMessage;
};
if (typeof(kony.sdk) === "undefined") {
	kony.sdk = {};
}

if (typeof(kony.sdk.errorcodes) === "undefined") {
	kony.sdk.errorcodes = {};
}

if (typeof(kony.sdk.errormessages) === "undefined") {
	kony.sdk.errormessages = {};
}

kony.sdk.errorcodes.invalid_user_credentials = 101;
kony.sdk.errormessages.invalid_user_credentials = "Invalid User Credentials.";

kony.sdk.errorcodes.invalid_app_credentials = 102;
kony.sdk.errormessages.invalid_app_credentials = "Invalid App Credentials.";

kony.sdk.errorcodes.invalid_user_app_credentials = 103;
kony.sdk.errormessages.invalid_user_app_credentials = "Invalid User/App Credentials.";

kony.sdk.errorcodes.invalid_session_or_token_expiry = 104;
kony.sdk.errormessages.invalid_session_or_token_expiry = "Session/Token got invalidated in the backend.Please login.";

kony.sdk.errorcodes.invalid_user_app_services = 105;
kony.sdk.errormessages.invalid_user_app_services = "Invalid provider in appServices.";

kony.sdk.errorcodes.cliams_token_null = 106;
kony.sdk.errormessages.cliams_token_null = "Claims Token is Unavialable";

kony.sdk.errorcodes.identity_session_inactive= 107;
kony.sdk.errormessages.identity_session_inactive = "Identity Provider's sessions is not active. Please login";

kony.sdk.errorcodes.default_code = 100;
kony.sdk.errormessages.default_message = "UnhandledMFcode";

kony.sdk.errorcodes.unknown_error_code = 1000;
kony.sdk.errormessages.unknown_error_message = "An unknown error has occured";

kony.sdk.errorcodes.connectivity_error_code = 1011;
kony.sdk.errormessages.connectivity_error_message = "An error occurred while making the request. Please check device connectivity, server url and request parameters";

kony.sdk.errorcodes.invalid_json_code = 1013;
kony.sdk.errormessages.invalid_json_message = "Invalid Json response was returned";

kony.sdk.errorcodes.request_timed_out_code = 1014;
kony.sdk.errormessages.request_timed_out_message = "Request to server has timed out";

kony.sdk.errorcodes.offline_auth_failed = 1015;
kony.sdk.errormessages.offline_auth_failed = "Offline Authentication failed, User should atleast login once when network connectivity is available.";

kony.sdk.errorcodes.servicedoc_unavailable= 1016;
kony.sdk.errormessages.servicedoc_unavailable = "MBAAS app is not initialized properly. Service document is unavailable.";

kony.sdk.errorcodes.transient_login_fail= 1017;
kony.sdk.errormessages.transient_login_fail= "Transient Login failed, Previous Identity Token expired in backend.";

kony.sdk.errorcodes.messaging_service_fail= 1018;
kony.sdk.errormessages.messaging_service_fail= "Failure in Messaging Service. ";

kony.sdk.errorcodes.integrity_check_failed= 1019;
kony.sdk.errormessages.integrity_check_failed= "Http message Body Integrity Check failed.";

kony.sdk.errorcodes.invalid_security_key = 1023;
kony.sdk.errormessages.invalid_security_key = "Security key should be a non empty string.";

kony.sdk.errorcodes.server_operation_failed = 1020;
kony.sdk.errormessages.server_operation_failed = "Operation Failed on server";

kony.sdk.errorcodes.populating_template_failed = 1021;
kony.sdk.errormessages.populating_template_failed = "Template population failed, template parameters are invalid or template is malformed";

kony.sdk.errorcodes.service_unavailable = 1022;
kony.sdk.errormessages.service_unavailable_message = "Service unavailable or cannot connect to host";

kony.sdk.errorcodes.clientvalidation_error_opstatus = 112233;

//Invaild API's for phonegap and plain-js
kony.sdk.errorcodes.invalid_api = 7000;
kony.sdk.errormessages.invalid_api ="Invalid Operation name, Operation Failed.";

//Object Service Error Messages
kony.sdk.errorcodes.invalid_dataobject_instance = 90001;
kony.sdk.errormessages.invalid_dataobject_instance = "Provided dataobject is invalid and should be instance of kony.sdk.dto.DataObject";

kony.sdk.errorcodes.primarykey_unavailable = 90002;
kony.sdk.errormessages.primarykey_unavailable = "Primary Keys missing, Operation Failed";

kony.sdk.errorcodes.null_or_undefined = 90003;
kony.sdk.errormessages.null_or_undefined = " cannot be null or undefined";

kony.sdk.errorcodes.transaction_failed = 90004;
kony.sdk.errormessages.transaction_failed = "Some error occurred, Operation Failed";

kony.sdk.errorcodes.norecords_to_delete = 90005;
kony.sdk.errormessages.norecords_to_delete = "No records deleted with the specified criteria";

kony.sdk.errorcodes.invalid_queryparams_instance = 90006;
kony.sdk.errormessages.invalid_queryparams_instance = "Provided queryParams is invalid and should be a json object";

kony.sdk.errorcodes.invalid_params_instance = 90007;
kony.sdk.errormessages.invalid_params_instance = "Provided params are invalid";

kony.sdk.errorcodes.invalid_object = 90008;
kony.sdk.errormessages.invalid_object = "Invalid object name, Operation Failed.";

kony.sdk.errorcodes.invalid_blob = 90009;
kony.sdk.errormessages.invalid_blob = "Failed to read from binary file, either the file does not exist or invalid";

kony.sdk.errorConstants = {
    INIT_FAILURE: "INIT_FAILURE",
    DATA_STORE_EXCEPTION: "DATASTORE_FAILURE",
    AUTH_FAILURE: "AUTH_FAILURE",
    INTEGRATION_FAILURE: "INTEGRATION_FAILURE",
    MESSAGING_FAILURE: "MESSAGING_FAILURE",
    SYNC_FAILURE: "SYNC_FAILURE",
    METRICS_FAILURE: "METRICS_FAILURE",
    MISC_FAILURE: "MISCELLANEOUS_FAILURE",
    OBJECT_FAILURE: "OBJECT_FAILURE",
    LOGIC_SERVICE_FAILURE: "LOGIC_SERVICE_FAILURE",
    SYNC_V2_FAILURE: "SYNC_V2_FAILURE",
    CONFIGURATION_URL_FAILURE: "CONFIGURATION_URL_FAILURE",
    CONFIGURATION_FAILURE: "CONFIGURATION_FAILURE",
    INTEGRITY_FAILURE: "INTEGRITY_FAILURE",
    INVALID_API_FAILURE:"INVALID_API_FAILURE"
};
/**
 * Method to create the Identity service instance with the provided provider name.
 * @param {string} providerName - Name of the provider
 * @returns {IdentityService} Identity service instance
 */

kony.sdk.offline = kony.sdk.offline || {};
kony.sdk.sso = kony.sdk.sso || {};
kony.sdk.isSSOLoginSuccess = kony.sdk.isSSOLoginSuccess || true;
 
kony.sdk.prototype.getIdentityService = function(providerName) {
	kony.sdk.logsdk.trace("Entering kony.sdk.prototype.getIdentityService");
	if (!kony.sdk.isInitialized) {
		throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, kony.sdk.constants.INIT_FAILURE_MESSAGE + " Identity service.");
	}
	var provider = null;
	if (providerName) {
		if (this.login != null) {
			for (var i = 0; i < this.login.length; i++) {
				var rec = this.login[i];
				if ((rec.alias && rec.alias.toUpperCase() === providerName.toUpperCase()) || (rec.prov.toUpperCase() === providerName.toUpperCase())) {
					provider = new IdentityService(this, rec);
					break;
				}

			}
			if (provider === null) {
				throw new Exception(kony.sdk.errorConstants.AUTH_FAILURE, "Invalid providerName");
			}
			//TODO: what if the providerName is not passed by the user? 
            kony.sdk.logsdk.debug("### auth:: returning authService for providerName = " + provider.getProviderName());
			return provider;
		}
	} else {
		throw new Exception(kony.sdk.errorConstants.AUTH_FAILURE, "Invalid providerName");
	}
};
/**
 * Should not be called by the developer.
 * @class
 * @classdesc Identity service instance for handling login/logout calls.
 */
function IdentityService(konyRef, rec) {
    kony.sdk.logsdk.trace("Entering IdentityService");
	var networkProvider = new konyNetworkProvider();
    var dataStore = new konyDataStore();
	var serviceObj = rec;
	konyRef.rec = rec;
	var mainRef = konyRef.mainRef;
	var user_attributes={};
	var offlineEnabled = false;
	var persistToken = false;
	if (serviceObj === undefined || serviceObj.prov == undefined || serviceObj.type == undefined) {
		throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, "Invalid service url and service type");
	}

	var _type = serviceObj.type;
	var _serviceUrl = stripTrailingCharacter(serviceObj.url, "/");
	var _providerName = serviceObj.prov;

    kony.sdk.logsdk.debug("### AuthService:: initialized for provider " + _providerName + " with type " + _type);

    function isLoggedIn() {
        if (kony.sdk.getCurrentInstance() &&
            kony.sdk.getCurrentInstance().tokens &&
            kony.sdk.getCurrentInstance().tokens.hasOwnProperty(_providerName) &&
            !kony.sdk.isNullOrUndefined(kony.sdk.getCurrentInstance().tokens[_providerName]) &&
            Object.keys(kony.sdk.getCurrentInstance().tokens[_providerName]).length !== 0) {
            return true;
        }
        return false;
    }

	var dsKey = _serviceUrl + "::" + _providerName + "::" + _type + "::RAW";

	function resetAllCurrentTokens(konyRef, _providerName) {
		kony.sdk.resetProviderKeys(konyRef, _providerName);
	}

	/**
	 * Login with the given credentials asynchronously and executes the given callback.
	 * @param {object} options - User name and password
	 * @param {function} successCallback  - Callback method on success
	 * @param {function} failureCallback - Callback method on failure
	 */
	this.login = function(options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering Login");
		var continueOnRefreshError = true;

        var reportingData = kony.sdk.getEncodedReportingParamsForSvcid("login_" + _providerName);

        kony.sdk.logsdk.debug("### AuthService::login Invoked login for provider " + _providerName + " of type " + _type);
		if (typeof(options) == 'undefined') {
			throw new Exception(kony.sdk.errorConstants.AUTH_FAILURE, "Missing required number of arguments to login function");
		}
        if(options && options["loginOptions"] && options["loginOptions"]["continueOnRefreshError"] === false){
            continueOnRefreshError  = false;
        }

        //#ifdef PLATFORM_NATIVE_ANDROID_IOS
        if(options && options["loginOptions"] && options["loginOptions"]["persistLoginResponse"] === true){
            persistToken  = true;
            dataStore.setItem("persistLoginResponseFlag", true);
            kony.sdk.offline.persistToken = true;
        }
		//#endif

		if(options && options["loginOptions"])
		{
		    offlineEnabled = options["loginOptions"]["isOfflineEnabled"] || false;
			kony.sdk.offline.isOfflineEnabled = kony.sdk.offline.isOfflineEnabled || offlineEnabled;
			kony.sdk.sso.isSSOEnabled = options["loginOptions"]["isSSOEnabled"] || false;
		}
		else
		{
			kony.sdk.sso.isSSOEnabled = false;
		}
			
		function invokeAjaxCall(url, params, headers) {

			if (!headers) {
				headers = {};
			}
			if(!kony.sdk.isNullOrUndefined(konyRef.currentClaimToken) && (new Date().getTime() < konyRef.claimTokenExpiry)){
				headers[kony.sdk.constants.KONY_AUTHORIZATION_HEADER] = konyRef.currentClaimToken;
			}
			headers[kony.sdk.constants.APP_KEY_HEADER] = mainRef.appKey;
			headers[kony.sdk.constants.APP_SECRET_HEADER] = mainRef.appSecret;
			headers[kony.sdk.constants.SDK_TYPE_HEADER] = kony.sdk.getSdkType();
			headers[kony.sdk.constants.SDK_VERSION_HEADER] = kony.sdk.version;
			headers[kony.sdk.constants.PLATFORM_TYPE_HEADER] = kony.sdk.getPlatformName();
			headers[kony.sdk.constants.HTTP_REQUEST_HEADER_ACCEPT] = kony.sdk.constants.CONTENT_TYPE_JSON;
            headers[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_FORM_URL_ENCODED;

            populateHeaderWithFabricAppVersion(headers);

			if(konyRef.reportingheaders_allowed) {
                if (reportingData != null && reportingData != undefined) {
                    try {
                        headers[kony.sdk.constants.REPORTING_HEADER] = reportingData;
                    } catch (error) {
                        kony.sdk.logsdk.error("### login::error while parsing metrics payload" + error);
                    }
                }
            }

			if(kony.sdk.sso.isSSOEnabled === true)
			{
				var ssotoken = kony.sdk.util.getSSOTokenForProvider(_providerName);
				if(!kony.sdk.util.isNullOrEmptyString(ssotoken)){
					headers[kony.sdk.constants.AUTHORIZATION_HEADER] = ssotoken;
				}
			}

			var endPointUrl = null;
			if (_type === "anonymous") {
				endPointUrl = _serviceUrl + url;
			} else {
				endPointUrl = _serviceUrl + url + "?provider=" + _providerName;
				params["provider"] = _providerName;
			}

            //#ifdef PLATFORM_NATIVE_ANDROID_IOS
			if(kony.sdk.getPlatformName() !== kony.sdk.constants.PLATFORM_WINDOWS) {
				//Save the user entered form data to a temporary store and only if login is successful, we store the value in this to proper credentials store.
				if (kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE && (_type === "basic" || (options && options["userid"] && options["password"])) && offlineEnabled === true) {
					kony.sdk.offline.saveTempUserCredentials(options);

					if (!kony.sdk.isNetworkAvailable()) {
						kony.sdk.offline.loginOffline(_providerName, function (cachedAuthResponse) {
                            kony.sdk.logsdk.info("successfully authenticated offline");
							processLoginSuccessResponse(cachedAuthResponse, konyRef, true, successCallback);
						}, function (error) {
                            kony.sdk.logsdk.error("offline authentication also failed");
							resetAllCurrentTokens(konyRef, _providerName);
							if (failureCallback) {
								failureCallback(kony.sdk.error.getAuthErrObj(error));
							}
						});
						return;
					}
				}
			}
			//#endif

			if (options && options["include_profile"]) {
			    params["include_profile"] = params["include_profile"] ? params["include_profile"] : options["include_profile"];
		    }
			var networkOptions = {};
			if(options && options["httpRequestOptions"] && options["httpRequestOptions"] instanceof Object){
				networkOptions["httpRequestOptions"] = options["httpRequestOptions"];
			}
			networkProvider.post(endPointUrl, params, headers,
				function(data) {
                    var response = processLoginSuccessResponse(data, konyRef, false);

                    function serviceDocCallback(){
                        kony.sdk.verifyAndCallClosure(successCallback, response);
                    }

                    getLatestServiceDocIfAvailable(data, serviceDocCallback);
				},
				function(data) {
					processLoginErrorResponse(data,konyRef,true,failureCallback) 
				},null, networkOptions);
		}

		function loginHelper(url,params,headers,isError){
            if(isError){
                var error = {};
                err.message = "Login Failed";
                err.opstatus = kony.sdk.errorcodes.transient_login_fail;
                err.code = (params && params.error)? params.error : "";
                kony.sdk.verifyAndCallClosure(failureCallback,err);
                return;
            }
			kony.sdk.logsdk.trace("Entering loginHelper");
			if(!kony.sdk.isNullOrUndefined(konyRef.currentClaimToken) && !konyRef.isAnonymousProvider){
				kony.sdk.claimsRefresh(function(res){
					invokeAjaxCall(url,params,headers)
				},function(err){
					if(continueOnRefreshError ){
                        kony.sdk.logsdk.error("### AuthService::login claimsRefresh failed, performing force login");
						invokeAjaxCall(url,params,headers);
					}else{
                        kony.sdk.logsdk.error("### AuthService::login claimsRefresh failed, invoking failurecallback");
						err.message = kony.sdk.errormessages.transient_login_fail;
						err.opstatus = kony.sdk.errorcodes.transient_login_fail;
						kony.sdk.verifyAndCallClosure(failureCallback,err);
					}
				})
			}else{
                kony.sdk.logsdk.info("### AuthService::login Claims token unavailable, performing regular login");
				invokeAjaxCall(url,params,headers);
			}
		}

        /**
         * Login once the deeplink redirection is done. .
         * @param {map} options
         */
        function loginForDeeplink(options){
			kony.sdk.logsdk.trace("Entering loginForDeeplink");
            if (options){
                var code = options[kony.sdk.constants.DEEPLINK_VALID_PARAM];
                var urlType = options["urlType"];

                try {
                    kony.sdk.logsdk.debug("### AuthService::login received authorization code");
                    loginHelper("/" + urlType + "/" + "token", {
                        code: code
                    }, {});
                } catch (err) {
                    kony.sdk.logsdk.error("exception ::" + err);
                    failureCallback();
                }
            }
        }

		if (_type === "anonymous") {
			konyRef.isAnonymousProvider = true;
            kony.sdk.logsdk.info("### AuthService::login Adapter type is anonymous");
			loginHelper("/login", {}, {});
		} else if (_type == "basic") {
			var mandatory_fields = ["userid", "password"];
			if(kony.sdk.sso.isSSOEnabled === false)
			{
				if (serviceObj.mandatory_fields && kony.sdk.isArray(serviceObj.mandatory_fields)) {
					mandatory_fields = serviceObj.mandatory_fields;
				}
				for (var i = 0; i < mandatory_fields.length; ++i) {
					if (kony.sdk.isNullOrUndefined(options[mandatory_fields[i]])) {
						throw new Exception(kony.sdk.errorConstants.AUTH_FAILURE, " Require " + mandatory_fields[i]);
					}
				}
			}
			var payload = {};
			var encryptedStorage = {};
			if(options!=null && options!=undefined)
			{
				for (var option in options) {
					payload[option] = options[option];
				}
			}
			payload["provider"] = _providerName;

            kony.sdk.logsdk.info("### AuthService::login Adapter type is basic");
			loginHelper("/login", payload, {});
		} else {
			if (options && options.userid && options.password) {
				var payload = {};
				for(var option in options){
					payload[option] = options[option];
				}
				payload["provider"] = _providerName;
				loginHelper("/login",payload);
			} else {
                kony.sdk.logsdk.debug("### AuthService::login Adapter type is " + _type);
				if(kony.sdk.isSSOLoginSuccess && kony.sdk.sso.isSSOEnabled == true && kony.sdk.util.getSSOToken()!=null && kony.sdk.util.getSSOToken()!="" && kony.sdk.util.getSSOToken()!=undefined) {
					if(_type === "oauth2"){
                        loginHelper("/oauth2/token", {}, {});
					} else if (_type === "saml") {
                        loginHelper("/saml/token", {}, {});
                    } else {
                        loginHelper("/login", {}, {});
                    }
				} else {
					//To provide backward compatibility, if MF is an older it will not have the changes for blocking the popup or opening the login url in the native browser.
					//Identity will add a new tuple in the service doc "identity_meta". SDK will validate the compatibility with the existance of serviceDoc["identity_meta"][<priovider_name>]["success_url"]
					var isMFVersionCompatible = false;
                    var oauthOptions = {};
                    if (options &&
                        options["loginOptions"] &&
                        options["loginOptions"]["customQueryParamsForOAuth"] &&
                        options["loginOptions"]["customQueryParamsForOAuth"] instanceof Object) {
                        oauthOptions["customQueryParamsForOAuth"] = options["loginOptions"]["customQueryParamsForOAuth"];
                    }

                    if (mainRef &&
						mainRef.config &&
						mainRef.config.identity_meta &&
						mainRef.config.identity_meta[_providerName] &&
						mainRef.config.identity_meta[_providerName].success_url) {
                        isMFVersionCompatible = true;
                    }

					if (kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_PLAIN_JS){
                        //Case to handle plain-js OAuth flow.
						// Popup needs to be blocked for oauth2 type & redirect to the url "success_url" if provided in query params else the default one declared in the MF application.
                        if (options && options["noPopup"]){
                            oauthOptions["noPopup"] = true
                        }

                        if (options && options[kony.sdk.constants.DEEPLINK_VALID_PARAM] && options["urlType"]){
                            //Validating the identity service once after deeplink is redirected. Params "code" & "urlType" are mandatory and are used to distinguish the request.
                            loginForDeeplink(options);
                        }else {
                            oauthOptions["appSecret"] = mainRef.appSecret;
                            oauthOptions["serviceDoc"] = mainRef.config;
                            if(options && options["include_profile"]){
                                oauthOptions["include_profile"] = options["include_profile"]
                            }
                            OAuthHandler(_serviceUrl, _providerName, mainRef.appKey, loginHelper, _type, oauthOptions, isMFVersionCompatible);
                        }
					} else{
                        if(kony.sdk.util.hasBrowserWidget(options)) {
                            //Case to handle OAuth for IDE
                            oauthOptions[kony.sdk.constants.BROWSER_WIDGET] = options[kony.sdk.constants.BROWSER_WIDGET];
                        } else {
                            //Default case if param browserWidget and UseDeviceBrowser not present. We create one browser widget and open the url in it.
                            if (options && options["UseDeviceBrowser"]) {
                                //Validating to check the existence of param "UseDeviceBrowser".
                                // if found login url will be opened in device native broser, else in browser widget.
                                oauthOptions["UseDeviceBrowser"] = options["UseDeviceBrowser"];
                            }
                            if (options && options[kony.sdk.constants.OAUTH_REDIRECT_SUCCESS_URL]) {
                                //Validating to check the existence of param "success_url".
                                // if found after login success we will redirect to the url specified in param "success_url".
                                var success_url = options[kony.sdk.constants.OAUTH_REDIRECT_SUCCESS_URL];
                                //Encoding is being done specifically for android because, in android kony.application.openUrl is not
                                // opening the url without encoding where as in ios its encoding and opening.
                                if (kony.sdk.getPlatformName() === kony.sdk.constants.PLATFORM_ANDROID) {
                                    //decoding and encoding, to handle the case where in the user himself is giving us the encoded value.
                                    success_url = encodeURIComponent(decodeURIComponent(options[kony.sdk.constants.OAUTH_REDIRECT_SUCCESS_URL]));
                                }
                                oauthOptions[kony.sdk.constants.OAUTH_REDIRECT_SUCCESS_URL] = success_url;
                            }
                        }

                        if (options && kony.sdk.util.isValidString(options[kony.sdk.constants.IE11_CROSS_DOMAIN_OAUTH_BASE_URL])) {
                            oauthOptions[kony.sdk.constants.IE11_CROSS_DOMAIN_OAUTH_BASE_URL] = options[kony.sdk.constants.IE11_CROSS_DOMAIN_OAUTH_BASE_URL];
                        }

                        OAuthHandler(_serviceUrl, _providerName, mainRef.appKey, loginHelper, _type, oauthOptions, isMFVersionCompatible);
					}
				}
			}
		}
	};

    //#ifdef PLATFORM_NATIVE_ANDROID_IOS
    /**
     * Tries to get persisted token from local store and update sdk.
     */
	this.usePersistedLogin = function(){
		kony.sdk.logsdk.trace("Entering usePersistedLogin");
		var stringifiedResponse = kony.sdk.offline.getUserAuthInformation("persistedAuthResponse");
		if(stringifiedResponse && kony.sdk.isJson(stringifiedResponse)){
			var persistedAuthResponse = JSON.parse(stringifiedResponse);

			// To support multilogin we are checking for the existence of provider name in profiles.
			if(persistedAuthResponse && persistedAuthResponse.profiles && persistedAuthResponse.profiles[_providerName]){
				konyRef.isAnonymousProvider = false;
				processMultipleProvidersResponse(persistedAuthResponse, _providerName);
				return true;
			}
		}
		return false;
	};
	//#endif

	var processMultipleProvidersResponse = function(data, providerName){

        if (data && data.profiles) {
        	konyRef.isAnonymousProvider = false;
            for (var provider in data.profiles) {
                if (!konyRef.tokens[provider]) {
                    konyRef.tokens[provider] = {};
                }
                konyRef.tokens[provider].profile = data.profiles[provider];
            }
        } else if (data && providerName && data.profile) {
            konyRef.isAnonymousProvider = false;
            konyRef.tokens[providerName].profile = data.profile;
        }


        if(data && data.provider_tokens){
            for(var provider in data.provider_tokens){
                if(!konyRef.tokens[provider]){
                    konyRef.tokens[provider] = {};
                }
                if(!konyRef.tokens[provider].provider_token){
                    konyRef.tokens[provider].provider_token = {}
                }
                konyRef.tokens[provider].provider_token.value = data.provider_tokens[provider];
            }
        }
		
		if(data && providerName && data.provider_token){
            konyRef.tokens[providerName].provider_token = data.provider_token;
        }


		konyRef.currentClaimToken = data.claims_token.value;
		konyRef.claimTokenExpiry = data.claims_token.exp;
		konyRef.currentRefreshToken = data.refresh_token;
	};

    var processLoginSuccessResponse = function(data,konyRef,isAsync,callBack){
		kony.sdk.logsdk.trace("Entering processLoginSuccessResponse");
        data = kony.sdk.formatSuccessResponse(data);
		if(_type !== "anonymous" &&!konyRef.tokens[_providerName]){
			konyRef.tokens[_providerName] = {};
		}
        kony.sdk.logsdk.info("### AuthService::login successful. Retrieved Data::");
		processMultipleProvidersResponse(data, _providerName);
        kony.sdk.logsdk.info("### AuthService::login extracted token. Calling success callback");

		if(kony.sdk.sso.isSSOEnabled === true)
		{	
			if(data.sso_token) {

                var isSSOSaved = kony.sdk.util.saveSSOToken(kony.sdk.util.addOrUpdateSSOTokenWithProvider(data.sso_token, _providerName));
				if (isSSOSaved === true){
					kony.sdk.isSSOLoginSuccess = true;
                    kony.sdk.logsdk.info("### SSOLoginService::SSOToken being saved successfully.");
				} else {
                    kony.sdk.logsdk.info("### SSOLoginService::Failed to save SSOToken.This might result in failure of corresponding sso Logins. Please check the configuration params");
				}
			}else{
                kony.sdk.logsdk.info("### SSOLoginService::Unable to fetch sso token.");
			}
		}
		
		if (data.profile && data.profile!=undefined && data.profile.user_attributes!=undefined) {
			user_attributes = data.profile.user_attributes;
		}
		if (data.profile) {
			kony.sdk.overrideUserId(data.profile.userid);
		}

		if(kony.sdk.getPlatformName() !== kony.sdk.constants.PLATFORM_WINDOWS && kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE) {
            //We store the user credentials and the success auth response only on successful online login.
            if (kony.sdk.offline.isOfflineEnabled === true) {
                if (kony.sdk.isNetworkAvailable() && offlineEnabled && _type === "basic") {
                    kony.sdk.offline.updateSuccessUserCredentials(_providerName);
                }
                kony.sdk.offline.saveUserAuthInformation("authResponse", data);
            }

            //#ifdef PLATFORM_NATIVE_ANDROID_IOS
            if (_type !== "anonymous") {
                if (persistToken || kony.sdk.offline.persistToken || kony.sdk.util.isPersistentLoginResponseEnabled()) {
                    kony.sdk.offline.saveUserAuthInformation("persistedAuthResponse", data);
                }
            }
            //#endif
        }

		kony.logger.setClaimsToken();
		if(!isAsync){
			return {};
		}
		else if(callBack){
			kony.sdk.verifyAndCallClosure(callBack, {});
		}
    };

    var processLoginErrorResponse = function(data,konyRef,isAsync,callBack){
		kony.sdk.logsdk.trace("Entering processLoginErrorResponse");
        kony.sdk.logsdk.info("### AuthService::login Calling failure callback");

		/*resetting all the token in case of error */
		resetAllCurrentTokens(konyRef, _providerName);
		if(kony.sdk.sso.isSSOEnabled === true){
			if(data.mfcode=="Auth-55"){
				kony.sdk.util.deleteSSOToken();
			}
			kony.sdk.isSSOLoginSuccess = false;
		}
		if(!isAsync){
			return kony.sdk.error.getAuthErrObj(data);
		}
		else if(callBack){
			callBack(kony.sdk.error.getAuthErrObj(data));
		}
    };
    
	/**
	 * Login anonymous with the given credentials synchronously and executes the given callback.
	 * @param {object} options - User name and password
	 */
    this.anonymousLoginSync = function(options) {
		kony.sdk.logsdk.trace("Entering anonymousLoginSync");
		konyRef.isAnonymousProvider = false;

        var reportingData = kony.sdk.getEncodedReportingParamsForSvcid("login_" + _providerName);

        kony.sdk.logsdk.debug("### AuthService::login Invoked login for provider " + _providerName + " of type " + _type);
		if (typeof(options) == 'undefined') {
			throw new Exception(kony.sdk.errorConstants.AUTH_FAILURE, "Missing required number of arguments to login function");
		}

		function invokeAjaxCall(url, params, headers) {

			if (!headers) {
				headers = {};
			}
			headers[kony.sdk.constants.APP_KEY_HEADER] = mainRef.appKey;
			headers[kony.sdk.constants.APP_SECRET_HEADER] = mainRef.appSecret;
			headers[kony.sdk.constants.HTTP_REQUEST_HEADER_ACCEPT] = kony.sdk.constants.CONTENT_TYPE_JSON;

			if(konyRef.reportingheaders_allowed) {
                if (reportingData != null && reportingData != undefined) {
                    try {
                        headers[kony.sdk.constants.REPORTING_HEADER] = reportingData;
                    } catch (error) {
                        kony.sdk.logsdk.error("### anonymousLoginSync::error while parsing metrics payload" + error);
                    }
                }
            }

			var endPointUrl = null;
			if (_type === "anonymous") {
				endPointUrl = _serviceUrl + url;
			} else {
				endPointUrl = _serviceUrl + url + "?provider=" + _providerName;
				params["provider"] = _providerName;
			}

			var data = networkProvider.postSync(endPointUrl, params, headers);
			if(data.opstatus == 0){
               return processLoginSuccessResponse(data,konyRef,false);
			}
			else{
			   return processLoginErrorResponse(data,konyRef,false);
			}
		}
        konyRef.isAnonymousProvider = true;
        kony.sdk.logsdk.info("### AuthService::login Adapter type is anonymous");
        var headers = {};
        headers[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_FORM_URL_ENCODED;
		return invokeAjaxCall("/login", {}, headers);
	};

	/**
	 * Logout and executes the given callback.
	 * @param {function} successCallback  - Callback method on success
	 * @param {function} failureCallback - Callback method on failure
	 * @param {object} options - additional options for logout
	 */
	this.logout = function(successCallback, failureCallback, options) {
kony.sdk.logsdk.trace("Entering logout");
		function logoutHandler() {
			_logout(successCallback, failureCallback, options);
		}
		if(kony.sdk.getPlatformName() !== kony.sdk.constants.PLATFORM_WINDOWS) {
			//if the user logged in using offline logout
			if (offlineEnabled == true && kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE && _type === "basic" && !kony.sdk.isNetworkAvailable()) {
				logoutHandler();
			} else {
				kony.sdk.claimsRefresh(logoutHandler, failureCallback);
			}
		}else{
			kony.sdk.claimsRefresh(logoutHandler, failureCallback);
		}
	};

	function _logout(successCallback, failureCallback, options) {
	    function invokeLogoutHelper(formData, invokeLogoutSuccess, invokeLogoutFailure){

            var claimsTokenValue = null;

            var reportingData = kony.sdk.getEncodedReportingParamsForSvcid("logout_" + _providerName);

            if (!kony.sdk.isNullOrUndefined(konyRef.currentClaimToken)) {
                claimsTokenValue = konyRef.currentClaimToken;
            }
            formdata.provider = _providerName;
            var url = "";

            if(_type == "oauth2" && kony.sdk.getSdkType() == kony.sdk.constants.SDK_TYPE_IDE){
                url = _serviceUrl + "/oauth2/logout?provider=" + _providerName;
            }else{
                url = _serviceUrl + "/logout?provider=" + _providerName;
            }

            var headers = {};
            headers[kony.sdk.constants.KONY_AUTHORIZATION_HEADER] = claimsTokenValue;
            headers[kony.sdk.constants.HTTP_REQUEST_HEADER_ACCEPT] = "*/*";
            headers[kony.sdk.constants.HTTP_CONTENT_HEADER] =  kony.sdk.constants.CONTENT_TYPE_FORM_URL_ENCODED;

            if(konyRef.reportingheaders_allowed) {
                if (reportingData != null && reportingData != undefined) {
                    try {
                        headers[kony.sdk.constants.REPORTING_HEADER] = reportingData;
                    } catch (error) {
                        kony.sdk.logsdk.error("### login::error while parsing metrics payload" + error);
                    }
                }
            }

            populateHeaderWithFabricAppVersion(headers);

            networkProvider.post(url, formdata, headers,
            function(data) {
                kony.sdk.logsdk.info("AuthService::logout successfully logged out. Calling success callback");

				function serviceDocCallback(){
                    logoutSuccess(data);
                    return;
				}

                getLatestServiceDocIfAvailable(data, serviceDocCallback);
            },
            function(err) {
                kony.sdk.logsdk.error("### AuthService::logout logged out Failed. Calling failure callback");
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getAuthErrObj(err));
            });

        }

		function logoutSuccess(data) {
			kony.sdk.logsdk.trace("Entering logoutSuccess");
			data = kony.sdk.formatSuccessResponse(data);
			delete konyRef.tokens[_providerName];

			//reset all current keys
			kony.sdk.resetCurrentKeys(konyRef,_providerName);

			//processing multiple profiles
			if(data && data.claims_token) {
				processMultipleProvidersResponse(data);
				konyRef.isAnonymousProvider = false;
			}

            //#ifdef PLATFORM_NATIVE_ANDROID_IOS
			if(offlineEnabled){
                kony.sdk.offline.isOfflineEnabled = false;
                kony.sdk.offline.removeUserAuthInformation();
                kony.sdk.offline.removeUserCredentials(_providerName);
			}

			if(persistToken || kony.sdk.offline.persistToken || kony.sdk.util.isPersistentLoginResponseEnabled()){
                kony.sdk.offline.removePersistedUserAuthInformation();
                persistToken = false;
                kony.sdk.offline.persistToken = false;
                dataStore.setItem("persistLoginResponseFlag", false);
			}
			//#endif

			if(slo === true){
				kony.sdk.util.deleteSSOTokenForProvider(_providerName);
			}
			kony.sdk.verifyAndCallClosure(successCallback, {});
		}

        kony.sdk.logsdk.debug("### AuthService::logout invoked on provider " + _providerName + " of type " + _type);
		var slo = false;
		if(!kony.sdk.isNullOrUndefined(options) && (options["slo"] === true || options["slo"] === false)) {
			slo = options["slo"];
		}
        var formdata = {};
        formdata = {"slo": slo};

		if(!isLoggedIn()){
			kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getIdentitySessionInactiveErrObj());
		}
		else if(_type == "oauth2" && kony.sdk.getSdkType() == kony.sdk.constants.SDK_TYPE_IDE){
            var callback_invoke = true;
            var oauth_status;

            function oAuthCallback(status){
                oauth_status = status;
				//Workaround to get around redirects
                if(callback_invoke) {
                    callback_invoke = false;
                    kony.timer.schedule("oAuthCallbackHandle", function() {
						if (oauth_status)
						    invokeLogoutHelper(formdata,logoutSuccess,failureCallback);
						else
							kony.sdk.verifyAndCallClosure(failureCallback,{});
					}, 3, false);
                }
            }
			var oauthOptions = {};
			oauthOptions["logout"] = true;
			oauthOptions["slo"] = slo;
			if(kony.sdk.util.hasBrowserWidget(options)) {
				oauthOptions[kony.sdk.constants.BROWSER_WIDGET] = options[kony.sdk.constants.BROWSER_WIDGET];
			}
            OAuthHandler(_serviceUrl, _providerName, mainRef.appKey, oAuthCallback, _type, oauthOptions);
        }else {
            if(kony.sdk.getPlatformName() !== kony.sdk.constants.PLATFORM_WINDOWS) {
				//if the user logged in using offline login
				if (kony.sdk.offline.isOfflineEnabled == true && kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE && _type === "basic" && !kony.sdk.isNetworkAvailable()) {
                    kony.sdk.logsdk.info("AuthService::offline logout successfully logged out. Calling success callback");
					logoutSuccess();
					return;
				}
			}

			invokeLogoutHelper(formdata,logoutSuccess, failureCallback);
        }
	}

	/**
	 * Fetch the backend datasource token.
	 * @param {boolean} fromserver - Flag to force fetch from server only.
	 * @param {object} options - Options
	 * @param {function} successCallback  - Callback method on success
	 * @param {function} failureCallback - Callback method on failure
	 */
	this.getBackendToken = function(fromserver, options, successCallback, failureCallback) {
		kony.sdk.logsdk.trace("Entering getBackendToken");
		function _claimsRefreshSuccess(token){
			kony.sdk.logsdk.trace("Entering _claimsRefreshSuccess with valid token");
            processMultipleProvidersResponse(token);
            //konyRef.currentBackEndToken = token.provider_token;
            //if offline login enabled then updating the backend token in the store
            if(kony.sdk.getPlatformName() !== kony.sdk.constants.PLATFORM_WINDOWS && kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE) {
                if (kony.sdk.offline.isOfflineEnabled && kony.sdk.offline.isOfflineEnabled == true) {
                    kony.sdk.offline.updateAuthToken(token);
                }

                //#ifdef PLATFORM_NATIVE_ANDROID_IOS
				if (persistToken || kony.sdk.offline.persistToken || kony.sdk.util.isPersistentLoginResponseEnabled()) {
					kony.sdk.offline.updatePersistedToken("persistedAuthResponse", token);
				}
				//#endif
            }

            kony.sdk.verifyAndCallClosure(successCallback,konyRef.tokens[_providerName].provider_token);
		}

		function _claimsRefreshFailure(error){
			kony.sdk.logsdk.trace("Entering _claimsRefreshFailure");
            kony.sdk.logsdk.info("### AuthService::getBackendToken fetching refresh failed. Calling failure callback");
            // konyRef.tokens[_providerName] = null;
            // konyRef.currentBackEndToken = null;
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getAuthErrObj(error));
		}

        kony.sdk.logsdk.debug("### AuthService::getBackendToken called for provider " + _providerName + " of type " + _type);
		if(!isLoggedIn()){
			kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getIdentitySessionInactiveErrObj());
		}
		var claimsOptions = null;
		if(options && options.refresh && options.refresh === true){
            claimsOptions = {
				"requestParams": {
					"refresh": "true"
				}
			};
		}

		if (fromserver != undefined && fromserver === true) {
            kony.sdk.logsdk.info("### AuthService::getBackendToken fromserver is enabled. Trying to login");
			_claimsRefresh(claimsOptions, _claimsRefreshSuccess, _claimsRefreshFailure);
		} else {
			if (konyRef.tokens[_providerName]) {
				var val = konyRef.tokens[_providerName];
				var _exp = val.provider_token.exp;
                kony.sdk.logsdk.debug("token expiry time: " + _exp);
                kony.sdk.logsdk.debug("Current time: " + (new Date().getTime()));
				if (_exp && _exp < (new Date().getTime())) {
                    kony.sdk.logsdk.info("### AuthService::getBackendToken Token expired. Fetching refresh from claims api");
					_claimsRefresh(claimsOptions, _claimsRefreshSuccess, _claimsRefreshFailure);
				} else {
                    kony.sdk.logsdk.info("### AuthService::getBackendToken present token is valid/doesn't have expiry time. Calling success callback");
					//konyRef.currentBackEndToken = val.provider_token;
					kony.sdk.verifyAndCallClosure(successCallback, konyRef.tokens[_providerName].provider_token);
				}
			} else {
                kony.sdk.logsdk.info("### AuthService::getBackendToken failed for find info for key " + dsKey + "in database. calling failure callback");
				kony.sdk.verifyAndCallClosure(failureCallback, null);
			}
		}
	};

	/**
	 * Get profile.
	 * @param {boolean} fromserver - Flag to force fetch from server only.
	 * @param {function} successCallback  - Callback method on success
	 * @param {function} failureCallback - Callback method on failure
	 */
	this.getProfile = function(fromserver, successCallback, failureCallback) {
		kony.sdk.logsdk.trace("Entering getProfile");
		if(!isLoggedIn()){
			kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getIdentitySessionInactiveErrObj());
		}
		else if (fromserver && fromserver == true) {
			profileRefresh(
				function(token) {
					konyRef.tokens[_providerName].profile = token;
					kony.sdk.verifyAndCallClosure(successCallback, token);
				},
				failureCallback)
		} else {
			if (konyRef.tokens[_providerName]) {
				var val = konyRef.tokens[_providerName];
				kony.sdk.verifyAndCallClosure(successCallback, val.profile);
			} else {
				kony.sdk.verifyAndCallClosure(failureCallback, null);
			}
		}
	};
	/**
	 * Get the provider name.
	 * @returns {string} Provider name.
	 */
	this.getProviderName = function() {
		return _providerName;
	};
	/**
	 * Get the provider type.
	 * @returns {string} Provider type.
	 */
	this.getProviderType = function() {
		return _type;
	};

	/**
	 * Get the generic session data type.
	 * @returns {string} session data.
	 */
	this.getUserData = function(successCallback, failureCallback) {
		kony.sdk.logsdk.trace("Entering getUserData (Get the generic session data type)");
		if(!isLoggedIn()){
			kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getIdentitySessionInactiveErrObj());
		}
		else {
			var userDataUrl = _serviceUrl + "/session/user_data";
            var options = {};
            options["invokedFrom"] = kony.sdk.constants.GET_USER_DATA;
			getSessionData(userDataUrl, successCallback, failureCallback,options);
		}
	};

	/**
	 * Get the user attributes returned by a provider
	 * @returns {string} user attributes.
	 */
	this.getUserAttributes = function(successCallback, failureCallback) {
		kony.sdk.logsdk.trace("Entering getUserAttributes");
		if(!isLoggedIn()){
			kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getIdentitySessionInactiveErrObj());
		}
		else if(user_attributes && Object.keys(user_attributes).length === 0){
			var userAttributesUrl = _serviceUrl + "/session/user_attributes?provider=" + _providerName;
			var options = {};
			options["invokedFrom"] = kony.sdk.constants.GET_USER_ATTRIBUTES;
			getSessionData(userAttributesUrl, function(res){
				user_attributes = res;
				kony.sdk.verifyAndCallClosure(successCallback,user_attributes);
			}, failureCallback,options);
		}else{
			if (konyRef.currentClaimToken === null) {
				kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getNullClaimsTokenErrObj());
			}else{ 
				kony.sdk.verifyAndCallClosure(successCallback,user_attributes );
			}
		}
	};

	/**
	 * Get the security attributes returned by a provider
	 * @returns {string} security attributes.
	 */
	this.getSecurityAttributes = function(successCallback, failureCallback) {
		kony.sdk.logsdk.trace("Entering getSecurityAttributes");
		if(!isLoggedIn()){
			kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getIdentitySessionInactiveErrObj());
		}
		else {
			var securityAttributesUrl = _serviceUrl + "/session/security_attributes?provider=" + _providerName;
            var options = {};
            options["invokedFrom"] = kony.sdk.constants.GET_SECURITY_ATTRIBUTES;
			getSessionData(securityAttributesUrl, successCallback, failureCallback,options);
		}
	};

	/**
		utility method to get session data
		@private
	*/
	var getSessionData = function(sessionAttributesEndPointUrl, successCallback, failureCallback,options) {

        var svcid = null;

        if(options["invokedFrom"] == kony.sdk.constants.GET_USER_ATTRIBUTES){
            svcid = kony.sdk.constants.GET_USER_ATTRIBUTES;
		} else if(options["invokedFrom"] == kony.sdk.constants.GET_SECURITY_ATTRIBUTES){
        	svcid = kony.sdk.constants.GET_SECURITY_ATTRIBUTES;
		} else{
            svcid = kony.sdk.constants.GET_USER_DATA;
		}

		var reportingData = kony.sdk.getEncodedReportingParamsForSvcid(svcid);

		if (konyRef.currentClaimToken === null) {
			kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getNullClaimsTokenErrObj());
		}
		else{
            var headers = {};
            headers[kony.sdk.constants.AUTHORIZATION_HEADER] = konyRef.currentClaimToken;

            if(konyRef.reportingheaders_allowed) {
                if (reportingData != null && reportingData != undefined) {
                    try {
                        headers[kony.sdk.constants.REPORTING_HEADER] = reportingData;
                    } catch (error) {
                        kony.sdk.logsdk.error("### getSessionData::error while parsing metrics payload" + error);
                    }
                }
            }

            populateHeaderWithFabricAppVersion(headers);

			networkProvider.get(sessionAttributesEndPointUrl, {}, headers,
				function(data) {
				    data = kony.sdk.formatSuccessResponse(data);
					kony.sdk.verifyAndCallClosure(successCallback, data);
				},
				function(err) {
					kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getAuthErrObj(err));
				});
		}
	};



	/**
	 * Method to refresh the claims token.
	 * @private
	 */
	var _claimsRefresh = function(options, success, failure) {
        kony.sdk.logsdk.debug("### AuthService::_claimsRefresh fetching claims from server for provider " + _providerName);
		var refreshToken = null;

        var reportingData = kony.sdk.getEncodedReportingParamsForSvcid(kony.sdk.constants.GET_BACKEND_TOKEN);

		if (!kony.sdk.isNullOrUndefined(konyRef.currentRefreshToken)) {
			refreshToken = konyRef.currentRefreshToken;
		}

		var _url = _serviceUrl + "/claims";
		if (options && options.requestParams != null) {
			_url = _url + "?";
			for (var i in options.requestParams) {
				if (options.requestParams.hasOwnProperty(i) && typeof(i) !== 'function') {
					_url = _url + (i + "=" + options.requestParams[i] + "&");
				}
			}
			_url = stripTrailingCharacter(_url, "&");
		}
		if (refreshToken) {
            kony.sdk.logsdk.info("### AuthService::_claimsRefresh making POST request to claims endpoint");
            var headers = {};
            headers[kony.sdk.constants.AUTHORIZATION_HEADER] = refreshToken;
            headers[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_FORM_URL_ENCODED;

            if(konyRef.reportingheaders_allowed) {
                if (reportingData != null && reportingData != undefined) {
                    try {
                        headers[kony.sdk.constants.REPORTING_HEADER] = reportingData;
                    } catch (error) {
                        kony.sdk.logsdk.error("### _claimsRefresh::error while parsing metrics payload" + error);
                    }
                }
            }

            populateHeaderWithFabricAppVersion(headers);

			networkProvider.post(_url, {}, headers,
				function(data) {
					data = kony.sdk.formatSuccessResponse(data);
                    kony.sdk.logsdk.info("### AuthService::_claimsRefresh Fetching claims succcessfull");
					processMultipleProvidersResponse(data);
                    kony.sdk.logsdk.info("### AuthService::_claimsRefresh saved locally. Calling success callback");
					kony.sdk.verifyAndCallClosure(success, data);
				},
				function(xhr, status, err) {
                    kony.sdk.logsdk.error("### AuthService::_claimsRefresh fetching claims failed. Calling failure callback");
					kony.sdk.verifyAndCallClosure(failure, kony.sdk.error.getAuthErrObj(err));
				});
		} else {
            kony.sdk.logsdk.info("### AuthService::_claimsRefresh no refreshtoken found. calling failure callback");
			kony.sdk.verifyAndCallClosure(failure, kony.sdk.error.getNullRefreshTokenErrObj());
		}
	};

	var profileRefresh = function(success, failure) {
		kony.sdk.logsdk.trace("Entering profileRefresh");
        kony.sdk.logsdk.debug("### AuthService::profileRefresh fetching profile from server for provider " + _providerName);

        var reportingData = kony.sdk.getEncodedReportingParamsForSvcid(kony.sdk.constants.GET_PROFILE);

		var refreshToken = null;
		if (!kony.sdk.isNullOrUndefined(konyRef.currentRefreshToken)) {
			refreshToken = konyRef.currentRefreshToken;
		}

		var _url = _serviceUrl + "/profile?provider=" + _providerName;
		if (refreshToken) {
            kony.sdk.logsdk.info("### AuthService::profileRefresh making POST request to profile endpoint");
            var headers = {};
            headers[kony.sdk.constants.AUTHORIZATION_HEADER] = refreshToken;
            headers[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_FORM_URL_ENCODED;

            if(konyRef.reportingheaders_allowed) {
                if (reportingData != null && reportingData != undefined) {
                    try {
                        headers[kony.sdk.constants.REPORTING_HEADER] = reportingData;
                    } catch (error) {
                        kony.sdk.logsdk.error("### profileRefresh::error while parsing metrics payload" + error);
                    }
                }
            }

            populateHeaderWithFabricAppVersion(headers);

			networkProvider.get(_url, null, headers,
				function(data) {
					data = kony.sdk.formatSuccessResponse(data);
					konyRef.tokens[_providerName].profile = data;
                    kony.sdk.logsdk.info("### AuthService::profileRefresh Fetching profile succcessfull, Calling success callback");
					kony.sdk.verifyAndCallClosure(success, data);
				},
				function(xhr, status, err) {
                    kony.sdk.logsdk.error("### AuthService::profileRefresh fetching profile failed. Calling failure callback");
					kony.sdk.verifyAndCallClosure(failure, kony.sdk.error.getAuthErrObj(err));
				});
		} else {
            kony.sdk.logsdk.info("### AuthService::profileRefresh no refreshtoken found. calling failure callback");
			kony.sdk.verifyAndCallClosure(failure, kony.sdk.error.getNullRefreshTokenErrObj());
		}
	};
}

function konySdkLogger()
{

this.INDIRECTIONLEVEL = 1;
this.trace = function(msg, params) {
    this.getInstance().trace(msg, params);
};
this.debug = function(msg, params) {
    this.getInstance().debug(msg, params);
};
this.info = function(msg, params) {
    this.getInstance().info(msg, params);
};
this.perf = function(msg, params) {
    this.getInstance().perf(msg, params);
};
this.warn = function(msg, params) {
    this.getInstance().warn(msg, params);
};
this.error = function(msg, params) {
    this.getInstance().error(msg, params);
};
this.fatal = function(msg, params) {
    this.getInstance().fatal(msg, params);
};
this.loggerEngineInit = function() {
    KonySDKLoggerObj = kony.logger.createNewLogger(kony.sdk.constants.LOGGER_NAME, null);
    KonySDKLoggerObj.setIndirectionLevel = this.INDIRECTIONLEVEL;
};
this.getInstance = function() {
    if (typeof(KonySDKLoggerObj) === 'undefined') this.loggerEngineInit();
    return KonySDKLoggerObj;
}
}
/**
 * Method to create the logic service instance with the provided service name.
 * @param {string} serviceName - Name of the service
 * @returns The url to connect to the logic service
 * @throws Exception if the serviceName or access is invalid.
 */
kony.sdk.prototype.getLogicService = function(serviceName) {

    if (!kony.sdk.isInitialized) {
        throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, kony.sdk.constants.INIT_FAILURE_MESSAGE + " Logic service - "+serviceName);
    }

    if (this.logicsvc != null) {
        if (this.logicsvc[serviceName] != null) {
            kony.sdk.logsdk.debug("### getLogicService::found Logic service" + this.logicsvc[serviceName]);
            return new kony.sdk.LogicService(this, serviceName);
        }
    }
    throw new Exception(kony.sdk.errorConstants.LOGIC_SERVICE_FAILURE, "Invalid serviceName:"+serviceName);
};
kony.sdk.LogicService = function(konyRef, serviceName){
    this.konyRef = konyRef;
    this.serviceName = serviceName;
    this.logicServiceUrl = null;

    this.getLogicServiceUrl = function(){
        if (this.logicServiceUrl == null) {
            this.logicServiceUrl = stripTrailingCharacter(konyRef.logicsvc[serviceName], "/");
        }
        return this.logicServiceUrl;
    };

    kony.sdk.logsdk.info(" ###LogicService Created & LogicService Url = " + this.getLogicServiceUrl());
    var networkProvider = new konyNetworkProvider();
    this.invokeOperation = function(serviceName, path, methodType, headers, data, successCallback, failureCallback, options) {
        function invokeOperationHandler() {
            _invokeOperation(serviceName, path, methodType, headers, data, true, successCallback, failureCallback, options);
        }
        kony.sdk.claimsRefresh(invokeOperationHandler, failureCallback);
    };

    function invokeOperationRetry(serviceName, path, methodType, headers, data, successCallback, failureCallback, options) {
        function invokeOperationRetryHandler() {
            _invokeOperation(serviceName, path, methodType, headers, data, false, successCallback, failureCallback, options);
        }
        kony.sdk.claimsAndProviderTokenRefresh(invokeOperationRetryHandler, failureCallback);
    }

    function retryServiceCall(errorResponse){
        if(errorResponse[kony.sdk.constants.MF_CODE]){
            // check for the mf code for which,
            // retry should be done.
        } else {
            if(errorResponse[kony.sdk.constants.HTTP_STATUS_CODE] && errorResponse[kony.sdk.constants.HTTP_STATUS_CODE] === 401){
                return true;
            }
        }
    }

    function _invokeOperation(serviceName, path, methodType, headers, data, isRetryNeeded, successCallback, failureCallback, options) {

        var requestData = {};
        kony.sdk.logsdk.trace("Entered into _invokeOperation servicePath: " + serviceName + ", methodType: " + methodType + ", path" + path + ", isRetryNeeded: " + isRetryNeeded);
        var reportingData = kony.sdk.getPayload(konyRef);
        var sessionId = kony.ds.read(kony.sdk.constants.KONYUUID);
        if(sessionId){
            reportingData.rsid = sessionId[0];
        }

        if(!reportingData.rsid)
        {
            kony.sdk.logsdk.warn("rsid is either empty,null or undefined");
        }

        if (kony.sdk.metric) {
            if (kony.sdk.metric.reportEventBufferBackupArray.length === 0) {
                kony.sdk.metric.readFromDS();
            }
            kony.sdk.metric.pushEventsToBufferArray();
            requestData.events = kony.sdk.metric.reportEventBufferBackupArray;
        }

        for (var key in data) {
            requestData[key] = data[key];
        }

        reportingData.svcid = serviceName;

        requestData[kony.sdk.constants.REPORTING_PARAMS] = JSON.stringify(reportingData);
        var defaultHeaders = {};
        defaultHeaders[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_FORM_URL_ENCODED;
        defaultHeaders[kony.sdk.constants.KONY_AUTHORIZATION_HEADER]= konyRef.currentClaimToken;

        if(typeof(svcObj) === 'object' &&  svcObj.version){
            defaultHeaders[kony.sdk.constants.API_VERSION_HEADER] = svcObj.version;
        }

        // if the user has defined his own headers, use them
        if (headers) {
            for (var header in headers) {
                defaultHeaders[header] = headers[header];
            }
        }

        function networkSuccessCallback(response)
        {
            if (kony.sdk.metric) {
                kony.sdk.metric.clearBufferEvents();
            }
            kony.sdk.verifyAndCallClosure(successCallback, response);
        }

        function networkFailureCallback(xhr, status, err)
        {
            if(isRetryNeeded === true && retryServiceCall(xhr) === true){

                invokeOperationRetry(serviceName, path, methodType, headers, data, successCallback, failureCallback, options);

                return;
            }
            kony.sdk.processLogicErrorResponse(xhr,true,failureCallback);
        }
        
        switch (methodType) {
            case "GET":
                networkProvider.get(konyRef.logicsvc[serviceName]+ path,
                    requestData, defaultHeaders, networkSuccessCallback, networkFailureCallback, null, options);
                break;

            case  "PUT":
                networkProvider.put(konyRef.logicsvc[serviceName]+ path,
                    requestData, defaultHeaders, networkSuccessCallback, networkFailureCallback, null, options);
                break;

            case "DELETE":
                networkProvider.invokeDeleteRequest(konyRef.logicsvc[serviceName]+ path,
                    requestData, defaultHeaders,networkSuccessCallback, networkFailureCallback, null, options);
                break;
            default:
                networkProvider.post(konyRef.logicsvc[serviceName]+ path,
                    requestData, defaultHeaders, networkSuccessCallback, networkFailureCallback, null, options);
                break;
        }
    }

    kony.sdk.processLogicErrorResponse = function(err,isAsync,callBack){
        if (kony.sdk.metric) {
            if (kony.sdk.metric.errorCodeMap[err.opstatus]) {
                kony.sdk.metric.saveInDS();
            }
        }
        if(err[kony.sdk.constants.MF_CODE]){
            var konyRef = kony.sdk.getCurrentInstance();
            //clear the cache if the error code related to session/token expiry
            if (kony.sdk.isSessionOrTokenExpired(err[kony.sdk.constants.MF_CODE])) {
                kony.sdk.logsdk.warn("###LogicService::invokeOperationFailure  Session/Token expired. Authenticate and Try again");
                //kony.sdk.resetCacheKeys(konyRef);
            }
        }
        if(!isAsync){
            return kony.sdk.error.getLogicErrObj(err);
        }
        else if(callBack){
            kony.sdk.verifyAndCallClosure(callBack, kony.sdk.error.getLogicErrObj(err));
        }
    };
};

kony.sdk.prototype.registerObjectService = function(objectServiceType, objectServiceClass) {
    kony.sdk.logsdk.trace("Entering kony.sdk.prototype.registerObjectService");
    kony.sdk.registeredobjsvcs = kony.sdk.registeredobjsvcs || {};
    kony.sdk.registeredobjsvcs[objectServiceType] = objectServiceClass;
};

/**
 * Method to create the object service instance with the provided service name.
 * @param {string} serviceName - Name of the service
 * @param {map} options - Map of key values like {"access":"offline"/"online"/"registered Object Service Name"}
 * @returns {@link kony.sdk.OnlineObjectService / @link kony.sdk.OfflineObjectService} Object service instance
 * @throws Exception if the serviceName or access is invalid.
 */
kony.sdk.prototype.getObjectService = function(serviceName, options) {
    kony.sdk.logsdk.trace("Entering kony.sdk.prototype.getObjectService");
    if (!kony.sdk.isInitialized) {
        throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, kony.sdk.constants.INIT_FAILURE_MESSAGE + " Object service - "+serviceName);
    }

    var access;
    if (!kony.sdk.isNullOrUndefined(options)) {
        access = options["access"];
    }


    if (this.objectsvc != null && this.objectsvc[serviceName] != null) {
        kony.sdk.logsdk.debug("### getObjectService::found Object service" + this.objectsvc[serviceName]);
        if(kony.sdk.util.isNullOrEmptyString(access) || access.toLowerCase() === "online") {
            return new kony.sdk.OnlineObjectService(this, serviceName, this.objectsvc[serviceName]);
        } else if(access.toLowerCase() === "offline") {

            //This returns SyncV1 object service
            return new kony.sdk.OfflineObjectService(this, serviceName);
        }

    } else if(this.offlineObjectsvc != null) {
        if (this.offlineObjectsvc[serviceName] != null) {
            if(kony.sdk.util.isNullOrEmptyString(access) || access.toLowerCase() === "online") {

                // This returns Online Object Service Instance
                return new kony.sdk.OnlineObjectService(this, serviceName, this.offlineObjectsvc[serviceName]);
            } else if(access.toLowerCase() === "offline") {

                //This returns Offline Enabled or SyncV2 object service
                return new kony.sdk.OfflineEnabledObjectService(this, serviceName);
            }
        }
    }

    kony.sdk.registeredobjsvcs = kony.sdk.registeredobjsvcs || {};
    //verifying if the servicetype available in registeredservices if available initialize and return
    if (kony.sdk.registeredobjsvcs[access] != null && kony.sdk.registeredobjsvcs[access] != undefined) {
        return new kony.sdk.registeredobjsvcs[access](this, serviceName);
    }

    throw new Exception(kony.sdk.errorConstants.OBJECT_FAILURE, "Invalid serviceName:"+ serviceName + "or access type:" + access);

};

/**
 * Method which returns the online ObjectService object
 * @param konyRef
 * @param serviceName
 * @constructor
 */
kony.sdk.OnlineObjectService = function(konyRef, serviceName, serviceInfo) {
    kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService");
    this.konyRef = konyRef;
    this.serviceName = serviceName;
    this.serviceInfo = serviceInfo;
    this.dataUrl = null;
    this.binaryUrl = null;
    this.fileStorageObjectServiceUrl = null;
    this.operationsUrl = null;
    this.metadataUrl = null;
    this.version = null;

    var currentObject = this;

    /**
     * This method is used to create a record on the object
     * @param {map} options - includes {"dataObject":(@link kony.sdk.dto.DataObject),"headers":<map of http headers>}
     * @param successCallback
     * @param failureCallback
     */
    this.create = function(options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.create");
        if(options == null || options == undefined) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined,"options" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        if(!(options["dataObject"] instanceof kony.sdk.dto.DataObject)) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance,kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if(!(options["queryParams"] == null || options["queryParams"] == undefined)) {
            if(!(options["queryParams"] instanceof Object)){
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance,kony.sdk.errormessages.invalid_queryparams_instance));
            }
        }

        var tmpDataUrl = this.getDataUrl();
        var objName = options["dataObject"].objectName;

        function createOperationHandler() {
            currentObject.getMetadataOfObject(objName,{},function(result){
                _create(options, tmpDataUrl, successCallback, failureCallback);
            },function(error){
                kony.sdk.logsdk.error("### OnlineObjectService::create Error:" , error);
                kony.sdk.verifyAndCallClosure(failureCallback,error);
            });
        }

        if (kony.sdk.skipAnonymousCall){
            createOperationHandler();
        }
        else{
            kony.sdk.claimsRefresh(createOperationHandler, failureCallback);
        }
    };

    /**
     * This method is used to fetch a record on the object
     * @param {map} options - includes {"dataObject":(@link kony.sdk.dto.DataObject),"headers":<map of http headers>}
     * @param successCallback
     * @param failureCallback
     */
    this.fetch = function(options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.fetch");
        if(options == null || options == undefined) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined,"options" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        if(!(options["dataObject"] instanceof kony.sdk.dto.DataObject)) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance,kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if(!(options["queryParams"] == null || options["queryParams"] == undefined)) {
            if(!(options["queryParams"] instanceof Object)){
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance,kony.sdk.errormessages.invalid_queryparams_instance));
            }
        }

        var tmpDataUrl = this.getDataUrl();
        var objName = options["dataObject"].objectName;

        function fetchOperationHandler() {
            currentObject.getMetadataOfObject(objName,{},function(result){
                _fetch(options, tmpDataUrl, successCallback, failureCallback);
            },function(error){
                kony.sdk.logsdk.error("### OnlineObjectService::fetch Error:" , error);
                kony.sdk.verifyAndCallClosure(failureCallback,error);
            });
        }

        if (kony.sdk.skipAnonymousCall){
            fetchOperationHandler();
        }
        else{
            kony.sdk.claimsRefresh(fetchOperationHandler, failureCallback);
        }

    };

    /**
     * This method is used to update a record on the object
     * @param {map} options - includes {"dataObject":(@link kony.sdk.dto.DataObject),"headers":<map of http headers>}
     * @param successCallback
     * @param failureCallback
     */
    this.update = function(options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.update");
        if(options == null || options == undefined) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined,"options" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        if(!(options["dataObject"] instanceof kony.sdk.dto.DataObject)) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance,kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if(!(options["queryParams"] == null || options["queryParams"] == undefined)) {
            if(!(options["queryParams"] instanceof Object)){
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance,kony.sdk.errormessages.invalid_queryparams_instance));
                return;
            }
        }

        var tmpDataUrl = this.getDataUrl();
        var objName = options["dataObject"].objectName;

        function updateOperationHandler() {
            currentObject.getMetadataOfObject(objName,{},function(result){
                _update(options, tmpDataUrl, successCallback, failureCallback);
            },function(error){
                kony.sdk.logsdk.error("### OnlineObjectService::update Error:" , error);
                kony.sdk.verifyAndCallClosure(failureCallback,error);
            });
        }

        if (kony.sdk.skipAnonymousCall){
            updateOperationHandler();
        }
        else{
            kony.sdk.claimsRefresh(updateOperationHandler, failureCallback);
        }

    };

    /**
     * This method is used to partial update a record on the object
     * @param {map} options - includes {"dataObject":(@link kony.sdk.dto.DataObject),"headers":<map of http headers>}
     * @param successCallback
     * @param failureCallback
     */
    this.partialUpdate = function(options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.partialUpdate");
        if(options == null || options == undefined) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined,"options" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        if(!(options["dataObject"] instanceof kony.sdk.dto.DataObject)) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance,kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if(!(options["queryParams"] == null || options["queryParams"] == undefined)) {
            if(!(options["queryParams"] instanceof Object)){
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance,kony.sdk.errormessages.invalid_queryparams_instance));
                return;
            }
        }

        var tmpDataUrl = this.getDataUrl();
        var objName = options["dataObject"].objectName;

        function partialUpdateOperationHandler() {
            currentObject.getMetadataOfObject(objName,{},function(result){
                _partialUpdate(options, tmpDataUrl, successCallback, failureCallback);
            },function(error){
                kony.sdk.logsdk.error("### OnlineObjectService::partialUpdate Error:" , error);
                kony.sdk.verifyAndCallClosure(failureCallback,error);
            });
        }

        if (kony.sdk.skipAnonymousCall){
            partialUpdateOperationHandler();
        }
        else{
            kony.sdk.claimsRefresh(partialUpdateOperationHandler, failureCallback);
        }

    };

    /**
     * This method is used to delete a record on the object
     * @param {map} options - includes {"dataObject":(@link kony.sdk.dto.DataObject),"headers":<map of http headers>}
     * @param successCallback
     * @param failureCallback
     */
    this.deleteRecord = function(options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.deleteRecord");
        if(options == null || options == undefined) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined,"options" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        if(!(options["dataObject"] instanceof kony.sdk.dto.DataObject)) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance,kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if(!(options["queryParams"] == null || options["queryParams"] == undefined)) {
            if(!(options["queryParams"] instanceof Object)){
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance,kony.sdk.errormessages.invalid_queryparams_instance));
                return;
            }
        }

        var tmpDataUrl = this.getDataUrl();
        var objName = options["dataObject"].objectName;

        function deleteOperationHandler() {
            currentObject.getMetadataOfObject(objName,{},function(result){
                _deleteRecord(options, tmpDataUrl, successCallback, failureCallback);
            },function(error){
                kony.sdk.logsdk.error("### OnlineObjectService::delete Error:" , error);
                kony.sdk.verifyAndCallClosure(failureCallback,error);
            });
        }

        if (kony.sdk.skipAnonymousCall){
            deleteOperationHandler();
        }
        else{
            kony.sdk.claimsRefresh(deleteOperationHandler, failureCallback);
        }

    };

    /**
     * This method is used to for performing custom operation
     * @param {string} verbName -  custom verb identifier
     * @param {map} options - includes {"dataObject":(@link kony.sdk.dto.DataObject),"headers":<map of http headers>}
     * @param successCallback
     * @param failureCallback
     */
    this.customVerb = function(verbName, options, successCallback, failureCallback){
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.customVerb");
        if(verbName == null || verbName == undefined) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined,"verbName" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        if(options == null || options == undefined) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined,"options" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        if(!(options["dataObject"] instanceof kony.sdk.dto.DataObject)) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance,kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if(!(options["queryParams"] == null || options["queryParams"] == undefined)) {
            if(!(options["queryParams"] instanceof Object)){
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance,kony.sdk.errormessages.invalid_queryparams_instance));
                return;
            }
        }

        var tmpDataUrl = this.getOperationsUrl();
        var objName = options["dataObject"].objectName;

        function customVerbHandler() {
            currentObject.getMetadataOfObject(objName,{},function(result){
                _customverb(verbName,options, tmpDataUrl, successCallback, failureCallback);
            },function(error){
                kony.sdk.logsdk.error("### OnlineObjectService::customverb Error:" , error);
                kony.sdk.verifyAndCallClosure(failureCallback,error);
            });
        }

        if (kony.sdk.skipAnonymousCall){
            customVerbHandler();
        }
        else{
            kony.sdk.claimsRefresh(customVerbHandler, failureCallback);
        }

    };

    /**
     * This method is used to retrive metadata of all objects
     * @param {map} options - includes {"getFromServer":boolean,"headers":<map of http headers>}
     * @param successCallback
     * @param failureCallback
     */
    this.getMetadataOfAllObjects = function(options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.getMetadataOfAllObjects");
        _getMetadataForObjectsOrServiceOnlineUtil(konyRef, serviceName, null, options, successCallback, failureCallback);
        kony.sdk.logsdk.trace("Exiting kony.sdk.OnlineObjectService.getMetadataOfAllObjects");
    };

    /**
     * This method is used to retrive metadata of a specific object
     * @param objectName
     * @param {map} options - includes {"getFromServer":boolean,"headers":<map of http headers>}
     * @param successCallback
     * @param failureCallback
     */
    this.getMetadataOfObject = function(objectName, options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.getMetadataOfObject");
        _getMetadataForObjectsOrServiceOnlineUtil(konyRef, serviceName, objectName, options, successCallback, failureCallback);
        kony.sdk.logsdk.trace("Exiting kony.sdk.OnlineObjectService.getMetadataOfObject");
    };

    this.getDataUrl = function() {
        if (kony.sdk.isNullOrUndefined(currentObject.dataUrl)) {
            currentObject.dataUrl = encodeURI(stripTrailingCharacter(currentObject.serviceInfo["url"] + "/objects/", "/"));
        }
        return currentObject.dataUrl;
    };

    this.getFileStorageObjectServiceUrl = function() {
        if (kony.sdk.isNullOrUndefined(currentObject.fileStorageObjectServiceUrl)) {
            currentObject.fileStorageObjectServiceUrl = encodeURI(stripTrailingCharacter(currentObject.serviceInfo["url"], "/"));
        }
        return currentObject.fileStorageObjectServiceUrl;
    };

    this.getBinaryUrl = function() {
        if (kony.sdk.isNullOrUndefined(currentObject.binaryUrl)) {
            currentObject.binaryUrl = encodeURI(stripTrailingCharacter(currentObject.serviceInfo["url"] + "/binary/", "/"));
        }
        return currentObject.binaryUrl;
    };

    this.getOperationsUrl = function() {
        if (kony.sdk.isNullOrUndefined(currentObject.operationsUrl)) {
            currentObject.operationsUrl = encodeURI(stripTrailingCharacter(currentObject.serviceInfo["url"] + "/operations/", "/"));
        }
        return currentObject.operationsUrl;
    };

    this.getMetadataUrl = function() {
        if (kony.sdk.isNullOrUndefined(currentObject.metadataUrl)) {
            currentObject.metadataUrl = encodeURI(stripTrailingCharacter(currentObject.serviceInfo["metadata_url"], "/"));
        }
        return currentObject.metadataUrl;
    };

    this.getVersion = function() {
        if (kony.sdk.isNullOrUndefined(currentObject.version)) {
            currentObject.version = currentObject.serviceInfo["version"];
        }
        return currentObject.version;
    };

    /*
    *  API for uploading binary data (either file or raw bytes) to backend
    */
    this.uploadBinaryData = function(options, onFileUploadStartedCallback, onChunkUploadCompletedCallback, onFileUploadCompletedCallback, onFileUploadFailureCallback)
    {
        var fileUploadStartedCallback = null;
        var chunkUploadCompletedCallback = null;
        var fileUploadCompletedCallback = null;
        var fileUploadFailureCallback = null;
        var uploadParams = null;

        /* validations for callbacks */

        // validation for onFileUploadStartedCallback
        if (kony.sdk.isNullOrUndefined(onFileUploadStartedCallback) || (typeof (onFileUploadStartedCallback) !== 'function'))
        {
            kony.sdk.logsdk.warn("### OnlineObjectService::uploadBinaryData onFileUploadStartedCallback is null or undefined or not a function");
        }
        else
        {
            fileUploadStartedCallback = onFileUploadStartedCallback;
        }

        // validation for onChunkUploadCompletedCallback
        if (kony.sdk.isNullOrUndefined(onChunkUploadCompletedCallback) || (typeof (onChunkUploadCompletedCallback) !== 'function'))
        {
            kony.sdk.logsdk.warn("### OnlineObjectService::uploadBinaryData onChunkUploadCompletedCallback is null or undefined or not a function");
        }
        else
        {
            chunkUploadCompletedCallback = onChunkUploadCompletedCallback;
        }

        // validation for onFileUploadCompletedCallback
        if (kony.sdk.isNullOrUndefined(onFileUploadCompletedCallback) || (typeof (onFileUploadCompletedCallback) !== 'function'))
        {
            kony.sdk.logsdk.warn("### OnlineObjectService::uploadBinaryData onFileUploadCompletedCallback is null or undefined or not a function");
        }
        else
        {
            fileUploadCompletedCallback = onFileUploadCompletedCallback;
        }

        // validation for onFileUploadFailureCallback
        if (kony.sdk.isNullOrUndefined(onFileUploadFailureCallback) || (typeof (onFileUploadFailureCallback) !== 'function'))
        {
            kony.sdk.logsdk.warn("### OnlineObjectService::uploadBinaryData onFileUploadFailureCallback is null or undefined or not a function");
        }
        else
        {
            fileUploadFailureCallback = onFileUploadFailureCallback;
        }

        // validation for options
        if (kony.sdk.isNullOrUndefined(options))
        {
            kony.sdk.logsdk.error("### OnlineObjectService::uploadBinaryData options is null or undefined");
            kony.sdk.verifyAndCallClosure(fileUploadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined, "options " + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        var dataObject = options["dataObject"];
        if(kony.sdk.isNullOrUndefined(dataObject))
        {
            kony.sdk.verifyAndCallClosure(fileUploadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance, kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if (!(dataObject instanceof kony.sdk.dto.DataObject))
        {
            kony.sdk.verifyAndCallClosure(fileUploadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance, kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        var objName = dataObject.getObjectName();
        var mfEndpointUrl = this.getDataUrl() + "/" +  objName;

        if(kony.sdk.isNullOrUndefined(dataObject.getRecord()))
        {
            kony.sdk.logsdk.error("### OnlineObjectService::uploadBinaryData Error: Please provide record to upload Binary content.");
            kony.sdk.verifyAndCallClosure(fileUploadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
            return;
        }

        uploadParams = dataObject.getRecord();

        var errorObj = kony.sdk.binary.validateUploadParams(uploadParams);
        if (errorObj) {
            kony.sdk.verifyAndCallClosure(fileUploadFailureCallback, errorObj);
            return;
        }

        // if rawbytes are provided, converting to base64 string as FFI can only receive base datatypes
        if (!kony.sdk.isNullOrUndefined(uploadParams[kony.sdk.constants.RAW_BYTES])) {
            var base64String = kony.convertToBase64(uploadParams[kony.sdk.constants.RAW_BYTES]);
            uploadParams[kony.sdk.constants.RAW_BYTES] = base64String;
        }


        function uploadBinaryDataOperationHandler()
        {
            currentObject.getMetadataOfObject(objName, {}, function (response)
                {
                    _uploadBinaryData(mfEndpointUrl, uploadParams, fileUploadStartedCallback, chunkUploadCompletedCallback, fileUploadCompletedCallback, fileUploadFailureCallback);
                },
                function (error)
                {
                    kony.sdk.logsdk.error("### OnlineObjectService::uploadBinaryData Error:" , error);
                    kony.sdk.verifyAndCallClosure(fileUploadFailureCallback, error);
                });
        }

        if (kony.sdk.skipAnonymousCall){
            uploadBinaryDataOperationHandler();
        }
        else{
            kony.sdk.claimsRefresh(uploadBinaryDataOperationHandler, fileUploadFailureCallback);
        }
    };

    /*
     * Helper method to perform file upload
     */
    function _uploadBinaryData(mfEndpointUrl, uploadParams, fileUploadStartedCallback, chunkUploadCompletedCallback, fileUploadCompletedCallback, fileUploadFailureCallback)
    {
        var uploadOptions = {};

        if(uploadParams)
        {
            //Extracting Mandatory Params from uploadParams before fetching template
            if (uploadParams[kony.sdk.constants.FILE_PATH])
            {
                uploadOptions[kony.sdk.constants.FILE_PATH] = uploadParams[kony.sdk.constants.FILE_PATH];
                delete uploadParams[kony.sdk.constants.FILE_PATH];
            }
            else if (uploadParams[kony.sdk.constants.RAW_BYTES])
            {
                uploadOptions[kony.sdk.constants.RAW_BYTES] = uploadParams[kony.sdk.constants.RAW_BYTES];
                delete uploadParams[kony.sdk.constants.RAW_BYTES];
            }
            else if (uploadParams[kony.sdk.constants.FILE_OBJECT]) {
                uploadOptions[kony.sdk.constants.FILE_OBJECT] = uploadParams[kony.sdk.constants.FILE_OBJECT];
                delete uploadParams[kony.sdk.constants.FILE_OBJECT]
            }

            uploadOptions["uploadParams"] = uploadParams;
        }

        var headers = {};
        if (!kony.sdk.skipAnonymousCall){
            headers[kony.sdk.constants.KONY_AUTHORIZATION_HEADER] = kony.sdk.getCurrentInstance().currentClaimToken;
        }

        uploadOptions["headers"] = headers;
        uploadOptions["URL"] = mfEndpointUrl;

        kony.sdk.binary.uploadBinaryData(
            uploadOptions,
            fileUploadStartedCallback,
            chunkUploadCompletedCallback,
            fileUploadCompletedCallback,
            fileUploadFailureCallback);
    }

    this.getBinaryData = function(options, arg1, arg2, arg3, arg4, arg5) {
        var externalSource = true;
        var fileDownloadStartedCallback = null;
        var chunkDownloadCompletedCallback = null;
        var fileDownloadCompletedCallback = null;
        var downloadFailureCallback = null;
        var binaryAttributeName = null;

        if (kony.sdk.isNullOrUndefined(arg5)) {
            if (kony.sdk.isNullOrUndefined(arg1)) {
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData fileDownloadStartedCallback is null or undefined");
            } else if (typeof (arg1) === 'function') {
                fileDownloadStartedCallback = arg1;
            } else{
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData invalid param provided for fileDownloadStartedCallback");
            }

            if (kony.sdk.isNullOrUndefined(arg2)) {
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData chunkDownloadCompletedCallback is null or undefined");
            } else if (typeof (arg2) === 'function') {
                chunkDownloadCompletedCallback = arg2;
            } else{
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData invalid param provided for chunkDownloadCompletedCallback");
            }

            if (kony.sdk.isNullOrUndefined(arg3)) {
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData fileDownloadCompletedCallback is null or undefined");
            } else if (typeof (arg3) === 'function') {
                fileDownloadCompletedCallback = arg3;
            } else{
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData invalid param provided for fileDownloadCompletedCallback");
            }

            if (kony.sdk.isNullOrUndefined(arg4)) {
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData downloadFailureCallback is null or undefined");
            } else if (typeof (arg4) === 'function') {
                downloadFailureCallback = arg4;
            } else{
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData invalid param provided for downloadFailureCallback");
            }
        } else {
            binaryAttributeName = arg1;
            externalSource = false;
            if (kony.sdk.isNullOrUndefined(arg2)) {
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData fileDownloadStartedCallback is null or undefined");
            } else if (typeof (arg2) === 'function') {
                fileDownloadStartedCallback = arg2;
            } else{
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData invalid param provided for fileDownloadStartedCallback");
            }

            if (kony.sdk.isNullOrUndefined(arg3)) {
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData chunkDownloadCompletedCallback is null or undefined");
            } else if (typeof (arg3) === 'function') {
                chunkDownloadCompletedCallback = arg3;
            } else{
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData invalid param provided for chunkDownloadCompletedCallback");
            }

            if (kony.sdk.isNullOrUndefined(arg4)) {
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData fileDownloadCompletedCallback is null or undefined");
            } else if (typeof (arg4) === 'function') {
                fileDownloadCompletedCallback = arg4;
            } else{
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData invalid param provided for fileDownloadCompletedCallback");
            }

            if (kony.sdk.isNullOrUndefined(arg5)) {
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData downloadFailureCallback is null or undefined");
            } else if (typeof (arg5) === 'function') {
                downloadFailureCallback = arg5;
            } else{
                kony.sdk.logsdk.warn("### OnlineObjectService::getBinaryData invalid param provided for downloadFailureCallback");
            }

        }
        if(kony.sdk.getSdkType() !== kony.sdk.constants.SDK_TYPE_IDE && kony.sdk.getAType() !== kony.sdk.constants.SDK_ATYPE_NATIVE)
        {
            kony.sdk.verifyAndCallClosure(downloadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_api,kony.sdk.errormessages.invalid_api + "platform :" + kony.sdk.getSdkType().toString()));
            return;
        }
        if (kony.sdk.isNullOrUndefined(options)) {
            kony.sdk.verifyAndCallClosure(downloadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined, "options" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        var tmpDataUrl = null;
        if(externalSource){
            tmpDataUrl = this.getDataUrl();
        }else{
            tmpDataUrl = this.getBinaryUrl();
        }
        var dataObject = options["dataObject"];
        if (!(dataObject instanceof kony.sdk.dto.DataObject)) {
            kony.sdk.verifyAndCallClosure(downloadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance, kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if (!(kony.sdk.isNullOrUndefined(options["queryParams"]))) {
            if (!(options["queryParams"] instanceof Object)) {
                kony.sdk.verifyAndCallClosure(downloadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance, kony.sdk.errormessages.invalid_queryparams_instance));
                return;
            }
        }
        var objName = dataObject.getObjectName();

        var streamingFlag = false;
        if (!kony.sdk.isNullOrUndefined(options["streaming"]) && options["streaming"] === true) {
            streamingFlag = true;
        }

        if (!externalSource) {
            if (kony.sdk.isNullOrUndefined(binaryAttributeName) || typeof (binaryAttributeName) !== "string") {
                kony.sdk.logsdk.error("### OnlineObjectService::getBinaryData Error: Please provide column name to fetch binary content");
                kony.sdk.verifyAndCallClosure(downloadFailureCallback, kony.sdk.error.getClientErrObj("90000", "Please provide column name to fetch binary content"));
                return;
            } else {
                options["binaryAttrName"] = binaryAttributeName;
            }
        }

        if(kony.sdk.isNullOrUndefined(dataObject.getRecord())){
            kony.sdk.logsdk.error("### OnlineObjectService::_getBinaryData Error: Please provide primary key details or fileParams to get Binary content.");
            kony.sdk.verifyAndCallClosure(downloadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
            return;
        }

        function getBinaryDataOperationHandler() {
            currentObject.getMetadataOfObject(objName, {}, function (response) {
                _getBinaryData(options, tmpDataUrl, externalSource, streamingFlag, fileDownloadStartedCallback, chunkDownloadCompletedCallback, fileDownloadCompletedCallback, downloadFailureCallback);
            }, function (error) {
                kony.sdk.logsdk.error("### OnlineObjectService::getBinaryData Error:" , error);
                kony.sdk.verifyAndCallClosure(downloadFailureCallback, error);
            });
        }

        if (kony.sdk.skipAnonymousCall){
            getBinaryDataOperationHandler();
        }
        else{
            kony.sdk.claimsRefresh(getBinaryDataOperationHandler, downloadFailureCallback);
        }
    };

    /**
     * Helps to get the binary content of the specified column on the Object
     * @param {map} options - includes {"dataObject":{@link kony.sdk.dto.DataObject}, "binaryAttrName":columnName}
     * @param successCallback
     * @param failureCallback
     */
    this.getBinaryContent = function(options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.getBinaryContent");
        if(options == null || options == undefined){
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined, "options" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        var tmpDataUrl = this.getBinaryUrl();
        var dataObject = options["dataObject"];
        if(!(dataObject instanceof kony.sdk.dto.DataObject)) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance,kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if(!(options["queryParams"] == null || options["queryParams"] == undefined)) {
            if(!(options["queryParams"] instanceof Object)){
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance,kony.sdk.errormessages.invalid_queryparams_instance));
                return;
            }
        }

        var objName = dataObject.getObjectName();
        var binaryColName = options["binaryAttrName"];
        if (binaryColName == null || binaryColName == undefined) {
            kony.sdk.logsdk.error("### OnlineObjectService::getBinaryContent Error: Please provide column name to fetch binary content");
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj("90000","Please provide column name to fetch binary content"));
            return;
        }
        function getBinaryContentOperationHandler() {
            currentObject.getMetadataOfObject(objName, {}, function (response) {
                _getBinaryContent(options, tmpDataUrl, successCallback, failureCallback);
            }, function (error) {
                kony.sdk.logsdk.error("### OnlineObjectService::getBinaryContent Error:" , error);
                kony.sdk.verifyAndCallClosure(failureCallback, error);
            });
        }

        if (kony.sdk.skipAnonymousCall){
            getBinaryContentOperationHandler();
        }
        else{
            kony.sdk.claimsRefresh(getBinaryContentOperationHandler, failureCallback);
        }
    };

    /**
     * Helps to create the binary content of the specified column on the Object
     * @param {map} options - includes {"dataObject": {@link kony.sdk.dto.DataObject}, "binaryAttrName":columnName}
     * @param successCallback
     * @param failureCallback
     */
    this.createBinaryContent = function(options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.createBinaryContent");
        var tmpDataUrl = this.getBinaryUrl();

        if(options == null || options == undefined) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined,"options" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        var dataObject = options["dataObject"];
        if(!(dataObject instanceof kony.sdk.dto.DataObject)) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance,kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if(!(options["queryParams"] == null || options["queryParams"] == undefined)) {
            if(!(options["queryParams"] instanceof Object)){
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance,kony.sdk.errormessages.invalid_queryparams_instance));
                return;
            }
        }

        var objName = dataObject.getObjectName();
        var binaryColName = options["binaryAttrName"];
        if (binaryColName == null || binaryColName == undefined) {
            kony.sdk.logsdk.error("### OnlineObjectService::createBinaryContent Error: Please provide column name to create binary content");
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj("900000","Please provide column name to create binary content"));
            return;
        }
        function createBinaryContentOperationHandler() {
            currentObject.getMetadataOfObject(objName, {}, function (response) {
                _createBinaryContent(options, tmpDataUrl, successCallback, failureCallback);
            }, function (error) {
                kony.sdk.logsdk.error("### OnlineObjectService::createBinaryContent Error:" , error);
                kony.sdk.verifyAndCallClosure(failureCallback, error);
            });
        }

        if (kony.sdk.skipAnonymousCall){
            createBinaryContentOperationHandler();
        }
        else{
            kony.sdk.claimsRefresh(createBinaryContentOperationHandler, failureCallback);
        }
    };

    /**
     * Helps to update the binary content of the specified column on the Object
     * @param {map} options - includes {"dataObject": {@link kony.sdk.dto.DataObject}, "binaryAttrName":columnName}
     * @param successCallback
     * @param failureCallback
     */
    this.updateBinaryContent = function(options, successCallback, failureCallback) {
        kony.sdk.logsdk.trace("Entering kony.sdk.OnlineObjectService.updateBinaryContent");
        var tmpDataUrl = this.getBinaryUrl();

        if(options == null || options == undefined) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined, "options" + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        var dataObject = options["dataObject"];
        if(!(dataObject instanceof kony.sdk.dto.DataObject)) {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_dataobject_instance,kony.sdk.errormessages.invalid_dataobject_instance));
            return;
        }

        if(!(options["queryParams"] == null || options["queryParams"] == undefined)) {
            if(!(options["queryParams"] instanceof Object)){
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance,kony.sdk.errormessages.invalid_queryparams_instance));
                return;
            }
        }

        var objName = dataObject.getObjectName();
        var binaryColName = options["binaryAttrName"];
        if (binaryColName == null || binaryColName == undefined) {
            kony.sdk.logsdk.error("### OnlineObjectService::updateBinaryContent Error: Please provide column name to create binary content");
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj("90000","Please provide column name to create binary content"));
            return;
        }
        function updateBinaryContentOperationHandler() {
            currentObject.getMetadataOfObject(objName, {}, function (response) {
                _updateBinaryContent(options, tmpDataUrl, successCallback, failureCallback);
            }, function (error) {
                kony.sdk.logsdk.error("### OnlineObjectService::updateBinaryContent Error:" , error);
                kony.sdk.verifyAndCallClosure(failureCallback, error);
            });
        }

        if (kony.sdk.skipAnonymousCall){
            updateBinaryContentOperationHandler();
        }
        else{
            kony.sdk.claimsRefresh(updateBinaryContentOperationHandler, failureCallback);
        }

    };

    function _getBinaryContent(options, tmpDataUrl, successCallback, failureCallback) {
        var dataObject = options["dataObject"];
        var headers = options["headers"];
        var binaryColName = options["binaryAttrName"];
        var objName = dataObject.getObjectName();
        var queryParams = options["queryParams"];
        var url =  tmpDataUrl + "/" + objName;
        var objMetadata = kony.sdk.ObjectServiceUtil.getCachedObjectMetadata(serviceName, objName);
        if (objMetadata.primaryKey != undefined && objMetadata.primaryKey != null ) {
            var pkCount = objMetadata.primaryKey.length;
            if (pkCount == 0) {
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                return;
            }
            //reading primarykey and framing filter clause
            var pkey = objMetadata.primaryKey[0];
            if(dataObject.getRecord()[pkey] == undefined || dataObject.getRecord()[pkey] == null){
                kony.sdk.logsdk.error("### OnlineObjectService::_getBinaryContent Error: Please provide primary key details to get Binary content.");
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                return;
            }
            url = url + "?" + pkey + "=" + dataObject.getRecord()[pkey];
            //passing binary column name to server
            if(binaryColName != null && binaryColName != undefined) {
                url = url + "&fieldName=" + binaryColName;
            }
            if(queryParams != undefined && queryParams != null){
                url = url + "&" + kony.sdk.util.objectToQueryParams(queryParams);
            }

        } else {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
            return;
        }
        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }

        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var header in headers) {
                if(header !== null && header !=='undefined'){
                    if (header.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase())
                        isKonyApiVersionAvailable = true
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = currentObject.getVersion();
            }
        }
        function invokeSuccessCallback(response){
            kony.sdk.logsdk.debug("### OnlineObjectService::_getBinaryContent::invokeSuccessCallback Response:" , response);
            kony.sdk.verifyAndCallClosure(successCallback,response["data"]);
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_getBinaryContent::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(failureCallback,error);
        }

        invokeObjectOperation(url, dataObject.getObjectName(), headers,null, kony.sdk.constants.HTTP_METHOD_GET ,invokeSuccessCallback,invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
    }

    function _getBinaryData(options, tmpDataUrl, externalSource, streamingFlag, fileDownloadStartedCallback, chunkDownloadCompletedCallback, fileDownloadCompletedCallback, downloadFailureCallback) {

        var dataObject = options["dataObject"];
        var headers = options["headers"];
        var binaryColName = options["binaryAttrName"];
        var objName = dataObject.getObjectName();
        var queryParams = options["queryParams"];
        var url =  tmpDataUrl + "/" + objName;
        var objMetadata = kony.sdk.ObjectServiceUtil.getCachedObjectMetadata(serviceName, objName);

        if(!externalSource){
            if (!kony.sdk.isNullOrUndefined(objMetadata.primaryKey)) {
                var pkCount = objMetadata.primaryKey.length;
                if (pkCount == 0) {
                    kony.sdk.verifyAndCallClosure(downloadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                    return;
                }
                //reading primarykey and framing filter clause
                var pkey = objMetadata.primaryKey[0];
                if(kony.sdk.isNullOrUndefined(dataObject.getRecord()[pkey])){
                    kony.sdk.logsdk.error("### OnlineObjectService::_getBinaryData Error: Please provide primary key details to get Binary content.");
                    kony.sdk.verifyAndCallClosure(downloadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                    return;
                }
                url = url + "?" + pkey + "=" + dataObject.getRecord()[pkey];
                //passing binary column name to server
                if(!kony.sdk.isNullOrUndefined(binaryColName)) {
                    url = url + "&fieldName=" + binaryColName;
                }

                url = url + "&type=bytes";
                if(!kony.sdk.isNullOrUndefined(queryParams)){
                    url = url + "&" + kony.sdk.util.objectToQueryParams(queryParams);
                }
            } else {
                kony.sdk.verifyAndCallClosure(downloadFailureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                return;
            }
        }

        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }

        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var headerKey in headers) {
                if(!kony.sdk.isNullOrUndefined(headerKey)){
                    if (headerKey.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase()) {
                        isKonyApiVersionAvailable = true;
                        headers[kony.sdk.constants.API_VERSION_HEADER] = headers[headerKey];
                    }
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = currentObject.getVersion();
            }
        }
        function invokeSuccessCallback(response){
            kony.sdk.logsdk.debug("### OnlineObjectService::_getBinaryData::invokeSuccessCallback Response:" , response);

            var downloadConfig = response["records"][0];
            downloadConfig.httpStatusCode = response.httpStatusCode;

            if(options && options["ChunkSize"]){
                downloadConfig.ChunkSize = options["ChunkSize"];
            }

            var fileParams = dataObject.getRecord();
            if(kony.sdk.isNullOrUndefined(fileParams["fileId"])){
                fileParams["fileId"] = new Date().getTime().toString();
            }

            kony.sdk.binary.getBinaryData(
                fileParams,
                streamingFlag,
                downloadConfig,
                fileDownloadStartedCallback,
                chunkDownloadCompletedCallback,
                fileDownloadCompletedCallback,
                downloadFailureCallback);
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_getBinaryData::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(downloadFailureCallback,error);
        }

        if(externalSource) {
            invokeObjectOperation(url, dataObject.getObjectName(), headers, null, kony.sdk.constants.HTTP_METHOD_GET , invokeSuccessCallback, invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
        }else{
            var fileParams = dataObject.getRecord();
            if(kony.sdk.isNullOrUndefined(fileParams["fileId"])){
                fileParams["fileId"] = dataObject.getRecord()[pkey];
            }

            if (!kony.sdk.skipAnonymousCall){
                headers[kony.sdk.constants.KONY_AUTHORIZATION_HEADER] = kony.sdk.getCurrentInstance().currentClaimToken;
            }

            var downloadConfig = {};
            downloadConfig["endpointUrl"] = url;
            downloadConfig["headers"] = headers;
            //for bypasing template call we need to add method and httpstatus code 309
            downloadConfig.method = kony.sdk.constants.HTTP_METHOD_GET;
            downloadConfig.httpStatusCode = kony.sdk.binary.constants.VALID_HTTP_REDIRECT_CODE;  
            if(options && options["ChunkSize"]){
                downloadConfig.ChunkSize = options["ChunkSize"];
            }

            kony.sdk.binary.getBinaryData(
                fileParams,
                streamingFlag,
                downloadConfig,
                fileDownloadStartedCallback,
                chunkDownloadCompletedCallback,
                fileDownloadCompletedCallback,
                downloadFailureCallback);
        }
    }

    function _createBinaryContent(options, tmpDataUrl, successCallback, failureCallback) {
        var dataObject = options["dataObject"];
        var headers = options["headers"];
        var binaryColName = options["binaryAttrName"];
        var objName = dataObject.getObjectName();
        var queryParams = options["queryParams"];
        var url =  tmpDataUrl + "/" + objName;
        var objMetadata = kony.sdk.ObjectServiceUtil.getCachedObjectMetadata(serviceName, objName);
        var jsonPayload = {};
        var pkey;
        if (objMetadata.primaryKey != undefined && objMetadata.primaryKey != null ) {
            var pkCount = objMetadata.primaryKey.length;
            if (pkCount == 0) {
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                return;
            }
            //reading primarykey and framing filter clause
            pkey = objMetadata.primaryKey[0];
            if(dataObject.getRecord()[pkey] == undefined || dataObject.getRecord()[pkey] == null){
                kony.sdk.logsdk.error("### OnlineObjectService::_createBinaryContent Error: Please provide primary key details to create Binary content.");
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                return;
            }
            jsonPayload[pkey] = dataObject.getRecord()[pkey];
            jsonPayload["data"] = dataObject.getRecord()[binaryColName];
            jsonPayload["fieldName"] = binaryColName;
        } else {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
            return;
        }
        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }

        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var header in headers) {
                if(header !== null && header !=='undefined'){
                    if (header.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase())
                        isKonyApiVersionAvailable = true
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = currentObject.getVersion();
            }
        }
        var formData = new kony.sdk.getFormData(jsonPayload);

        if(!kony.sdk.isNullOrUndefined(queryParams)) {
             kony.sdk.updateFormData(formData, "queryparams", queryParams);
        }

        function invokeSuccessCallback(response){
            kony.sdk.logsdk.debug("### OnlineObjectService::_createBinaryContent::invokeSuccessCallback Response:" , response);
            kony.sdk.verifyAndCallClosure(successCallback,response[pkey]);
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_createBinaryContent::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(failureCallback,error);
        }

        invokeObjectOperation(url, dataObject.getObjectName(), headers, formData, null, invokeSuccessCallback,invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
    }

    function _updateBinaryContent(options, tmpDataUrl, successCallback, failureCallback) {
        var dataObject = options["dataObject"];
        var headers = options["headers"];
        var binaryColName = options["binaryAttrName"];
        var objName = dataObject.getObjectName();
        var queryParams = options["queryParams"];
        var url =  tmpDataUrl + "/" + objName;
        var objMetadata = kony.sdk.ObjectServiceUtil.getCachedObjectMetadata(serviceName, objName);
        var jsonPayload = {};
        var pkey;
        if (objMetadata.primaryKey != undefined && objMetadata.primaryKey != null ) {
            var pkCount = objMetadata.primaryKey.length;
            if (pkCount == 0) {
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                return;
            }
            //reading primarykey and framing filter clause
            pkey = objMetadata.primaryKey[0];
            if(dataObject.getRecord()[pkey] == undefined || dataObject.getRecord()[pkey] == null){
                kony.sdk.logsdk.error("### OnlineObjectService::_updateBinaryContent Error: Please provide primary key details to create Binary content.");
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                return;
            }
            jsonPayload[pkey] = dataObject.getRecord()[pkey];
            jsonPayload["data"] = dataObject.getRecord()[binaryColName];
            jsonPayload["fieldName"] = binaryColName;
        } else {
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
            return;
        }
        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }
        headers["X-HTTP-Method-Override"] = "PUT";
        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var header in headers) {
                if(header !== null && header !=='undefined'){
                    if (header.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase())
                        isKonyApiVersionAvailable = true
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = currentObject.getVersion();
            }
        }

        var formData = new kony.sdk.getFormData(jsonPayload);

        if(queryParams != undefined && queryParams != null) {
            kony.sdk.updateFormData(formData, "queryparams", queryParams);
        }

        function invokeSuccessCallback(response){
            kony.sdk.logsdk.debug("### OnlineObjectService::_updateBinaryContent::invokeSuccessCallback Response:" , response);
            kony.sdk.verifyAndCallClosure(successCallback,response[pkey]);
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_updateBinaryContent::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(failureCallback,error);
        }

        invokeObjectOperation(url, dataObject.getObjectName(), headers, formData, null,  invokeSuccessCallback,invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
    }

    function _create(options, tmpDataUrl, successCallback, failureCallback) {
        var dataObject = options["dataObject"];
        var headers = options["headers"];
        var url =  tmpDataUrl + "/" + dataObject.objectName;
        var record = dataObject.getRecord();
        var queryParams = options["queryParams"];
        if(record == null || record == undefined){
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.null_or_undefined,"record " + kony.sdk.errormessages.null_or_undefined));
            return;
        }

        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }

        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var header in headers) {
                if(header !== null && header !=='undefined'){
                    if (header.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase())
                        isKonyApiVersionAvailable = true
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = currentObject.getVersion();
            }
        }

        var formData = new kony.sdk.getFormData(record, null);

        if(queryParams != undefined && queryParams != null) {
            kony.sdk.updateFormData(formData, "queryparams", queryParams);
        }

        function invokeSuccessCallback(response){
            kony.sdk.logsdk.debug("### OnlineObjectService::_create::invokeSuccessCallback Response:", response);
            kony.sdk.verifyAndCallClosure(successCallback,response);
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_create::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(failureCallback, error)
        }

        invokeObjectOperation(url, dataObject.objectName, headers,formData,null,  invokeSuccessCallback,invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
    }

    function _fetch(options, tmpDataUrl, successCallback, serviceErrorCallback) {
        var dataObject = options["dataObject"];
        var odataqueryStr = dataObject.getOdataUrl();
        var headers = options["headers"];
        var queryParams = options["queryParams"];
        var url =  tmpDataUrl + "/" + dataObject.objectName;
        if(odataqueryStr != undefined && odataqueryStr != null){
            url = url + "?" + encodeURI(odataqueryStr);
            if(queryParams != undefined && queryParams != null){
                url = url + "&" + kony.sdk.util.objectToQueryParams(queryParams);
            }
        }else if(queryParams != undefined && queryParams != null){
            url = url + "?" + kony.sdk.util.objectToQueryParams(queryParams);
        }

        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }
        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var header in headers) {
                if(header !== null && header !=='undefined'){
                    if (header.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase())
                        isKonyApiVersionAvailable = true
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = currentObject.getVersion();
            }
        }

        // If useCache is enabled and cacheID is present then network call will be skipped and cached response will be returned.
        if (options && options["useCache"] && options["cacheID"]){
            var cacheResponse = new kony.sdk.ClientCache().get(options["cacheID"]);
            if (cacheResponse){
                kony.sdk.logsdk.debug("### OnlineObjectService::_fetch:: key found in cache, invokeSuccessCallback Response:" , cacheResponse);
                kony.sdk.verifyAndCallClosure(successCallback,cacheResponse);
                return;
            }
        }

        function invokeSuccessCallback(response){
            kony.sdk.logsdk.debug("### OnlineObjectService::_fetch::invokeSuccessCallback Response:" , response);

            // If useCache is enabled then the response is cached and returned.
            if (options && options["useCache"]){
                cacheResponseForKey(options, url, {"objectName": dataObject.objectName}, response);
            }

            kony.sdk.verifyAndCallClosure(successCallback,response);
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_fetch::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(serviceErrorCallback,error);
        }

        invokeObjectOperation(url, dataObject.objectName, headers,null, kony.sdk.constants.HTTP_METHOD_GET , invokeSuccessCallback,invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
    }

    function _update(options, tmpDataUrl, updateServiceCallback, serviceErrorCallback) {
        var dataObject = options["dataObject"];
        var headers = options["headers"];
        var url =  tmpDataUrl + "/" + dataObject.objectName;
        var queryParams = options["queryParams"];
        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }

        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var header in headers) {
                if(header !== null && header !=='undefined'){
                    if (header.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase())
                        isKonyApiVersionAvailable = true
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = currentObject.getVersion();
            }
        }

        headers["X-HTTP-Method-Override"] = "PUT";
        var formData = new kony.sdk.getFormData(dataObject.getRecord(), null);

        if(queryParams != undefined && queryParams != null) {
            kony.sdk.updateFormData(formData, "queryparams", queryParams);
        }

        function invokeSuccessCallback(response){
            kony.sdk.logsdk.debug("### OnlineObjectService::_update::invokeSuccessCallback Response:" , response);
            kony.sdk.verifyAndCallClosure(updateServiceCallback,response);
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_update::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(serviceErrorCallback,error);
        }

        invokeObjectOperation(url, dataObject.objectName, headers,formData,null,  invokeSuccessCallback,invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
    }

    function _partialUpdate(options, tmpDataUrl, partialUpdateServiceCallback, serviceErrorCallback) {
        var dataObject = options["dataObject"];
        var headers = options["headers"];
        var url =  tmpDataUrl + "/" + dataObject.objectName;
        var queryParams = options["queryParams"];

        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }
        headers["X-HTTP-Method-Override"] = "PATCH";

        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var header in headers) {
                if(header !== null && header !=='undefined'){
                    if (header.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase())
                        isKonyApiVersionAvailable = true
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = currentObject.getVersion();
            }
        }

        var formData = new kony.sdk.getFormData(dataObject.getRecord(), null);

        if(queryParams != undefined && queryParams != null) {
            kony.sdk.updateFormData(formData, "queryparams", queryParams);
        }

        function invokeSuccessCallback(response){
            kony.sdk.logsdk.debug("### OnlineObjectService::_partialUpdate::invokeSuccessCallback Success Response:" , response);
            kony.sdk.verifyAndCallClosure(partialUpdateServiceCallback,response);
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_partialUpdate::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(serviceErrorCallback,error);
        }

        invokeObjectOperation(url, dataObject.objectName, headers,formData,null, invokeSuccessCallback,invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
    }

    function _deleteRecord(options, tmpDataUrl, deleteSuccessCallback, serviceErrorCallback) {
        var dataObject = options["dataObject"];
        var headers = options["headers"];
        var objMetadata = kony.sdk.ObjectServiceUtil.getCachedObjectMetadata(serviceName,dataObject.objectName);
        var url =  tmpDataUrl + "/" + dataObject.objectName;
        var queryParams = options["queryParams"];
        var odataUrl = "";
        if (objMetadata.primaryKey != undefined && objMetadata.primaryKey != null ) {
            var pkCount = objMetadata.primaryKey.length;
            for(var i=0;i<pkCount;i++) {
                //reading primarykey and framing filter clause
                var pkey = objMetadata.primaryKey[i];
                if(dataObject.getRecord()[pkey] == undefined || dataObject.getRecord()[pkey] == null){
                    kony.sdk.logsdk.error("### OnlineObjectService::_delete Error: Please provide all primary keys to process the request");
                    kony.sdk.verifyAndCallClosure(serviceErrorCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                    return;
                }
                if (i == 0) {
                    odataUrl = "?$filter=" + pkey + " eq '" + dataObject.getRecord()[pkey] + "'";
                } else {
                    //appending the condition incase of composite primary key
                    odataUrl = odataUrl + " and " + pkey + " eq '" + dataObject.getRecord()[pkey] + "'";
                }
            }
        }

        url = url + encodeURI(odataUrl);

        if(queryParams != undefined && queryParams != null) {
            if (odataUrl && odataUrl.length != 0) {
                url = url + "&" + kony.sdk.util.objectToQueryParams(queryParams);
            } else {
                url = url + "?" + kony.sdk.util.objectToQueryParams(queryParams);
            }
        }

        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }

        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var header in headers) {
                if(header !== null && header !=='undefined'){
                    if (header.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase())
                        isKonyApiVersionAvailable = true
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = currentObject.getVersion();
            }
        }

        headers["X-HTTP-Method-Override"] = "DELETE";

        function invokeSuccessCallback(response){
            kony.sdk.logsdk.debug("### OnlineObjectService::_delete::invokeSuccessCallback Response:" , response);
            kony.sdk.verifyAndCallClosure(deleteSuccessCallback,response);
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_delete::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(serviceErrorCallback,error);
        }

        invokeObjectOperation(url, dataObject.objectName, headers,null, kony.sdk.constants.HTTP_METHOD_GET , invokeSuccessCallback,invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
    }

    function _customverb(verbName, options, tmpDataUrl, customVerbServiceCallback, serviceErrorCallback) {
        var dataObject = options["dataObject"];
        var headers = options["headers"];
        var url =  tmpDataUrl + "/" + dataObject.objectName + "/" + verbName;
        var queryParams = options["queryParams"];
        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }
        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var header in headers) {
                if(header !== null && header !=='undefined'){
                    if (header.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase())
                        isKonyApiVersionAvailable = true
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = currentObject.getVersion();
            }
        }

        var formData = new kony.sdk.getFormData(dataObject.getRecord(), null);

        if(queryParams != undefined && queryParams != null) {
            kony.sdk.updateFormData(formData, "queryparams", queryParams);
        }

        function invokeSuccessCallback(response){
            kony.sdk.logsdk.debug("### OnlineObjectService::_customverb::invokeSuccessCallback Success Response:" , response);
            kony.sdk.verifyAndCallClosure(customVerbServiceCallback,response);
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_customverb::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(serviceErrorCallback,error);
        }

        invokeObjectOperation(url, dataObject.objectName, headers,formData,null, invokeSuccessCallback,invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
    }	
	
	this.getFileStorage = function(){	
        // TODO : Fix this as there are issues with getMetadataOfAllObjects call - that was hanging	
		return kony.sdk.FileStorageClasses.import(this.getFileStorageObjectServiceUrl());
	};
};



function _getMetadataUrl(konyRef, serviceName) {
    var metadataUrl = null;

    if (konyRef.objectsvc[serviceName]) {
        metadataUrl = encodeURI(stripTrailingCharacter(konyRef.objectsvc[serviceName]["metadata_url"], "/"));
    } else if (konyRef.offlineObjectsvc[serviceName]) {
        metadataUrl = encodeURI(stripTrailingCharacter(konyRef.offlineObjectsvc[serviceName]["metadata_url"], "/"));
    }

    return metadataUrl;

}

function _getVersion(konyRef, serviceName) {

    var version = null;

    if (konyRef.objectsvc[serviceName]) {
        version = konyRef.objectsvc[serviceName]["version"];
    } else if (konyRef.offlineObjectsvc[serviceName]) {
        version = konyRef.offlineObjectsvc[serviceName]["version"];
    }

    return version;
}


/*This method is used to fetch metadata for Object/Objectservice.
* It is fetched from cache first, if it not available in cache then fetches method data from metadata URL.
*/
function _getMetadataForObjectsOrServiceOnlineUtil(konyRef, serviceName, objectName, options, successCallback, failureCallback) {
    var tmpMetadataUrl = _getMetadataUrl(konyRef, serviceName);;

    if(!(kony.sdk.isNullOrUndefined(options)) && !(options["queryParams"] == null || options["queryParams"] == undefined)) {
        if(!(options["queryParams"] instanceof Object)){
            kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.invalid_queryparams_instance,kony.sdk.errormessages.invalid_queryparams_instance));
        }
    }

    function getMetadataOfObjectOperationHandler() {
        _getMetadataForObjectOrService(konyRef, serviceName, objectName, options, tmpMetadataUrl, successCallback, failureCallback);
    }

    if (kony.sdk.skipAnonymousCall){
        getMetadataOfObjectOperationHandler();
    }
    else{
        kony.sdk.claimsRefresh(getMetadataOfObjectOperationHandler, failureCallback);
    }

}

function _getMetadataForObjectOrService(konyRef, serviceName, objectName, options, tmpMetadataUrl, successCallback, failureCallback) {

    //if the getFromServer flag is true then get metadata from server even though its available in cache
    var getFromServer = false;
    var headers  = null;
    var queryParams = null;
    if(options != null && options != undefined) {
        getFromServer = options["getFromServer"];
        headers = options["headers"];
        queryParams = options["queryParams"];
    }
    var tmpObjOrSvcMetadata = null;
    if(objectName) {
        tmpObjOrSvcMetadata = kony.sdk.ObjectServiceUtil.getCachedObjectMetadata(serviceName, objectName);
    } else {
        tmpObjOrSvcMetadata = kony.sdk.ObjectServiceUtil.getCachedMetadata(serviceName);
    }

    if (getFromServer != true && tmpObjOrSvcMetadata != null && tmpObjOrSvcMetadata != undefined) {
        kony.sdk.logsdk.debug("### OnlineObjectService::_getMetadataOfObject from KonyStore:",tmpObjOrSvcMetadata);
        kony.sdk.verifyAndCallClosure(successCallback, tmpObjOrSvcMetadata);
    } else {
        if (!headers) {
            //if headers not sent by the deveolper
            headers = {};
        }

        var isKonyApiVersionAvailable = false;
        if (typeof(headers) !== 'undefined' && headers !== null) {
            //check for x-kony-api-version case insensitive
            for (var header in headers) {
                if(header !== null && header !=='undefined'){
                    if (header.toLowerCase() === kony.sdk.constants.API_VERSION_HEADER.toLowerCase())
                        isKonyApiVersionAvailable = true
                }
            }
            if (!isKonyApiVersionAvailable) {
                headers[kony.sdk.constants.API_VERSION_HEADER] = _getVersion(konyRef, serviceName);
            }
        }

        var url =  tmpMetadataUrl;
        var svcid = "metadata";

        if(objectName) {
            url = url + "/" + objectName;
            svcid = svcid + "_" + objectName;
        }

        if(queryParams != undefined && queryParams != null){
            url = url + "?" + kony.sdk.util.objectToQueryParams(queryParams);
        }

        function invokeSuccessCallback(result) {
            kony.sdk.logsdk.debug("### OnlineObjectService::_getMetadataForObjectOrService::invokeSuccessCallback Response:" ,result);
            if(objectName) {
                var table = result["Metadata"]["table"];
                kony.sdk.ObjectServiceUtil.cacheObjectMetadata(serviceName, table);
                var tmpObjMetadata = kony.sdk.ObjectServiceUtil.getCachedObjectMetadata(serviceName, objectName);
                kony.sdk.verifyAndCallClosure(successCallback, tmpObjMetadata);
            } else {
                var tableArray = result["Metadata"]["tables"];
                kony.sdk.ObjectServiceUtil.cacheMetadata(serviceName, tableArray);
                var tmpMetadata = kony.sdk.ObjectServiceUtil.getCachedMetadata(serviceName);
                kony.sdk.verifyAndCallClosure(successCallback, tmpMetadata);
            }
        }

        function invokeFailureCallback(error){
            kony.sdk.logsdk.error("### OnlineObjectService::_getMetadataForObjectOrService::invokeFailureCallback Error:" , error);
            kony.sdk.verifyAndCallClosure(failureCallback,error);
        }

        invokeObjectOperation(url, svcid, headers,null, kony.sdk.constants.HTTP_METHOD_GET , invokeSuccessCallback,invokeFailureCallback, checkAndFetchNetworkProviderOptions(options));
    }

}

function checkAndFetchNetworkProviderOptions(options){
    var providerOptions = {};
    //Fetching httpRequestOptions
    if(options && options["httpRequestOptions"] && options["httpRequestOptions"] instanceof Object){
        providerOptions["httpRequestOptions"] = options["httpRequestOptions"];
    }
    //Fetching XMLHttpRequestOptions
    if(options && options["xmlHttpRequestOptions"] && options["xmlHttpRequestOptions"] instanceof Object){
        providerOptions["xmlHttpRequestOptions"] = options["xmlHttpRequestOptions"];
    }
    return providerOptions;
}

//Method is used to send http request for ObjectService operations
function invokeObjectOperation(url, svcid, headers, formData, httpMethod, successCallback, failureCallback, networkProviderOptions) {
    kony.sdk.logsdk.trace("Entering invokeObjectOperation");

    var networkProvider = new konyNetworkProvider();
    var reportingData = kony.sdk.getEncodedReportingParamsForSvcid(svcid);

    var defaultHeaders = {};
    if(!httpMethod) {
        //default http method is post
        httpMethod = "POST";
    }

    if (!kony.sdk.skipAnonymousCall){
        // Check to find if the service is public or not, in case of public service no token is required.
        defaultHeaders[kony.sdk.constants.KONY_AUTHORIZATION_HEADER] =  konyRef.currentClaimToken;
    }

    defaultHeaders[kony.sdk.constants.HTTP_REQUEST_HEADER_ACCEPT] = kony.sdk.constants.CONTENT_TYPE_JSON;
    defaultHeaders[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_JSON;

    var deviceId = kony.sdk.getDeviceId();
    if(!kony.sdk.isNullOrUndefined(deviceId)) {
        defaultHeaders[kony.sdk.constants.DEVICEID_HEADER] = deviceId;
    }

    if(reportingData != null && reportingData != undefined) {
        try {
            defaultHeaders[kony.sdk.constants.REPORTING_HEADER] = reportingData;
        }catch(error) {
            kony.sdk.logsdk.error("### invokeObjectOperation::error while parsing metrics payload" + error);
        }
    }
    // if the user has defined his own headers, use them
    if (headers) {
        var tempHeader = "";
        for (var header in headers) {
            if (kony.sdk.constants.HTTP_REQUEST_HEADER_ACCEPT.toLowerCase() === header.toLowerCase()) {
                //Accept can be multiple
                //Reason being client can be programmed to accept more than one type of content from server.
                tempHeader = kony.sdk.constants.HTTP_REQUEST_HEADER_ACCEPT;
                if (defaultHeaders[tempHeader].toLowerCase() !== headers[header].toLowerCase()) {
                    defaultHeaders[header] = defaultHeaders[tempHeader] + "," + headers[header];
                }
            } else if (kony.sdk.constants.KONY_AUTHORIZATION_HEADER.toLowerCase() === header.toLowerCase()) {
                tempHeader = kony.sdk.constants.KONY_AUTHORIZATION_HEADER;
                if (defaultHeaders[tempHeader] !== headers[header]) {
                    defaultHeaders[tempHeader] = headers[header];
                }
            } else if ("content-type" === header.toLowerCase()) {
                tempHeader = kony.sdk.constants.HTTP_CONTENT_HEADER;
                //Content-type can and should be a single value.
                //Reason being client can only send a single kind of content at a single instance
                if (defaultHeaders[tempHeader].toLowerCase() !== headers[header].toLowerCase()) {
                    defaultHeaders[tempHeader] = headers[header];
                }
            } else {
                if (defaultHeaders[header] !== headers[header]) {
                    defaultHeaders[header] = headers[header];
                }
            }
        }
    }

    function networksuccess(res) {
        kony.sdk.logsdk.trace("Entering networksuccess");
        kony.sdk.verifyAndCallClosure(successCallback, res);
    }

    function networkerror(xhr, status, err) {
        kony.sdk.logsdk.trace("Entering networkerror");
        if (xhr && !(status && err)) {
            err = xhr;
        }
        if(err[kony.sdk.constants.MF_CODE]){
            var konyRef = kony.sdk.getCurrentInstance();
            //clear the cache if the error code related to session/token expiry
            if (kony.sdk.isSessionOrTokenExpired(err[kony.sdk.constants.MF_CODE])) {
                kony.sdk.logsdk.warn("###ObjectService::invokeObjectOperationFailure  Session/Token expired. Authenticate and Try again");
                //kony.sdk.resetCacheKeys(konyRef);
            }
        }
        kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getObjectServiceErrObj(err));
    }

    if (httpMethod === "GET") {
        networkProvider.get(url, null, defaultHeaders, networksuccess, networkerror, "formdata", networkProviderOptions);
    } else {
        networkProvider.post(url, formData, defaultHeaders,	networksuccess,	networkerror, "formdata", networkProviderOptions);
    }
}
kony.sdk.util = kony.sdk.util || {};
kony.sdk.ObjectServiceUtil = kony.sdk.ObjectServiceUtil || {};
kony.sdk.dto = kony.sdk.dto || {};

kony.sdk.constants.DateTimeType = {
    TODAY: "TODAY",
    YESTERDAY: "YESTERDAY",
    TOMORROW: "TOMORROW",
    CURRENTWEEK: "CURRENTWEEK",
    LASTWEEK: "LASTWEEK",
    NEXTWEEK: "NEXTWEEK",
    CURRENTMONTH: "CURRENTMONTH",
    LASTMONTH: "LASTMONTH",
    NEXTMONTH: "NEXTMONTH"
};

kony.sdk.constants.Aggregation = {
    NONE: "",
    COUNT: "COUNT",
    SUM: "SUM",
    MAX: "MAX",
    MIN: "MIN",
    AVG: "AVG"
};

kony.sdk.constants.OrderType = {
    ASCENDING: "ASC",
    DESCENDING: "DESC"
};

kony.sdk.constants.MatchType = {
    EQUALS: {
        value: "=",
        name: "EQUALS"
    },
    GREATER: {
        value: ">",
        name: "GREATER"
    },
    GREATEREQUAL: {
        value: ">=",
        name: "GREATEREQUAL"
    },
    LESS: {
        value: "<",
        name: "LESS"
    },
    LESSEQUAL: {
        value: "<=",
        name: "LESSEQUAL"
    },
    STARTSWITH: {
        value: "LIKE",
        name: "STARTSWITH"
    },
    CONTAINS: {
        value: "LIKE",
        name: "CONTAINS"
    },
    LIKE: {
        value: "LIKE",
        name: "LIKE"
    },
    ENDSWITH: {
        value: "LIKE",
        name: "ENDSWITH"
    },
    NOTEQUAL: {
        value: "<>",
        name: "NOTEQUAL"
    },
    ISNULL: {
        value: "IS NULL",
        name: "ISNULL"
    },
    ISNOTNULL: {
        value: "IS NOT NULL",
        name: "ISNOTNULL"
    }
};

kony.sdk.constants.JoinType = {
    INNER: "INNER",
    LEFT: "LEFT",
    RIGHT: "RIGHT"

};

kony.sdk.constants.Operator = {
    AND: "AND",
    OR: "OR"
};

kony.sdk.constants.ObjectServiceConstants = {

    DATAOBJECT: "dataObject",
    QUERYPARAMS: "queryParams"
};

/**
 * This is a utility function used to check whether the two strings provided
 * would match with each other.
 * @param string1
 * @param string2
 * @return boolean
 */
kony.sdk.util.matchIgnoreCase = function (string1, string2) {
    if (string1 === null || string2 === null || string1 === undefined
        || string2 === undefined) {
        return false;
    }
    return (string1.toUpperCase() === string2.toUpperCase());
};

kony.sdk.util.isNull = function (val) {
    if (val === null || val === undefined)
        return true;
    val = val + "";
    return (kony.sdk.util.matchIgnoreCase(val, "null"));
};

kony.sdk.util.isValidNumberType = function (val) {
    if (kony.sdk.util.matchIgnoreCase(typeof val, "number"))
        return true;
    else if (kony.sdk.util.matchIgnoreCase(typeof val, "string")
        && null != kony.sdk.util.toNumber(val))
        return true;
    else
        return false;

};

kony.sdk.util.toNumber = function (arg) {
    if (arguments.length != 1) {
        throw new Error("Invalid argument to kony.sdk.util.toNumber");
    }
    if (typeof (arg) === "number") {
        return arg;
    } else if (typeof (arg) === "string") {
        var str = arg.replace(/^\s*/, '').replace(/\s*$/, '');
        if (str === '') {
            return null;
        } else {
            var num = str - 0;
            return (isNaN(num) ? null : num);
        }
    } else {
        return null;
    }
};

kony.sdk.util.validateCriteriaObject = function (criteria) {
    if (criteria !== null && criteria !== undefined) {
        return (criteria instanceof kony.sdk.dto.Criteria || criteria instanceof kony.sdk.dto.Match
            || criteria instanceof kony.sdk.dto.Between
            || criteria instanceof kony.sdk.dto.LogicGroup || criteria instanceof kony.sdk.dto.And
            || criteria instanceof kony.sdk.dto.Or || criteria instanceof kony.sdk.dto.Not
            || criteria instanceof kony.sdk.dto.Expression
            || criteria instanceof kony.sdk.dto.InCriteria || criteria instanceof kony.sdk.dto.Exists
            || criteria instanceof kony.sdk.dto.Join);
    } else {
        return false;
    }
};

kony.sdk.ObjectServiceUtil.cacheMetadata = function (serviceName, objects) {
    if (objects !== undefined && objects !== null) {
        kony.sdk.dataStore.removeItem(serviceName);
        for (var i = 0; i < objects.length; i++) {
            var object = objects[i];
            //clearing the existing metadata of service and updating it with the latest metadata
            kony.sdk.ObjectServiceUtil.cacheObjectMetadata(serviceName, object);
        }
    }
};

kony.sdk.ObjectServiceUtil.cacheObjectMetadata = function (serviceName, object) {
    if (object !== undefined && object !== null) {
        //getting metadata of servicename
        var metadataOfAllObjs = kony.sdk.dataStore.getItem(serviceName);
        var jsonObject = JSON.parse('{}');
        //if metadata available get it
        if (metadataOfAllObjs !== null && metadataOfAllObjs !== undefined && metadataOfAllObjs !== "{}") {
            jsonObject = JSON.parse(metadataOfAllObjs);
        }
        //adding metadata of object to the existing metadata
        jsonObject[object.name] = object;
        var jsonStr = JSON.stringify(jsonObject);
        kony.sdk.dataStore.setItem(serviceName, jsonStr);
    }
};

kony.sdk.ObjectServiceUtil.getCachedMetadata = function (serviceName) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.ObjectServiceUtil.getCachedMetadata");

    var appMetadata = kony.sdk.util.getPackagedMetadata();
    if(appMetadata != null && appMetadata != undefined){
        if(serviceName != undefined && serviceName != null)
            return appMetadata[serviceName];
    }
    else{
        //reading metadata from the store
        var jsonObject = null;
        var metadataOfAllObjs = kony.sdk.dataStore.getItem(serviceName);
        if (metadataOfAllObjs !== null && metadataOfAllObjs !== undefined && metadataOfAllObjs !== "{}") {
            jsonObject = JSON.parse(metadataOfAllObjs);
        }
        return jsonObject;
    }
    return null;
};

kony.sdk.ObjectServiceUtil.getCachedObjectMetadata = function (serviceName, objectName) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.ObjectServiceUtil.getCachedObjectMetadata");
    var objectMetadata;
    if (objectName !== undefined && objectName !== null) {
        var metadataOfAllObjs = kony.sdk.ObjectServiceUtil.getCachedMetadata(serviceName);
        var jsonObject = null;
        if (metadataOfAllObjs !== null && metadataOfAllObjs !== undefined && metadataOfAllObjs !== "{}") {
            jsonObject = metadataOfAllObjs;
            //getting the object's metadata from the stored metadata
            objectMetadata = jsonObject[objectName];
        }
    }
    return objectMetadata;
};

/**
 * An object used to perform CRUD operations on objects
 * @param objectName
 * @param record
 * @constructor
 */
kony.sdk.dto.DataObject = function (objectName, record) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.dto.DataObject");
    this.objectName = objectName;
    if (record != null && record != undefined) {
        this.record = record;
    } else {
        this.record = {};
    }

    this.odataUrl = null;
    this.selectQueryObject = null;
    this.offlineObjectsOptions = {};

    this.setOfflineObjectsOptions = function(offlineObjectsOptions) {
        this.offlineObjectsOptions = offlineObjectsOptions;
    };

    this.getOfflineObjectsOptions = function() {
        return this.offlineObjectsOptions;
    };

    /**
     * This function is used to add fields and their values to the dataobject
     * @param fieldName
     * @param value
     */
    this.addField = function (fieldName, value) {
        this.record[fieldName] = value;
    };

    /**
     * This function is used to set a map of records to the dataobject
     * @param fieldValuesMap
     */
    this.setRecord = function (fieldValuesMap) {
        this.record = fieldValuesMap;
    };

    /**
     * This function is used to get the map of records present in the DataObject
     * @returns {JSON} record
     */
    this.getRecord = function () {
        return this.record;
    };

    /**
     * This function is used to add a child Dataobject into the data object
     * @param  childDataObject {@link kony.sdk.dto.DataObject}
     */
    this.addChildDataObject = function (childDataObject) {
        if (this.record[childDataObject.objectName] == null || this.record[childDataObject.objectName] == undefined) {
            this.record[childDataObject.objectName] = [];
        }
        this.record[childDataObject.objectName].push(childDataObject.getRecord());
    };

    /**
     * This function is used to set the odata url to query
     * @param odataUrl
     */
    this.setOdataUrl = function (odataUrl) {
        this.odataUrl = odataUrl;
    };

    /**
     * This function is used to get the odata url to query
     * @returns {null}
     */
    this.getOdataUrl = function () {
        return this.odataUrl;
    };

    /**
     * This function is used to set a SelectQueryObject {@link kony.sdk.dto.SelectQuery}
     * @param selectQueryObject {@link kony.sdk.dto.SelectQuery}
     */
    this.setSelectQueryObject = function (selectQueryObject) {
        this.selectQueryObject = selectQueryObject;
    };

    /**
     * This function is used to get a SelectQueryObject {@link kony.sdk.dto.SelectQuery}
     * @returns selectQueryObject {@link kony.sdk.dto.SelectQuery}
     */
    this.getSelectQueryObject = function () {
        return this.selectQueryObject;
    };

    /**
     * This function is used to get the object name
     * @returns objectName {string}
     */
    this.getObjectName = function () {
        return this.objectName;
    };
};

/**
 * This object is used to define a record object used in Offline CRUD
 * @constructor
 */
kony.sdk.dto.RecordObject = function () {
    kony.sdk.logsdk.trace("Entering into kony.sdk.dto.RecordObject");
    this.tableName = "";
    this.columnValues = {};
    this.childRecords = [];
};

kony.sdk.util.getSyncDbName = function () {
    return kony.sync.getDBName();
};


kony.sdk.util.getPrimarykeysFromMetadata = function (objMetadata) {
    var tmpSrcAttributes = null;
    if (objMetadata.primaryKey != null && objMetadata.primaryKey != undefined && objMetadata.primaryKey.length > 0) {
        tmpSrcAttributes = {};
        var pkLen = objMetadata.primaryKey.length;
        for (var indx = 0; indx < pkLen; indx++) {
            var pKey = objMetadata.primaryKey[indx];
            //adding primarykey column names in srcattributes which will be useful while deleting children
            tmpSrcAttributes[pKey] = pKey;
        }
    }
    return tmpSrcAttributes;
};


/**
 * This is a replaceAll utility function
 * @param string
 * @param toReplace
 * @param replaceWith
 * @return String temp
 */
kony.sdk.util.replaceAll = function (string, toReplace, replaceWith) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.util.replaceAll");
    var temp = string;
    var index = temp.indexOf(toReplace);
    while (index != -1) {
        temp = temp.replace(toReplace, replaceWith);
        index = temp.indexOf(toReplace);
    }
    return temp;
};

kony.sdk.util.validateDateTypeInput = function (dateType) {
    return (kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.TODAY)
        || kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.TOMORROW)
        || kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.YESTERDAY)
        || kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.CURRENTWEEK)
        || kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.NEXTWEEK)
        || kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.LASTWEEK)
        || kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.CURRENTMONTH)
        || kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.NEXTMONTH)
        || kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.LASTMONTH));
};

kony.sdk.util.getDateRange = function (dateType) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.util.getDateRange");
    var result = [];
    var currentDate = new Date();
    var formattedDate = new Date(currentDate.getFullYear(), currentDate
            .getMonth(), currentDate.getDate(), currentDate.getHours(),
        currentDate.getMinutes(), currentDate.getSeconds(), currentDate
            .getMilliseconds());
    var start;
    var end;
    if (kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.TODAY)) {
        end = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 23, 59, 59);
        start = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 0, 0, 0);
    } else if (kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.TOMORROW)) {
        formattedDate.setDate(formattedDate.getDate() + 1);
        end = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 23, 59, 59);
        start = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 0, 0, 0);
    } else if (kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.YESTERDAY)) {
        formattedDate.setDate(formattedDate.getDate() - 1);
        end = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 23, 59, 59);
        start = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 0, 0, 0);
    } else if (kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.CURRENTWEEK)) {
        var firstDayofWeek = formattedDate.getDate() - formattedDate.getDay();
        var lastDayofWeek = firstDayofWeek + 6;
        formattedDate.setDate(firstDayofWeek);
        start = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 0, 0, 0);
        formattedDate.setDate(lastDayofWeek);
        end = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 23, 59, 59);
    } else if (kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.LASTWEEK)) {
        formattedDate.setDate(formattedDate.getDate() - 7);
        var firstDayofWeek = formattedDate.getDate() - formattedDate.getDay();
        var lastDayofWeek = firstDayofWeek + 6;
        formattedDate.setDate(firstDayofWeek);
        start = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 0, 0, 0);
        formattedDate.setDate(lastDayofWeek);
        end = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 23, 59, 59);
    } else if (kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.NEXTWEEK)) {
        formattedDate.setDate(formattedDate.getDate() + 7);
        var firstDayofWeek = formattedDate.getDate() - formattedDate.getDay();
        var lastDayofWeek = firstDayofWeek + 6;
        formattedDate.setDate(firstDayofWeek);
        start = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 0, 0, 0);
        formattedDate.setDate(lastDayofWeek);
        end = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            formattedDate.getDate(), 23, 59, 59);
    } else if (kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.CURRENTMONTH)) {
        start = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            1, 0, 0, 0);
        end = new Date(formattedDate.getFullYear(),
            formattedDate.getMonth() + 1, 0, 23, 59, 59);
    } else if (kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.LASTMONTH)) {
        start = new Date(formattedDate.getFullYear(),
            formattedDate.getMonth() - 1, 1, 0, 0, 0, 0);
        end = new Date(formattedDate.getFullYear(), formattedDate.getMonth(),
            0, 23, 59, 59, 999);
    } else if (kony.sdk.util.matchIgnoreCase(dateType, kony.sdk.constants.DateTimeType.NEXTMONTH)) {
        start = new Date(formattedDate.getFullYear(),
            formattedDate.getMonth() + 1, 1, 0, 0, 0, 0);
        end = new Date(formattedDate.getFullYear(),
            formattedDate.getMonth() + 2, 0, 23, 59, 59, 999);
    } else {
        start = 0;
        end = 0;
    }
    result.push(start);
    result.push(end);
    return result;
};

//Helps to prepare the primary condition to get binary data
kony.sdk.util.getPkTableForBinary = function (objMetadata, columnValues, failureCallback) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.util.getPkTableForBinary");
    var pkTable = {};
    var whereClause = [];
    if (!kony.sdk.isNullOrUndefined(objMetadata.primaryKey)) {
        for (var indx = 0; indx < objMetadata.primaryKey.length; indx++) {
            var pKey = objMetadata.primaryKey[indx];
            var pKeyValue = columnValues[pKey];
            if (kony.sdk.isNullOrUndefined(pKeyValue)) {
                kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
                return;
            }
            pkTable[pKey] = pKeyValue;
        }
        return pkTable;
    } else {
        kony.sdk.verifyAndCallClosure(failureCallback, kony.sdk.error.getClientErrObj(kony.sdk.errorcodes.primarykey_unavailable,kony.sdk.errormessages.primarykey_unavailable));
    }
};

//Helps to provide the Metadata of column in a Object
kony.sdk.util.getMetadataOfColumn = function (objMetadata, colName) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.util.getMetadataOfColumn");
    if (objMetadata != null && objMetadata != undefined) {
        var columns = objMetadata["columns"];
        if (columns != null && columns != undefined) {
            for (var indx in columns) {
                var colMeta = columns[indx];
                if (colMeta["name"] == colName) {
                    return colMeta;
                }
            }
        }
    }
    return null;
};

//Helps in generating kony.sdk.dto.RecordObject from a given complex record
kony.sdk.util.populateColumnValues = function (record, childRecords) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.util.populateColumnValues");
    var columnValues = {};
    var recordsLength = Object.keys(record).length;
    for (var index = 0; index < recordsLength; index++) {
        var colName = Object.keys(record)[index];
        var colVal = record[colName];
        if (colVal instanceof Array) {
            for (var tempIndex = 0; tempIndex < colVal.length; tempIndex++) {
                var tempRecord = new kony.sdk.dto.RecordObject();
                tempRecord.tableName = colName;
                tempRecord.columnValues = kony.sdk.util.populateColumnValues(record[colName][tempIndex], tempRecord.childRecords);
                childRecords.push(tempRecord);
            }
        } else {
            columnValues[colName] = colVal;
        }
    }
    return columnValues;
};

//Helps in getting the relationship data of an entity from a given relationship list
kony.sdk.util.getRelationOfEntity = function (relationshipList, entityName) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.util.getRelationOfEntity");
    var i = 0;
    for (; i < relationshipList.length; i++) {
        //considering only OneToMany relationships as it will have parent and child hierarchy
        if (relationshipList[i] != null && relationshipList[i]["relationshipType"] == "OneToMany" && relationshipList[i].relatedEntity.localeCompare(entityName) == 0) {
            return relationshipList[i];
        }
    }
    return null;
};

//Helps in finding if a given column name is a primary key
kony.sdk.util.isPrimaryKey = function (primaryKeyList, columnValue) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.util.isPrimaryKey");
    for (var i = 0; i < primaryKeyList.length; i++) {
        if (primaryKeyList[i] == columnValue)
            return true;
    }
    return false;
};

kony.sdk.util.objectToQueryParams  = function(valueObject){
    kony.sdk.logsdk.trace("Entering into kony.sdk.util.objectToQueryParams ");
    var queryParams = "";
    if(!kony.sdk.isNullOrUndefined(valueObject) && valueObject instanceof Object && Object.keys(valueObject).length > 0) {
        var objCount = Object.keys(valueObject).length;
        for (var i = 0; i < objCount; i++) {
            var tempKey = Object.keys(valueObject)[i];
            if (queryParams.length === 0)
                queryParams = encodeURIComponent(tempKey) + "=" + encodeURIComponent(valueObject[tempKey]);
            else
                queryParams = queryParams + "&" + encodeURIComponent(tempKey) + "=" + encodeURIComponent(valueObject[tempKey]);
        }
    }

    return queryParams;
};

kony.sdk.util.getPackagedMetadata = function(){
    kony.sdk.logsdk.trace("Entering into   kony.sdk.util.getPackagedMetadata");
    if(kony.sdk.APP_META === undefined || kony.sdk.APP_META === null){
        kony.sdk.APP_META = {};
    }
    return kony.sdk.APP_META["objectsvc_meta"];
};

/**
 User needs to call this API to prepackage the metadata of the app. The data needs to be passed as json object or a stringified version of json object
 */
kony.sdk.util.setPackagedMetadata = function(metadataJson){
    kony.sdk.logsdk.trace("Entering into   kony.sdk.util.setPackagedMetadata");
    try{
        if(typeof metadataJson == "object"){
            kony.sdk.APP_META = metadataJson;
        }
        else if(typeof metadataJson == "string"){
            var parsedMetadata = JSON.parse(metadataJson);
            kony.sdk.APP_META = parsedMetadata;
        }
    }catch(error) {
        kony.sdk.logsdk.error("### kony.sdk.setPackagedMetadata::error while validating the input packaged metadata" , error);
    }
};


stripTrailingCharacter = function(str, character) {
    kony.sdk.logsdk.trace("Entering into stripTrailingCharacter");
    if (str.substr(str.length - 1) === character) {
        return str.substr(0, str.length - 1);
    }
    return str;
};

kony.sdk.setLogLevelFromServerResponse = function(responseHeaders){
    kony.sdk.logsdk.trace("Entering into kony.sdk.setLogLevelFromServerResponse");
    var sdkRef = kony.sdk.getCurrentInstance();
	if(responseHeaders && responseHeaders[kony.logger.deviceLogLevelHeader]){
		logLevel = responseHeaders[kony.logger.deviceLogLevelHeader].toUpperCase();
		if(!logLevel.localeCompare(kony.logger.logLevel.NONE.code) && kony.logger.currentLogLevel !== kony.logger.logLevel.NONE)
			kony.logger.currentLogLevel = kony.logger.logLevel.NONE;
		else if(!logLevel.localeCompare(kony.logger.logLevel.FATAL.code) && kony.logger.currentLogLevel !== kony.logger.logLevel.FATAL)
			kony.logger.currentLogLevel = kony.logger.logLevel.FATAL;
		else if(!logLevel.localeCompare(kony.logger.logLevel.ERROR.code) && kony.logger.currentLogLevel !== kony.logger.logLevel.ERROR)
			kony.logger.currentLogLevel = kony.logger.logLevel.ERROR;
		else if(!logLevel.localeCompare(kony.logger.logLevel.WARN.code) && kony.logger.currentLogLevel !== kony.logger.logLevel.WARN)
			kony.logger.currentLogLevel = kony.logger.logLevel.WARN;
        else if(!logLevel.localeCompare(kony.logger.logLevel.PERF.code) && kony.logger.currentLogLevel !== kony.logger.logLevel.PERF)
			kony.logger.currentLogLevel = kony.logger.logLevel.PERF;
		else if(!logLevel.localeCompare(kony.logger.logLevel.INFO.code) && kony.logger.currentLogLevel !== kony.logger.logLevel.INFO)
			kony.logger.currentLogLevel = kony.logger.logLevel.INFO;
		else if(!logLevel.localeCompare(kony.logger.logLevel.DEBUG.code) && kony.logger.currentLogLevel !== kony.logger.logLevel.DEBUG)
			kony.logger.currentLogLevel = kony.logger.logLevel.DEBUG;
		else if(!logLevel.localeCompare(kony.logger.logLevel.TRACE.code) && kony.logger.currentLogLevel !== kony.logger.logLevel.TRACE)
			kony.logger.currentLogLevel = kony.logger.logLevel.TRACE;
		else if(!logLevel.localeCompare(kony.logger.logLevel.ALL.code) && kony.logger.currentLogLevel !== kony.logger.logLevel.ALL)
			kony.logger.currentLogLevel = kony.logger.logLevel.ALL;
		else if(!logLevel.localeCompare('OFF'))
		{
			kony.logger.deactivatePersistors(kony.logger.networkPersistor);
			kony.logger.currentLogLevel = kony.logger.logLevel.NONE;
			sdkRef.removeGlobalRequestParam(kony.logger.deviceLogLevelHeader,sdkRef.globalRequestParamType.headers);
			return;
		}
		else {
            return;
        }
        sdkRef.setGlobalRequestParam(kony.logger.deviceLogLevelHeader,logLevel,sdkRef.globalRequestParamType.headers);
        kony.logger.activatePersistors(kony.logger.networkPersistor);
    }
};


kony.sdk.prototype.enableDebug = function() {
    kony.sdk.logsdk.trace("Entering into kony.sdk.prototype.enableDebug");
    kony.sdk.isDebugEnabled = true;
};

kony.sdk.prototype.disableDebug = function() {
    kony.sdk.logsdk.trace("Entering into kony.sdk.prototype.disableDebug");
    kony.sdk.isDebugEnabled = false;
};

function Exception(name, message) {
    kony.sdk.logsdk.error("Exception --> " + name + ": " + message);
    return {
        code: name,
        message: message
    };
}

kony.sdk.verifyAndCallClosure = function(closure, params) {
    if (typeof(closure) === 'function') {
        closure(params);
    } else {
        kony.sdk.logsdk.warn("invalid callback",JSON.stringify(closure));
    }
};

kony.sdk.overrideUserId = function(userId){
    kony.sdk.logsdk.trace("Entering into kony.sdk.overrideUserId");
    if(kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE && typeof(kony.setUserID) === 'function') {
        kony.setUserID(userId,true);
    }else{
        konyRef.setCurrentUserId(userId);
    }
};

kony.sdk.formatCurrentDate = function(inputDateString) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.formatCurrentDate");
    var dateObj = new Date(inputDateString);
    var year = dateObj.getUTCFullYear();
    var month = kony.sdk.formatDateComponent(dateObj.getUTCMonth() + 1);
    var date = kony.sdk.formatDateComponent(dateObj.getUTCDate());
    var hours = kony.sdk.formatDateComponent(dateObj.getUTCHours());
    var minutes = kony.sdk.formatDateComponent(dateObj.getUTCMinutes());
    var seconds = kony.sdk.formatDateComponent(dateObj.getUTCSeconds());
    var dateSeparator = "-";
    var timeSeparator = ":";
    var dateString = year + dateSeparator + month + dateSeparator + date + " " + hours + timeSeparator + minutes + timeSeparator + seconds;
    return dateString;
};

kony.sdk.formatDateComponent = function(dateComponent) {
    kony.sdk.logsdk.trace("Entering into kony.sdk.formatDateComponent");
    if (dateComponent < 10) {
        dateComponent = "0" + dateComponent;
    }
    return dateComponent;
};

kony.sdk.isNullOrUndefined = function(val) {
    if (val === null || val === undefined) {
        return true;
    } else {
        return false;
    }
};

kony.sdk.constants.reportingType = {
    session: "session",
    custom: "custom"
};

kony.sdk.isEmptyObject = function(obj) {
    if(typeof(obj) === "boolean"
		|| typeof(obj) === "number"){
        return false;
    }
    else if(typeof(obj) === "string"){
        return obj.trim().length === 0;
    }
    for (var prop in obj) {
        return false;
    }
    return true;
};


kony.sdk.isArray = function(data) {
    if (data && Object.prototype.toString.call(data) === '[object Array]') {
        return true;
    }
    return false;
};


kony.sdk.formatSuccessResponse = function(data)
{
    if(data && data.httpresponse)
    {
        delete data.httpresponse;
    }
    return data;
};

kony.sdk.isJson = function(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

kony.sdk.util.getString = function (val) {

    if (!kony.sdk.isNullOrUndefined(val) && (val.toString()).toLocaleLowerCase() !== "null") {
        return val.toString();
    }
    return "";
};

//private method to identify whether session/token expired or not based on error code
kony.sdk.isSessionOrTokenExpired = function(mfcode) {
    if (mfcode && (mfcode === "Auth-5" || mfcode === "Auth-6" || mfcode === "Gateway-31" || mfcode === "Gateway-33" || mfcode === "Gateway-35" || mfcode === "Gateway-36" || mfcode === "Auth-46" || mfcode === "Auth-55")) {
        return true;
    }
    return false;
};

//private method to clear cache
kony.sdk.resetProviderKeys = function(konyRef, _providerName) {
    try {
        if (konyRef) {
            if (_providerName) {
                if (konyRef.tokens.hasOwnProperty(_providerName)) {
                    konyRef.tokens[_providerName] = null;
                }
            }
        }
    } catch(e) {
        kony.sdk.logsdk.error("Error while clearing the cache..");
    }
};

//private method to clear cache
kony.sdk.resetCurrentKeys = function(konyRef, _providerName) {
    try {
        if (konyRef) {
            konyRef.currentClaimToken = null;
            konyRef.currentBackEndToken = null;
            konyRef.claimTokenExpiry = null;
            konyRef.currentRefreshToken = null;
            //setting the anonymous provider as true to access the public protected urls without any issue
            konyRef.isAnonymousProvider = true;
            if (_providerName) {
                if (konyRef.tokens.hasOwnProperty(_providerName)) {
                    konyRef.tokens[_providerName] = null;
                }
            }
        }
    } catch(e) {
        kony.sdk.logsdk.error("Error while clearing the cache..");
    }
};

kony.sdk.util.populateIndividualServiceLists = function(serviceConfig,objectToPopulate){
    kony.sdk.logsdk.trace("Entering into kony.sdk.util.populateIndividualServiceLists");
    var svcMeta = serviceConfig["services_meta"];
    if(kony.sdk.isNullOrUndefined(objectToPopulate["objectsvc"])) {
        objectToPopulate["objectsvc"] = {};
    }
    if(kony.sdk.isNullOrUndefined(objectToPopulate["offlineObjectsvc"])) {
        objectToPopulate["offlineObjectsvc"] = {};
    }
    if(svcMeta){
        for(var svc in svcMeta){
            if(svcMeta.hasOwnProperty(svc)) {
                var svcObj = svcMeta[svc];
                if (svcObj && svcObj["type"] === "objectsvc") {
                    if (!kony.sdk.isNullOrUndefined(svcObj["offline"])) {
                        if (svcObj["offline"] === false) {
                            objectToPopulate["objectsvc"][svc] = svcObj;
                        } else if (svcObj["offline"] === true) {
                            objectToPopulate["offlineObjectsvc"][svc] = svcObj;
                        }
                    } else {
                        objectToPopulate["objectsvc"][svc] = svcObj;
                        objectToPopulate["offlineObjectsvc"][svc] = svcObj;
                    }
                }
                else if (svcObj && svcObj["type"] === "integsvc") {
                    objectToPopulate["integsvc"][svc] = svcObj;
                }
            }
        }
    }
};

/**
 * Generates hash code for the URL by sha512 algorithm
 * @param url
 * @param requestParams
 * @return {*}
 */
kony.sdk.util.generateHashcodeForURL = function (url, requestParams){
    var concatenatedResult = "";
    var hashID = null;

    if (!kony.sdk.isNullOrUndefined(url))
        concatenatedResult += url;

    if (!kony.sdk.isNullOrUndefined(requestParams)){
        concatenatedResult += JSON.stringify(requestParams);
    }

    if (kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE && !kony.sdk.util.isNullOrEmptyString(concatenatedResult)){
        hashID = kony.crypto.createHash("sha512", concatenatedResult);
    }

    return hashID;
};

/**
 * Utility function to save the response in the cache.
 * @param options {object} save the response with key options["cacheID"]. If not provided then we will calculate hashcode by url and requestData.
 * @param url {string}
 * @param requestData {object}
 * @param response {object}
 */
function cacheResponseForKey(options, url, requestData, response){
    var hashCode = null;

    if (options["cacheID"])
        hashCode = options["cacheID"];
    else
        hashCode = kony.sdk.util.generateHashcodeForURL(url, requestData);

    if (hashCode){

        if (typeof (hashCode) !== "string"){
            hashCode = hashCode.toString();
        }

        var expiry = options["expiryTime"] ? options["expiryTime"] : kony.sdk.constants.DEFAULT_CACHE_EXPIRY_TIME;
        response["cacheID"] = hashCode;
        new kony.sdk.ClientCache().add(hashCode, response, expiry);
    }
}

kony.sdk.util.isNullOrEmptyString = function (val) {
    if (kony.sdk.isNullOrUndefined(val) || (typeof(val) === "string" && val.trim() === "")) {
        return true;
    }
    return false;
};

function doesMFSupportsAppversioning(){
    // In case of IDE platforms we will check the existence of appConfig.svcDoc.service_doc_etag for compatibility of app version with the MF.
    // In case of plain-js & phone gap initOptions should not be sent during init call.
    if (kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE && !kony.sdk.isNullOrUndefined(appConfig) && !kony.sdk.isNullOrUndefined(appConfig.svcDoc) && !kony.sdk.isNullOrUndefined(appConfig.svcDoc.service_doc_etag)){
        return true;
    }
    else if (kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_PLAIN_JS || kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_PHONEGAP){
        return true;
    }
    else{
        return false;
    }
}

function populateHeaderWithFabricAppVersion(headers){
    if (doesMFSupportsAppversioning() && !kony.sdk.isNullOrUndefined(headers) && !kony.sdk.isNullOrUndefined(kony.sdk.getFabricAppVersion())){
        headers[kony.sdk.constants.APP_VERSION_HEADER] = kony.sdk.getFabricAppVersion();
    }
}

/*
* Utility method to check whether options has browserWidget or not
* @return true if it supports
* */
kony.sdk.util.hasBrowserWidget =  function(options){
    return options && options[kony.sdk.constants.BROWSER_WIDGET] && kony.sdk.util.type(options[kony.sdk.constants.BROWSER_WIDGET]) === "kony.ui.Browser";
};

/*
* Utility method to check whether binary is supported
* @return true if it supports
* */
kony.sdk.util.isBinarySupported = function () {
    return kony.sdk.getSdkType() === kony.sdk.constants.SDK_TYPE_IDE && kony.sdk.getAType() === kony.sdk.constants.SDK_ATYPE_NATIVE;
};

/*
** Intializing SSO FFI's with null implementation
*  Supporting platforms like IDE has sso_handler which has implementation.
*/
kony.sdk.util.saveSSOToken = function(){

    kony.sdk.logsdk.warn("kony.sdk.util.saveSSOToken:: SSO is not supported.");
    return null;
};

kony.sdk.util.getSSOToken = function(){

    kony.sdk.logsdk.warn("kony.sdk.util.getSSOToken:: SSO is not supported.");
    return null;
};

kony.sdk.util.deleteSSOToken = function(){

    kony.sdk.logsdk.warn("kony.sdk.util.deleteSSOToken:: SSO is not supported.");
    return null;
};

kony.sdk.util.initializeSSO = function(){
  // STUB code returns nothing
};

/*
** Utility method to clone any object
*  @return cloned object
*/
kony.sdk.cloneObject = function(obj){
    var clonedObject;
    try{
        clonedObject = JSON.parse(JSON.stringify(obj));
    }catch(err){
        kony.sdk.logsdk.error("cloning object failed, reverting back to copy");
        clonedObject = obj;
    }
    return clonedObject;
};

/**
 * Utility method to check if a given variable is JSON Object
 * @param obj
 * @returns {boolean}
 */
kony.sdk.util.isJsonObject = function(obj){
    if(obj === null || obj === undefined){
        return false;
    }

    return obj.constructor === {}.constructor;
};

/**
 * Utility method to check whether the given variable is a valid string
 * @param str
 * @returns {boolean}
 */
kony.sdk.util.isValidString = function(str){
    if(str === null || str === undefined || str.constructor !== "".constructor){
        return false;
    }

    return str.trim() !== ""
};

/**
 * Utility method to convert JSON object keys to lower case
 * @param obj {Object} - JSON object
 * @returns convertedJSON {Object} - JSON object keys in lower case and values assigned to respective keys.
 */
kony.sdk.util.convertJsonKeysToLowerCase = function (obj) {
    var convertedJSON = {};
    if (!kony.sdk.util.isJsonObject(obj)) {
        return obj;
    }
    var keys = Object.keys(obj);
    for (var i = 0; i < keys.length; i++) {
        convertedJSON[keys[i].toLowerCase()] = obj[keys[i]];
    }
    return convertedJSON;
};

/**
 * Utility method to get JSON property case-insensitively
 * @param {Object} jsonObject
 * @param {String} key
 * @returns {*}
 */
kony.sdk.util.getValueForKeyAndIgnoreCase = function (jsonObject, key) {
    var keysInJSON = Object.keys(jsonObject);
    var index = 0;
    for (var jsonKey in keysInJSON) {
        if (keysInJSON[jsonKey].toLocaleLowerCase() === key.toLocaleLowerCase()) {
            return Object.values(jsonObject)[index];
        } else {
            index++
        }
    }

    return null;
};

/**
 * Utility method to populate JSON Template
 * @param {String} template
 * @param {Object} templateParams : Input Params provided by the User
 * @return Object containing processed template and missing variables
 */
kony.sdk.util.populateTemplate = function (template, templateParams) {

    if (kony.sdk.util.isNullOrEmptyString(template) || !kony.sdk.util.isJsonObject(templateParams)) {
        kony.sdk.logsdk.error(kony.sdk.errorConstants.populating_template_failed + " " + kony.sdk.errormessages.populating_template_failed);
        return null;
    }

    var DOLLAR_VARIABLE_PATTERN = /(\${)+(\w.*?)+(})/g;
    var templateVariables = [];
    var missingVariables = [];
    var resultSet = {};
    var populatedTemplate = kony.sdk.cloneObject(template);

    var inputTemplateVariables = populatedTemplate.match(DOLLAR_VARIABLE_PATTERN);
    //Match returns Array of all the matches.
    //Iterating over the array and extracting all template variables.
    for (var iteratorVariable in inputTemplateVariables) {
        var inputVariable = inputTemplateVariables[iteratorVariable].toString();
        var templateParameter = inputVariable.slice(2, (inputVariable.length) - 1);
        templateVariables.push(templateParameter);
    }

    //Populating the template with user inputs.
    for (var iterateVariable = 0; iterateVariable < templateVariables.length; iterateVariable++) {
        var inputParameter = templateVariables[iterateVariable];
        if (templateParams.hasOwnProperty(inputParameter)) {
            populatedTemplate = populatedTemplate.replace("${" + inputParameter + "}", templateParams[inputParameter]);
        }
        else {
            missingVariables.push(inputParameter);
        }
    }

    resultSet[kony.sdk.constants.PROCESSED_TEMPLATE] = populatedTemplate;
    resultSet[kony.sdk.constants.MISSING_VARIABLES] = missingVariables;

    return resultSet;
};

/**
 * Checks if the browser is IE11
 * @returns {boolean}
 */
kony.sdk.util.checkForIE11 = function () {
    //Checking if this is being run in DesktopWeb
    if (typeof(XMLHttpRequest) !== 'undefined') {
        var ua = window.navigator.userAgent;
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10) === 11;
        }
    }
    return false;
};

/**
 * Utility method to get persistToken flag from data store
 *
 * @returns {boolean}
 */
kony.sdk.util.isPersistentLoginResponseEnabled = function() {
    var dataStore = new konyDataStore();
    var persistTokenFlag = dataStore.getItem("persistLoginResponseFlag");
    if(!kony.sdk.isNullOrUndefined(persistTokenFlag) && persistTokenFlag === true) {
        return true;
    }
    return false;
}

/**
 * Based on interactive or non-interactive session info from license, returning session type
 * @return {string}
 */
kony.sdk.util.getSessionType = function(){
    var sessionType;
    if(kony.licensevar && kony.licensevar.isInteractive != undefined) {
        sessionType = kony.licensevar.isInteractive ? kony.sdk.constants.APP_SESSION_INTERACTIVE :
            kony.sdk.constants.APP_SESSION_NON_INTERACTIVE;
    } else {
        /**
         *In case of phonegap and plain js, we are sending interacting session.
         */
        kony.sdk.logsdk.trace("Updating interacting session in kony reporting params by default");
        sessionType = kony.sdk.constants.APP_SESSION_INTERACTIVE;
    }
    return sessionType;
};

/**
 * Utility method to get kony reporting params in encoded string
 * @return {string}
 */
kony.sdk.getEncodedReportingParamsForSvcid = function(svcid) {
    var reportingData = kony.sdk.getPayload(konyRef);
    reportingData.rsid = kony.sdk.currentInstance.getSessionId();
    if(svcid) {
        reportingData.svcid = svcid;
    } else {
        kony.sdk.logsdk.warn("### kony.sdk.getEncodedReportingParamsForSvcid:: svcid is either null or undefined");
    }
    return encodeURI(JSON.stringify(reportingData));
};

kony.sdk.serviceDoc = function() {
	kony.sdk.logsdk.trace("Entering into kony.sdk.serviceDoc");
	var appId = "";
	var baseId = "";
	var services_meta = {};
	var name = "";
	var selflink = "";
	var login = null;
	var integsvc = {};
	var reportingsvc = {};
	var messagingsvc = {};
	var sync = {};
	var objectsvc = {};
	var logicsvc = {};

	this.toJSON = function() {
		servConfig = {};
		servConfig.appId = this.getAppId();
		servConfig.baseId = this.getBaseId();
		servConfig.name = this.getAppName();
		servConfig.selflink = this.getSelfLink();
		servConfig.services_meta = this.getServicesMeta();
		servConfig.login = this.getAuthServices();
		servConfig.integsvc = this.getIntegrationServices();
		servConfig.messagingsvc = this.getMessagingServices();
		servConfig.sync = this.getSyncServices();
		servConfig.reportingsvc = this.getReportingServices();
		servConfig.objectsvc = this.getObjectServices();
		servConfig.logicsvc = this.getLogicServices();
		kony.sdk.util.populateIndividualServiceLists(this,servConfig);
		return servConfig;
	}

	this.setAppId = function(appIdStr) {
		appId = appIdStr;
	};

	this.getAppId = function() {
		return appId;
	};

	this.setBaseId = function(baseIdStr) {
		baseId = baseIdStr;
	};

	this.getBaseId = function() {
		return baseId;
	};

	this.setAppName = function(appName) {
		name = appName;
	};

	this.getAppName = function() {
		return name;
	};

	this.setSelfLink = function(selfLinkStr) {
		selflink = selfLinkStr;
	};

	this.getSelfLink = function() {
		return selflink;
	};

	function setEndPoints(providerType, providerValues) {
		for (var provider in providerValues) {
			providerType[provider] = providerValues[provider];
		}
	}

	this.setAuthService = function(loginProvider) {
		if(login === null){
			login = [];
		}
		login.push(loginProvider);
	};

	//what will this return? name?
	this.getAuthServiceByName = function(authServiceProvider) {
		if(login === null){
			return null;
		}
		for (var i in login) {
			var provider = login[i];
			if (provider.prov == authServiceProvider) {
				return provider;
			}
		}
	};

	this.getAuthServices = function() {
		return login;
	};

	this.setIntegrationService = function(providerName, endPointUrl) {
		integsvc[providerName] = endPointUrl;
	};

	this.getIntegrationServiceByName = function(integrationServiceProviderName) {
		return integsvc[integrationServiceProviderName];
	};

	this.getIntegrationServices = function() {
		return integsvc;
	};

	this.setObjectService = function(providerName, endPointUrl) {
		objectsvc[providerName] = endPointUrl;
	};

	this.getObjectServiceByName = function(objectServiceProviderName) {
		return objectsvc[objectServiceProviderName];
	};

	this.getObjectServices = function() {
		return objectsvc;
	};

	this.getLogicServices = function() {
		return logicsvc;
	};

	this.getServicesMeta = function() {
		return services_meta;
	};

	this.setReportingService = function(reportingType, url) {
		if (reportingType == kony.sdk.constants.reportingType.session || reportingType == kony.sdk.constants.reportingType.custom) {
			reportingsvc[reportingType] = url;
		} else {
			throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, "invalid reporting type " + reportingType);
		}
	}

	this.getReportingServiceByType = function(reportingServiceProviderType) {
		return reportingsvc[reportingServiceProviderType];
	};

	this.getReportingServices = function() {
		return reportingsvc;
	};

	this.setMessagingService = function(appId, url) {
		messagingsvc[appId] = url;
	};

	this.getMessagingServiceByName = function(messagingServiceProviderName) {
		return messagingsvc[messagingServiceProviderName];
	};

	this.getMessagingServices = function() {
		return messagingsvc;
	}

	this.setSyncService = function(syncServiceProvider) {
		sync = syncServiceProvider;
	};

	this.getSyncServices = function() {
		return sync;
	};

};

kony.logger = kony.logger || {};

kony.logger = {

    // Logger constants

    networkPersistorUrlEndpoint: "deviceLogs",

    deviceLogLevelHeader: "X-KONY-DEVICE-LOG-LEVEL",

    filePersistor: 1,

    consolePersistor: 2,

    networkPersistor: 4,

    // Log Level Block which gives all the handle for setting and getting

    //ALL(0) < TRACE(1) < DEBUG(2) < INFO(4) < PEF(8) < WARN(16) < ERROR(32) < FATAL(64) < NONE(127)
    logLevel: {
        NONE: {
            value: 127,
            name: "none",
            code: "NONE"
        },
        FATAL: {
            value: 64,
            name: "fatal",
            code: "FATAL"
        },
        ERROR: {
            value: 32,
            name: "error",
            code: "ERROR"
        },
        WARN: {
            value: 16,
            name: "warn",
            code: "WARN"
        },
        PERF: {
            value: 8,
            name: "perf",
            code: "PERF"
        },
        INFO: {
            value: 4,
            name: "info",
            code: "INFO"
        },
        DEBUG: {
            value: 2,
            name: "debug",
            code: "DEBUG"
        },
        TRACE: {
            value: 1,
            name: "trace",
            code: "TRACE"
        },
        ALL: {
            value: 0,
            name: "all",
            code: "ALL"
        }
    },



    get currentLogLevel() {
        if (typeof(currentLevel) === 'undefined')
            currentLevel = kony.logger.logLevel.NONE;
        if (kony.logger.isNativeLoggerAvailable()) {
            var logLevelValue = KonyLogger.getLogLevel();
            for (var key in kony.logger.logLevel) {
                if (kony.logger.logLevel.hasOwnProperty(key)) {
                    if (kony.logger.logLevel[key].value == logLevelValue) {
                        currentLevel = kony.logger.logLevel[key];
                        break;
                    }
                }
            }
        }
        return currentLevel;
    },

    set currentLogLevel(level) {
        currentLevel = level;
        if (kony.logger.isNativeLoggerAvailable())
            KonyLogger.setLogLevel(currentLevel.value);
    },

    isNativeLoggerAvailable: function() {
        if (typeof(KonyLogger) === 'undefined')
            return false;
        else
            return true;
    },


    flush: function() {
        if (kony.logger.isNativeLoggerAvailable())
            KonyLogger.flush();
    },

    // Persister block for activating and deactivating

    activatePersistors: function(activatedList) {
        if (kony.logger.isNativeLoggerAvailable())
            KonyLogger.activatePersistors(activatedList);
    },
    deactivatePersistors: function(deactivatedList) {
        if (kony.logger.isNativeLoggerAvailable())
            KonyLogger.deactivatePersistors(deactivatedList);
    },

    //setting claims token after referesh
    setClaimsToken: function() {
        var token = kony.sdk.getCurrentInstance().currentClaimToken;
        if (kony.logger.isNativeLoggerAvailable())
            KonyLogger.setClaimsToken(token);
    },

    setConfig: function(loggerConfig) {
        if (kony.logger.isNativeLoggerAvailable()) {
            KonyLogger.setConfig(loggerConfig.getLoggerConfig());
        }
    },

    setPersistorConfig: function(persistor) {
        if (kony.logger.isNativeLoggerAvailable()) {
            KonyLogger.setPersistorConfig(persistor.getPersistorConfig());
        }
    },


    createLoggerObject: function(loggerName, loggerConfig) {
        var loggerObj = {};
        loggerObj.config = parseConfig(loggerConfig);


        loggerObj.trace = function(msg, params) {
            logMessage(loggerObj, kony.logger.logLevel.TRACE, msg, params);
        };
        loggerObj.debug = function(msg, params) {
            logMessage(loggerObj, kony.logger.logLevel.DEBUG, msg, params);
        };
        loggerObj.info = function(msg, params) {
            logMessage(loggerObj, kony.logger.logLevel.INFO, msg, params);
        };
        loggerObj.perf = function(msg, params) {
            logMessage(loggerObj, kony.logger.logLevel.PERF, msg, params);
        };
        loggerObj.warn = function(msg, params) {
            logMessage(loggerObj, kony.logger.logLevel.WARN, msg, params);
        };
        loggerObj.error = function(msg, params) {
            logMessage(loggerObj, kony.logger.logLevel.ERROR, msg, params);
        };
        loggerObj.fatal = function(msg, params) {
            logMessage(loggerObj, kony.logger.logLevel.FATAL, msg, params);
        };

        var indirectionLevel = 0;

        loggerObj.setIndirectionLevel = function(_indirectionLevel) {
            indirectionLevel = _indirectionLevel;
        }
        loggerObj.getIndirectionLevel = function() {
            return indirectionLevel;
        }

        loggerObj.loggerName = loggerName;

        return loggerObj;

    },

    createLoggerConfig: function() {
        var formatC = {};
        var logFilterC = {};
        var accConfig = {};
        var overrideConfig = null;
        var persistorList = [];

        var config = {
            //formatterConfig
            //timeformat
            set timeFormat(val) {
                formatC.timeFormat = val;
            },
            //timeZone
            set timeZone(val) {
                formatC.timeZone = val;
            },

            //FilterConfig
            //logLevel
            set logLevel(val) {
                logFilterC.logLevel = val;
            },

            //accumulatorConfig
            //bytesLimit
            set bytesLimit(val) {
                accConfig.bytesLimit = val;
            },
            //statementsLimit
            set statementsLimit(val) {
                accConfig.statementsLimit = val;
            },

            //overrideConfig
            set overrideConfig(val) {
                overrideConfig = val;
            },

            //peristorList
            get persistorList() {
                return persistorList;
            },
            addPersistor: function(val) {
                persistorList.push(val.getPersistorConfig());
            },

            getLoggerConfig: function() {
                var loggerConfig = {};
                if (Object.keys(formatC).length > 0) loggerConfig.formatterConfig = formatC;
                if (Object.keys(logFilterC).length > 0) loggerConfig.logFilterConfig = logFilterC;
                if (Object.keys(accConfig).length > 0) loggerConfig.accumulatorConfig = accConfig;
                if (overrideConfig !== null) loggerConfig.overrideConfig = overrideConfig;
				loggerConfig.persistors = persistorList;
                return loggerConfig;
            }
        };
        return config;
    },

    createFilePersistor: function() {
        var prop = {};
        var persistorProperties = {
            //Persistor properites
            get persistorType() {
                return kony.logger.filePersistor;
            },
            //maxNumberOfLogFiles
            set maxNumberOfLogFiles(val) {
                prop.maxNumberOfLogFiles = val;
            },
            //maxFileSize
            set maxFileSize(val) {
                prop.maxFileSize = val;
            },

            getPersistorConfig: function() {
                var perConfig = {};
                perConfig.type = this.persistorType;
                if (Object.keys(prop).length > 0) perConfig.properties = prop;
                return perConfig;
            }
        };
        return persistorProperties;
    },
    createNetworkPersistor: function() {
        var prop = {};
        var persistorProperties = {
            //persistorType
            get persistorType() {
                return kony.logger.networkPersistor;
            },
            //URL
            set URL(val) {
                prop.URL = val;
            },
            getPersistorConfig: function() {
                var perConfig = {};
                perConfig.type = this.persistorType;
                if (Object.keys(prop).length > 0) perConfig.properties = prop;
                return perConfig;
            }
        };
        return persistorProperties;
    },

    appLoggerInitialisation: function() {
        var loggerObj = {};
        loggerObj = new kony.logger.createNewLogger(kony.sdk.constants.APP_LOGGER_NAME, null);
        return loggerObj;
    },

    isValidJSTable : function (inputTable){
        if (kony.sdk.isNullOrUndefined(inputTable)) {
            return false;
        }
        if (typeof inputTable === "object" || typeof inputTable === "Object" || typeof inputTable === "Array"|| typeof inputTable === "array") {
            return true;
        } else {
            return false;
        }
    }
};
kony.logger = kony.logger || {};

kony.logger.createNewLogger = function(loggerName, loggerConfig) {
	
	parseConfig = function(loggerConfig) {
        return loggerConfig;
    };

   logMessage = function(loggerObj,logLevel, msg, params) {
        parseMessage = function(logLevel, msg, params) {
            params = (typeof(params) === "undefined") ? "" : params;

            //Stringify object
            if (kony.logger.isValidJSTable(params)) {
                params = JSON.stringify(params, null, " ");
            }
            
            if (logLevel.value >= kony.logger.currentLogLevel.value) {
                var date = new Date().toLocaleDateString();
                var time = new Date().toLocaleTimeString();
                var level = logLevel.code;

                var formattedMessage = "["+loggerObj.loggerName+"][" + level + "][" + date + "][" + time + "] : " + msg +" "+ params;
                console.log(formattedMessage);
            }
        };
        parseMessage(logLevel, msg, params);
    };

    //Exposed object and it's methods
    var loggerObj =  kony.logger.createLoggerObject(loggerName, loggerConfig);
    return loggerObj;
}
kony.logger["appLogger"] = kony.logger.appLoggerInitialisation();
/**
 * MFSDK
 * Created by KH2204.
 * Copyright © 2018 Kony. All rights reserved.
 */

/**
 * Method to create the integration service instance with the provided service name.
 * @param {string} serviceName - Name of the service
 * @returns {IntegrationService} Integration service instance
 */
kony.sdk.prototype.getIntegrationService = function (serviceName) {
    if (!kony.sdk.isInitialized) {
        throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, kony.sdk.constants.INIT_FAILURE_MESSAGE + "integration service :" + serviceName);
    }

    var konyRef = kony.sdk.getCurrentInstance();
    if (!kony.sdk.skipAnonymousCall && !this.currentClaimToken && !konyRef.isAnonymousProvider) {
        throw new Exception(kony.sdk.errorConstants.AUTH_FAILURE, "Valid claims token is not found, login using identity service before performing an operation on this integration service :" + serviceName);
    }

    if (this.integsvc != null) {
        if (this.integsvc[serviceName] != null) {
            kony.sdk.logsdk.debug("found integration service" + this.integsvc[serviceName]);
            return new IntegrationService(this, serviceName);
        }
    }
    throw new Exception(kony.sdk.errorConstants.INTEGRATION_FAILURE, "Integration service is not found or invalid :" + serviceName);
};

/**
 * Method should not be called by developer.
 * @class
 * @classdesc Integration service instance for invoking the integration services.
 */

function IntegrationService(konyRef, serviceName) {
    var serviceUrl = "";
    var svcObj = konyRef.integsvc[serviceName];

    if (typeof(svcObj) === "object") {
        serviceUrl = svcObj["url"];
    } else {
        serviceUrl = svcObj;
    }

    var networkProvider = new konyNetworkProvider();
    if (kony.sdk.util.isNullOrEmptyString(serviceName) || kony.sdk.util.isNullOrEmptyString(serviceUrl)) {
        throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, "Invalid serviceUrl and serviceName");
    }
    serviceUrl = stripTrailingCharacter(serviceUrl, "/");

    this.getUrl = function () {
        return serviceUrl;
    };

    /**
     * Integration service success callback method.
     * @callback integrationSuccessCallback
     * @param {json} response - Integration service response
     */

    /**
     * Integration service failure callback method.
     * @callback integrationFailureCallback
     * @param {json} error - Error information
     */
    /**
     * invoke the specified operation
     * @param {string} operationName - Name of the operation
     * @param {object} headers - Input headers for the operation
     * @param {object} data - Input data for the operation
     * @param {integrationSuccessCallback} successCallback  - Callback method on success
     * @param {integrationFailureCallback} failureCallback - Callback method on failure
     * @param {object} options - XMLHttpRequest options like withCredentials value.
     */

    this.invokeOperation = function (operationName, headers, data, successCallback, failureCallback, options) {
        function invokeOperationHandler() {
            _invokeOperation(operationName, headers, data, true, successCallback, failureCallback, options);
        }

        if (kony.sdk.skipAnonymousCall) {
            invokeOperationHandler();
        } else {
            kony.sdk.claimsAndProviderTokenRefresh(invokeOperationHandler, failureCallback);
        }
    };

    function invokeOperationRetry(operationName, headers, data, successCallback, failureCallback, options) {
        function invokeOperationRetryHandler() {
            _invokeOperation(operationName, headers, data, false, successCallback, failureCallback, options);
        }

        if (kony.sdk.skipAnonymousCall) {
            invokeOperationRetryHandler();
        } else {
            kony.sdk.logsdk.debug("### IntegrationService::retryServiceCall received 401 from fabric, trying to refresh backend token");
            kony.sdk.claimsRefresh(invokeOperationRetryHandler, failureCallback);
        }
    }

    function retryServiceCall(errorResponse) {
        if (errorResponse[kony.sdk.constants.MF_CODE]) {
            // check for the mfcode for which,
            // retry should be done.
        } else {
            if (errorResponse[kony.sdk.constants.HTTP_STATUS_CODE] && errorResponse[kony.sdk.constants.HTTP_STATUS_CODE] === 401) {
                return true;
            }
        }
    }

    function _invokeOperation(operationName, headers, data, isRetryNeeded, successCallback, failureCallback, options) {
        var requestData = kony.sdk.getPayload(konyRef);
        requestData.svcid = operationName;

        var sessionID = kony.sdk.dataStore.getItem(kony.sdk.constants.KONYUUID);
        if (!kony.sdk.isNullOrUndefined(sessionID)) {
            requestData.rsid = sessionID;
        } else {
            kony.sdk.logsdk.warn("sessionId  is either empty,null or undefined");
        }

        var dataToSend = {};
        if (kony.sdk.metric) {
            if (kony.sdk.metric.reportEventBufferBackupArray.length === 0) {
                kony.sdk.metric.readFromDS();
            }
            kony.sdk.metric.pushEventsToBufferArray();
            requestData.events = kony.sdk.metric.reportEventBufferBackupArray;
        }
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                dataToSend[key] = data[key];
            }
        }

        var defaultHeaders = {};
        defaultHeaders[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_FORM_URL_ENCODED;
        defaultHeaders["X-Kony-ReportingParams"] = JSON.stringify(requestData);

        if (!kony.sdk.skipAnonymousCall) {
            // Check to find if the service is public or not, in case of public service no token is required.
            var token = konyRef.currentClaimToken;
            if (!token) {
                token = kony.sdk.getCurrentInstance().currentClaimToken;
            }
            defaultHeaders[kony.sdk.constants.KONY_AUTHORIZATION_HEADER] = token;
        }

        var deviceId = kony.sdk.getDeviceId();
        if (!kony.sdk.isNullOrUndefined(deviceId)) {
            defaultHeaders["X-Kony-DeviceId"] = deviceId;
        }

        if (typeof(svcObj) === 'object' && svcObj.version) {
            defaultHeaders["X-Kony-API-Version"] = svcObj.version;
        }
        // if the user has defined his own headers, use them
        if (!kony.sdk.isNullOrUndefined(headers)) {
            if ((Object.keys(headers)).length !== 0 && typeof(headers) === "object") {
                var defaultKeys = Object.keys(defaultHeaders);
                var lowerCaseHeaders = defaultKeys.map(function (x) {
                    return x.toLowerCase()
                });
                for (var header in headers) {
                    var headerConst = header;
                    if (lowerCaseHeaders.indexOf(headerConst.toLowerCase()) !== -1) {
                        for (var i = 0; i < defaultKeys.length; i++) {
                            var tempKey = defaultKeys[i];
                            if (tempKey.toLowerCase() === headerConst.toLowerCase()) {
                                defaultHeaders[tempKey] = headers[header];
                            }
                        }
                    } else {
                        defaultHeaders[header] = headers[header];
                    }
                }
            }
        }

        // If useCache is enabled and cacheID is present then network call will be skipped and cached response will be returned.
        if (options && options["useCache"] && options["cacheID"]) {
            var cacheResponse = new kony.sdk.ClientCache().get(options["cacheID"]);
            if (cacheResponse) {
                kony.sdk.logsdk.debug("Key found in hash, returning cached response.");
                kony.sdk.verifyAndCallClosure(successCallback, cacheResponse);
                return;
            }
        }

        function networkSuccessCallback(res) {
            if (kony.sdk.metric) {
                kony.sdk.metric.clearBufferEvents();
            }
            // If useCache is enabled then the response is cached and returned.
            if (options && options["useCache"]) {
                cacheResponseForKey(options, serviceUrl + "/" + operationName, requestData, res);
            }
            kony.sdk.verifyAndCallClosure(successCallback, res);
        }

        function networkFailureCallback(xhr, status, err) {
            if (xhr && !(status && err)) {
                err = xhr;
            }
            if (isRetryNeeded === true && retryServiceCall(err) === true) {
                kony.sdk.logsdk.debug("errorCallback, retrying the operation: " + operationName);
                invokeOperationRetry(operationName, headers, data, successCallback, failureCallback);
                return;
            }
            kony.sdk.processIntegrationErrorResponse(err, true, failureCallback);
        }

        networkProvider.post(serviceUrl + "/" + operationName,
            dataToSend, defaultHeaders, networkSuccessCallback,
            networkFailureCallback, null,options);
    }

    kony.sdk.processIntegrationErrorResponse = function (err, isAsync, callBack) {
        if (kony.sdk.metric) {
            if (kony.sdk.metric.errorCodeMap[err.opstatus]) {
                kony.sdk.metric.saveInDS();
            }
        }
        if (err[kony.sdk.constants.MF_CODE]) {
            //clear the cache if the error code related to session/token expiry
            if (kony.sdk.isSessionOrTokenExpired(err[kony.sdk.constants.MF_CODE])) {
                kony.sdk.logsdk.info("###IntegrationService::invokeOperationFailure  Session/Token expired. Authenticate and Try again");
                //TODO: Start a conversation with Suhas and Krishna regarding the scenario wherein one auth session expired and other is still valid.
            }
        }
        if (!isAsync) {
            return kony.sdk.error.getIntegrationErrObj(err);
        }
        else if (callBack) {
            kony.sdk.verifyAndCallClosure(callBack, kony.sdk.error.getIntegrationErrObj(err));
        }
    };
}
function OAuthHandler(serviceUrl, providerName, appkey, callback, type, options, isMFVersionCompatible) {
    var _window = window;
	var _popup = null;
    var noPopup = false;
    var requestUrl;
    if(options && options.hasOwnProperty("noPopup")){
        noPopup = true;
    }
    var appSecret;
    if(options && options.hasOwnProperty("appSecret")){
        appSecret = options["appSecret"]
    }
    var serviceDoc;
    if(options && options.hasOwnProperty("serviceDoc")){
        serviceDoc = options["serviceDoc"]
    }
    var customQueryParamsForOAuth;
    if(options && options["customQueryParamsForOAuth"]){
        customQueryParamsForOAuth = kony.sdk.util.objectToQueryParams(options["customQueryParamsForOAuth"]);
    }
    var urlType = "/" + type + "/";

    if (noPopup && isMFVersionCompatible){
        //Saving the required data in session storage, will be used to validate the identity service once after deeplink is redirected.
        sessionStorage.appkey = appkey;
        sessionStorage.appSecret = appSecret;
        sessionStorage.serviceDoc = JSON.stringify(serviceDoc);
        sessionStorage.providerName = providerName;
        sessionStorage.urlType = type;

        if (options && options["include_profile"])
            sessionStorage.include_profile = options["include_profile"];
    }

	var _listener = function(event) {
		var _contents = event.data;
        /**
         MFSDK-3431 - Recieving post message event from other endpoints.
         This is a short term fix. Currently Identity sends us only string in post message event, later on they have to
         send json with some more keys giving us the knowledge of source
         */
        if(kony.sdk.util.isValidString(_contents) && !kony.sdk.isJson(_contents)) {
            _popup.close();
            _detachEvent();
            try {
                kony.sdk.logsdk.debug("### OAuthHandler::_listener received authorization code as " + _contents);
                var headers = {};
                if (type === "oauth2" || type === "saml") {
                    headers[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_FORM_URL_ENCODED
                }
                callback(urlType + "token", {
                    code: _contents
                }, headers);
            } catch (err) {
                kony.sdk.logsdk.error("exception ::" + err);
                failureCallback();
            }
        }else if(kony.sdk.isJson(_contents) || kony.sdk.util.isJsonObject(_contents)) {
            kony.sdk.logsdk.debug("### OAuthHandler::_listener received event.data in unknown format as " + JSON.stringify(_contents));
            //TODO - After Identity changes check for desired key in the json.
        }
	};
	var _attachEvent = function() {
		if (_window.addEventListener) {
			_window.addEventListener('message', _listener, false);
		} else if (_window.attachEvent) {
			_window.attachEvent('message', _listener);
		} else {
			throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, "environment doesnt support event attatching");
		}
	};

	var _detachEvent = function() {
		if (_window.detachEvent) {
			_window.detachEvent('message', _listener);
		} else if (_window.removeEventListener) {
			_window.removeEventListener('message', _listener);
		} else {
			throw new Exception(kony.sdk.errorConstants.INIT_FAILURE, "environment doesnt support event attatching");
		}
	};

    requestUrl = serviceUrl + urlType + "login?provider=" + providerName + "&appkey=" + appkey;

    if (options && options["success_url"] && isMFVersionCompatible)
        requestUrl += "&success_url="+options["success_url"];

    if (!kony.sdk.isNullOrUndefined(kony.sdk.getFabricAppVersion())){
        requestUrl += "&app_version="+kony.sdk.getFabricAppVersion();
    }

    if(!kony.sdk.util.isNullOrEmptyString(customQueryParamsForOAuth)){
        requestUrl = requestUrl + "&" + customQueryParamsForOAuth;
    }

	if (noPopup && isMFVersionCompatible){
	    //No popup will be shown in case of oauth2 flow, if noPopup is enabled.
		// Redirection will happen to success_url or the default one specified in the mf console.
        _window.open(requestUrl, "_self");
    }else {
        _attachEvent();
        _popup = _window.open(requestUrl);
    }
}

/**
 * Handles the deeplink callback, this needs to be called once deep link redirection is done.
 * @param {object} queryparams parameters from Identity service - "code": HashValue
 * @param {function} successCallBack  - Callback method on success
 * @param {function} failureCallBack - Callback method on failure
 */
function handleDeeplinkCallback(queryparams, successCallBack, failureCallBack){
    if (queryparams && kony.sdk.constants.DEEPLINK_VALID_PARAM in queryparams){
        if (sessionStorage.appkey && sessionStorage.appSecret && sessionStorage.serviceDoc){
            var konyClient = new kony.sdk();
            var loginOptions = {};
            loginOptions[kony.sdk.constants.DEEPLINK_VALID_PARAM] = queryparams["code"];
            loginOptions["urlType"] = sessionStorage.urlType;

            if (sessionStorage.getItem("include_profile"))
                loginOptions["include_profile"] = sessionStorage.include_profile;

            konyClient.initWithServiceDoc(sessionStorage.appkey, sessionStorage.appSecret, JSON.parse(sessionStorage.serviceDoc));
            var authClient = konyClient.getIdentityService(sessionStorage.providerName);
            authClient.login(loginOptions,
                function(response) {
                    successCallBack(response);
                }, function(error) {
                    failureCallBack(error);
                }
            );
        }
        else{
            failureCallBack({"Result": "Required parameters appkey, appSecret, serviceDoc or urlType not found in sessionStorage"});
        }
    }else{
        failureCallBack({"Result": "Required parameter code is not found the query params."});
    }
}
function konyLogger() {
	this.log = function(text) {
		if (kony.sdk.isDebugEnabled) {
			console.log(text);
		}
	}
}

function setLogLevelCallClosure(res, status, xhr, callback){
	kony.sdk.setLogLevelFromServerResponse(xhr.getAllResponseHeaders());
	callback(res);
}


function konyNetworkProvider() {
	
	var konyRef = konyRef || kony.sdk.getCurrentInstance();
	/**
	 * GET Request
	 * @param url
	 * @param data
	 * @param headers
	 * @param successCallback
	 * @param failureCallback
	 * @private
	 */
	this.get = function(url, data, headers, successCallback, failureCallback, options) {

		if (headers == undefined || headers == null) {
			headers = {};
		}
		var isContentTypeAvailable = false;
		if(headers !== null && headers !== 'undefined'){
				for (var header in headers) {
                            if(header.toLowerCase() === kony.sdk.constants.HTTP_CONTENT_HEADER.toLowerCase())
                        		isContentTypeAvailable = true
                        }
                        if (!isContentTypeAvailable)
                            headers[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_JSON;

		}
        if (data && typeof(data) !== "string") {
			data = JSON.stringify(data);
		}
        //Appending global params
		if(!kony.sdk.isNullOrUndefined(konyRef)) {
			url = konyRef.appendGlobalParams(url,headers,data);
		}

        headers[kony.sdk.constants.HTTP_REQUEST_HEADER_ACCEPT] = kony.sdk.constants.CONTENT_TYPE_JSON;
        var contentType = headers[kony.sdk.constants.HTTP_CONTENT_HEADER];
        konyXMLHttpRequest(url, data, headers,
            kony.sdk.constants.HTTP_METHOD_GET, contentType,
            function (res) {
                kony.sdk.verifyAndCallClosure(successCallback, res);
            }, function (err) {
                kony.sdk.verifyAndCallClosure(failureCallback, err);
            }, options);
	};

    /**
	 * POST Request
     * @param url
     * @param data
     * @param headers
     * @param successCallback
     * @param failureCallback
     * @param konyContentType
     * @param options
     */
    this.post = function(url, data, headers, successCallback, failureCallback,konyContentType, options) {
		if (headers == undefined || headers == null) {
			headers = {};
		}

		var isContentTypeAvailable = false;
		if(headers !== null && headers !== 'undefined'){
                for (var header in headers) {
                     if(header.toLowerCase() === kony.sdk.constants.HTTP_CONTENT_HEADER.toLowerCase())
                        isContentTypeAvailable = true
                }
                 if (!isContentTypeAvailable)
                     headers[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_JSON;
        }
        //Appending global params
		if(!kony.sdk.isNullOrUndefined(konyRef)) {
		    if(kony.sdk.isNullOrUndefined(data))
		        data = {};
			url = konyRef.appendGlobalParams(url,headers,data);
		}

        if('X-Kony-ReportingParams' in headers) {
            var parms = headers['X-Kony-ReportingParams'];
            var currp = decodeURI(parms);
            var curobj = JSON.parse(currp);
            curobj.passthrough = headers['X-Kony-Passthrough'];
            headers['X-Kony-ReportingParams'] = encodeURI(JSON.stringify(curobj));
        }
        delete headers['X-Kony-Passthrough'];

		konyXMLHttpRequest(url, data, headers, 
							"POST", headers[kony.sdk.constants.HTTP_CONTENT_HEADER],
							successCallback, failureCallback, options);
	};

	/**
	 * DELETE Request
	 * @param url
	 * @param data
	 * @param headers
	 * @param successCallback
	 * @param failureCallback
	 * @private
	 */
	this.invokeDeleteRequest = function(url, data, headers, successCallback, failureCallback, options) {
		if (headers == undefined || headers == null) {
			headers = {};
		}

				var isContentTypeAvailable = false;
        		if(headers !== null && headers !== 'undefined'){
                    for (var header in headers) {
                         if(header.toLowerCase() === kony.sdk.constants.HTTP_CONTENT_HEADER.toLowerCase())
                            isContentTypeAvailable = true
                    }
                    if (!isContentTypeAvailable){
                        headers[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_JSON;
                        data = JSON.stringify(data);
                     }
                }

        //Appending global params
		if(!kony.sdk.isNullOrUndefined(konyRef)) {
			if(kony.sdk.isNullOrUndefined(data))
				data = {};
			url = konyRef.appendGlobalParams(url,headers,data);
		}

        var contentType = headers[kony.sdk.constants.HTTP_CONTENT_HEADER];

        konyXMLHttpRequest(url, data, headers,
            kony.sdk.constants.HTTP_METHOD_DELETE, contentType,
            function (res) {
                kony.sdk.verifyAndCallClosure(successCallback, res);
            }, function (err) {
                kony.sdk.verifyAndCallClosure(failureCallback, err);
            }, options);
	};
}

function konyXMLHttpRequest(url, params, headers, httpMethod, konyContentType, successCallback, errorCallback, options) {
	

	var paramsTable = "";
	var firstVal = true;
	var resultTable = {};
	var xmlHttpRequestOptions;
	if(options && options["xmlHttpRequestOptions"]){
		xmlHttpRequestOptions = options["xmlHttpRequestOptions"];
	}else{
		xmlHttpRequestOptions = {};
	}
	var httpRequest = new XMLHttpRequest();
	if (typeof(errorCallback) === 'undefined') {
		errorCallback = successCallback;
	}
	if (!params) {
		params = "";
	}


	//if httpmethod is not provided falling back to POST
	if (!httpMethod) {
		httpMethod = constants.HTTP_METHOD_POST;
	}

	httpRequest.onerror = function(res) {
		resultTable[kony.sdk.constants.MF_OPSTATUS] = kony.sdk.errorcodes.connectivity_error_code;
		resultTable[kony.sdk.constants.MF_ERROR_CODE] = kony.sdk.errorcodes.connectivity_error_code;
	    resultTable[kony.sdk.constants.MF_ERROR_MSG] = kony.sdk.errormessages.connectivity_error_message;
	    errorCallback(resultTable);
	};

	httpRequest.onload = function (res) {
		var isInvalidJSON=false;
		if(res){
			if(httpRequest.responseText !== "") {
                if (options && options["passthrough"]) {
                    resultTable = {};
                    resultTable.rawResponse = httpRequest.responseText;
                }
                else if (httpRequest.responseText && typeof(httpRequest.responseText) === 'string') {
                    if (kony.sdk.isJson(httpRequest.responseText)) {
                        resultTable = JSON.parse(httpRequest.responseText);
                    }
                    else {
                        isInvalidJSON = true;
                    }
                }
            }
			if(isInvalidJSON || (httpRequest.status >= 200 && httpRequest.status < 300 && !httpRequest.responseText))
			{
				resultTable={};
				resultTable.httpresponse = {};
				resultTable[kony.sdk.constants.MF_OPSTATUS]= kony.sdk.errorcodes.invalid_json_code;
				resultTable[kony.sdk.constants.MF_ERROR_MSG]= kony.sdk.errormessages.invalid_json_message;
				resultTable[kony.sdk.constants.MF_ERROR_CODE]= kony.sdk.errorcodes.invalid_json_code;
				resultTable[kony.sdk.constants.HTTP_STATUS_CODE] = httpRequest.status;
				resultTable.httpresponse["response"]= httpRequest.responseText;
				resultTable.httpresponse.headers = httpRequest.getAllResponseHeaders();
				resultTable.httpresponse.responsecode =httpRequest.status;
				resultTable.httpresponse.url= url;
				errorCallback(resultTable);
			}
			else if(httpRequest.status >= 200 && httpRequest.status < 300){
				resultTable.httpresponse = {};
				resultTable.httpresponse.headers = httpRequest.getAllResponseHeaders();
				resultTable.httpresponse.responsecode =httpRequest.status;
				resultTable.httpresponse.url= url;
				if(!resultTable.opstatus){
					resultTable.opstatus = 0;
				}
				if (resultTable[kony.sdk.constants.MF_OPSTATUS] === 0) {
					successCallback(resultTable);
				} else {
					errorCallback(resultTable);
				}

			}
			else {
				if(httpRequest.responseText){
					resultTable[kony.sdk.constants.HTTP_STATUS_CODE] = httpRequest.status;
					resultTable.httpresponse = {};
					resultTable.httpresponse.headers = httpRequest.getAllResponseHeaders();
					resultTable.httpresponse.responsecode =httpRequest.status;
					resultTable.httpresponse.url= url;
					errorCallback(resultTable);
				}
				else
				{
					resultTable[kony.sdk.constants.MF_OPSTATUS] = kony.sdk.errorcodes.connectivity_error_code;
					resultTable[kony.sdk.constants.MF_ERROR_CODE] = kony.sdk.errorcodes.connectivity_error_code;
					resultTable[kony.sdk.constants.MF_ERROR_MSG] = kony.sdk.errormessages.connectivity_error_message;
					errorCallback(resultTable);
				}
			}
		}
		else{
			resultTable[kony.sdk.constants.MF_OPSTATUS] = kony.sdk.errorcodes.unknown_error_code;
			resultTable[kony.sdk.constants.MF_ERROR_CODE] = kony.sdk.errorcodes.unknown_error_code;
			resultTable[kony.sdk.constants.MF_ERROR_MSG] = kony.sdk.errormessages.unknown_error_message;
			errorCallback(resultTable);
		}
	};

	httpRequest.ontimeout = function(res) {
		resultTable[kony.sdk.constants.MF_OPSTATUS] = kony.sdk.errorcodes.connectivity_error_code;
		resultTable[kony.sdk.constants.MF_ERROR_CODE] = kony.sdk.errorcodes.connectivity_error_code;
		resultTable[kony.sdk.constants.MF_ERROR_MSG] = kony.sdk.errormessages.connectivity_error_message;
	    errorCallback(resultTable);
	};

	httpRequest.withCredentials = xmlHttpRequestOptions["enableWithCredentials"] || false;
	//httpRequest.withCredentials = headers["withCredentials"] || false;
	httpRequest.open(httpMethod, url, true);
	if (typeof(headers) !== 'undefined' && headers !== null) {
		if (typeof(headers[kony.sdk.constants.HTTP_CONTENT_HEADER]) === 'undefined') {
			headers[kony.sdk.constants.HTTP_CONTENT_HEADER] = kony.sdk.constants.CONTENT_TYPE_JSON;
		}
		for (var header in headers) {
			httpRequest.setRequestHeader(header, headers[header]);
		}
	}

	if (params && params.httpconfig && params.httpconfig.timeout) {

		httpRequest.timeout = params.httpconfig.timeout * 1000;

	}
	if (konyContentType == undefined || konyContentType == null || konyContentType != 'formdata') {
		//preparing params for other than object services
		if (headers[kony.sdk.constants.HTTP_CONTENT_HEADER] === kony.sdk.constants.CONTENT_TYPE_FORM_URL_ENCODED || headers[kony.sdk.constants.HTTP_CONTENT_HEADER] === kony.sdk.constants.CONTENT_TYPE_JSON) {
			var paramsTable = "";
			var firstVal = true;
			for (var key in params) {
				if (!firstVal) {
					paramsTable += "&";
				}
				firstVal = false;
				if (typeof(params[key])!= "undefined") {
					if(typeof(params[key]) !== "string"){
						if(!(params[key] instanceof Array && typeof(options) != "undefined" && options != null && typeof(options["enablePreMFCompat"]) != "undefined" && options["enablePreMFCompat"] === true))
							params[key] = JSON.stringify(params[key]);
					}
					paramsTable = paramsTable + key + "=" + encodeURIComponent(params[key]);
				}
			}
			params = paramsTable;
		} else if (typeof(params) !== "string") {
			params = JSON.stringify(params);
		}
	} else if (konyContentType == "formdata"){
		//for specific requests like object services we will get formdata object
		//for object services we are getting kony.net.FormData as params so using the same.
	}
	try {
		if (params) {
			httpRequest.send(params);
		} else {
			httpRequest.send();
		}

	} catch (e) {
			kony.sdk.logsdk.error("catch -> error occurred " , JSON.stringify(e));
	}

}

function konyDataStore() {
	
	/**
	 * Sets item in the datastore.
	 * @param key key: String
	 * @param value value: String
	 * @private
	 */
	this.setItem = function(key, value) {
		if (typeof(key) !== "string" && typeof(value) !== "string") {
			throw new Exception(kony.sdk.errorConstants.DATA_STORE_EXCEPTION, "Invalid type: Keys & values must be strings");
		} else {
			localStorage.setItem(key, value);
		}
	};

	/**
	 * retrieves an item from datastore, return null if not found
	 * @param key
	 * @returns {*}
	 * @private
	 */
	this.getItem = function(key) {
		if (typeof(key) !== "string") {
			throw new Exception(kony.sdk.errorConstants.DATA_STORE_EXCEPTION, "Invalid Key: Keys must be strings");
		} else {
			var value = localStorage.getItem(key);
			if (value === null || value === undefined) {
				return null;
			} else {
				return value;
			}
		}
	};

	/**
	 * removes an item from datastore. fails silently if key not found or removing failed
	 * @param key
	 * @private
	 */
	this.removeItem = function(key) {
		if (localStorage != null) {
			if (typeof(key) !== "string") {
				throw new Exception(Error.DATA_STORE_EXCEPTION, "Invalid Key: Keys must be strings");
			} else {
				localStorage.removeItem(key);
			}
		}
	};

	/**
	 * Clears all keys from datastore
	 * @private
	 */
	this.destroy = function() {
		localStorage.clear();
	};

	/**
	 * retrieves all key,value pairs from datastore
	 * @returns {{}}
	 * @private
	 */
	this.getAllItems = function() {
		var items = {};
		var len = localStorage.length;
		for (var i = 0; i < len; i++) {
			var key = localStorage.key(i);
			var value = localStorage.getItem(key);
			items[key] = value;
		}
		return items;
	}
}

kony.sdk.getSdkType = function() {
	return kony.sdk.constants.SDK_TYPE_PLAIN_JS;
}

kony.sdk.getPlatformName = function() {
	return "browser";
}

kony.sdk.getDeviceId = function () {
    return null;
};

kony.sdk.getPayload = function(konyRef) {
	var payload = {};
	payload.ua = navigator.userAgent;
	payload.aid = konyRef.mainRef.baseId;
	payload.aname = konyRef.mainRef.name;
	payload.atype = kony.sdk.getAType();
	payload.stype = "b2c";
    payload.sdkversion = kony.sdk.version;
    payload.sdktype = kony.sdk.getSdkType();
    payload.sessiontype = kony.sdk.util.getSessionType();
	return payload;
};


kony.sdk.getAType = function() {
    return "browser";
};

kony.sdk.setLicenseCall = function(data){};
kony.sdk.saveMetadatainDs = function(appKey,appSecret,servConfig) {};
kony.sdk.deleteMetadatafromDs = function() {};
kony.sdk.httpIntegrity = {};
kony.sdk.httpIntegrity.setIntegrityCheck = function(integrityParams){};
kony.sdk.httpIntegrity.removeIntegrityCheck = function () {};
kony.sdk.initiateSession = function() {}

kony.sdk.util.getSSOTokenForProvider = function (_providerName) {

    kony.sdk.logsdk.warn("kony.sdk.util.getSSOTokenForProvider:: SSO is not supported.");
    return null;
};

kony.sdk.util.addOrUpdateSSOTokenWithProvider = function (ssoToken, _providerName) {

    kony.sdk.logsdk.warn("kony.sdk.util.addOrUpdateSSOTokenWithProvider:: SSO is not supported.");
    return null;
};

kony.sdk.util.deleteSSOTokenForProvider = function (_providerName) {

    kony.sdk.logsdk.warn("kony.sdk.util.deleteSSOTokenForProvider:: SSO is not supported.");
    return null;

};

var MFAppVersion;

kony.sdk.setFabricAppVersion = function(version){
    MFAppVersion = version;
}

/**
 * Returns the default fabric application version.
 * @return {*}
 */
kony.sdk.getFabricAppVersion = function(){
    return MFAppVersion;
}

kony.sdk.util.type = function(objectVar){
    return typeof(objectVar)
};

/**
 * kony.ds is the wrapper over konydataStore
 * kony.ds is framework namespace for ide platform which is used in multiple places in common js code.
 * Hence phonegap has to have the defination for kony.ds
 */
kony.ds = {};

kony.ds.read = function (item) {
    if(item) {
        var fetchedString = kony.sdk.dataStore.getItem(item);
        if(fetchedString == null)
		{
            kony.sdk.logsdk.warn("key not present in data store ");
            return;
		}
		else
		{
        	return fetchedString.split(",");
        }
    } else {
        kony.sdk.logsdk.warn("item to get from kony.ds.read is not defined");
    }
}

kony.ds.save = function (item, key) {
    if(item && key) {
        kony.sdk.dataStore.setItem(key, item.toString());
    } else {
        kony.sdk.logsdk.warn("key or value to set through kony.ds.save is not defined");
    }
}
